window.loadHulkManualOverride = function () {
	console.log('UCOAST MANUAL OVERRIDE FOR QUICK ADD')
	var checkout_selectors =
		"input[name='checkout']:not(.hulkapps-ignore), input[value='Checkout']:not(.hulkapps-ignore), button[name='checkout']:not(.hulkapps-ignore), [href$='checkout']:not(.hulkapps-ignore), button[value='Checkout']:not(.hulkapps-ignore), input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc'],.hulkapps_checkout"
	if ('product' == window.hulkapps.page_type) {
		var hulk_variants = window.hulkapps.product.variants
		window.hulkapps.product.selected_variant = null
		var product_price = '',
			currency_symbol = '',
			display_price_setting = ''
		window.product_page_btn_condition = function () {
			var t = []
			if (
				(document
					.querySelectorAll(
						".single-option-selector,.swatch-element input[type='radio'],.single-option-selector__radio:checked, select[data-option='option1'], select[data-option='option1']:checked, select[data-option='option2'], select[data-option='option1']:checked, select[data-option='option3'], select[data-option='option3']:checked, select[data-index='option1'], select[data-index='option1']:checked, select[data-index='option2'], select[data-index='option1']:checked, select[data-index='option3'], select[data-index='option3']:checked, ul li div[swatch-option='option1'], input[type='radio']:checked"
					)
					.forEach(function (i) {
						t.push(i.value)
					}),
				1 ==
					(t = (function (t, i) {
						for (var e = [], a = t.length, o = 0; o < a; o++) {
							var n = t[o]
							i(n) && e.push(n)
						}
						return e
					})(t, function (t) {
						return t
					})).length)
			)
				var i = t
			else var i = t.join(' / ')
			null != document.querySelector('.selected_variant span')
				? document.querySelector('.selected_variant span').textContent
				: Object.keys(hulk_variants).forEach(function (t) {
						var e = hulk_variants[t]
						;(i = i.toString().toLowerCase()),
							e.title.toString().toLowerCase().trim() == i.trim() &&
								(e.id,
								(window.hulkapps.product.selected_variant = e.id),
								(product_price = e.price),
								(window.hulkapps.product.selected_variant_price = product_price))
				  }),
				null == window.hulkapps.product.selected_variant &&
					((window.hulkapps.product.selected_variant = hulk_variants[0].id),
					(product_price = window.hulkapps.product.variants[0].price),
					(window.hulkapps.product.selected_variant_price = product_price))
		}
	}
	;(window.hulkLoadScript = function (t, i) {
		var e = document.createElement('script')
		;(e.type = 'text/javascript'),
			e.readyState
				? (e.onreadystatechange = function () {
						;('loaded' == e.readyState || 'complete' == e.readyState) &&
							((e.onreadystatechange = null), i())
				  })
				: (e.onload = function () {
						i()
				  }),
			(e.src = t),
			document.getElementsByTagName('head')[0].appendChild(e)
	}),
		(window.checkAppInstalled = function (t) {
			;(window.hulkapps.is_product_option = !0),
				hulkLoadScript(
					'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/intlTelInput.min.js',
					function () {
						commonJS(t), cartPageJS(t), productPageJS(t)
					}
				)
		}),
		(window.commonJS = function (t) {
			var i, e
			function a(t) {
				var i, e
				XMLHttpRequest.callbacks
					? XMLHttpRequest.callbacks.push(t)
					: ((XMLHttpRequest.callbacks = [t]),
					  (i = XMLHttpRequest.prototype.send),
					  (XMLHttpRequest.prototype.send = function () {
							if (XMLHttpRequest.callbacks)
								for (e = 0; e < XMLHttpRequest.callbacks.length; e++)
									XMLHttpRequest.callbacks[e](this)
							i.apply(this, arguments)
					  }))
			}
			window.getCartInfo(),
				(window.fetch = new Proxy(window.fetch, {
					apply(t, i, e) {
						let a = t.apply(i, e)
						return (
							a
								.then((t) => {
									var i = window.hulkappsParseURL(e[0]),
										a = !1
									if (
										([
											'/cart/change',
											'/cart/clear',
											'/cart/update',
											'/cart/add',
										].forEach(async function (i) {
											if (e[0] && e[0].includes(i)) {
												a = !0
												var o = await t.clone().json()
												e[0].includes('/cart/add') && (o = void 0),
													window.getCartInfo(0, o)
											}
										}),
										!a && i && i.query)
									) {
										if (
											i.query.get('section_id') &&
											i.query.get('section_id').includes('cart')
										)
											(a = !0), window.getCartInfo()
										else {
											if (
												i.query.get('view') &&
												i.query
													.get('view')
													.includes('hulkapps_cart_collections')
											)
												return
											i.query.get('view') &&
												i.path.includes('/cart') &&
												!i.path.includes('/cart.js') &&
												((a = !0), window.getCartInfo())
										}
									}
									!a && i && '/cart' === i.path && window.getCartInfo()
								})
								.catch((t) => {}),
							a
						)
					},
				})),
				a(function (t) {
					var i = !1,
						e = window.hulkappsParseURL(t._url)
					let a = ['/cart/change', '/cart/clear', '/cart/update', '/cart/add']
					var o = !1
					let n = function () {
							if (t.readyState === XMLHttpRequest.DONE) {
								if (
									((o = !0),
									a.forEach(function (e) {
										if (t._url && t._url.includes(e)) {
											i = !0
											var a = t.status
											if (0 === a || (a >= 200 && a < 400)) {
												var o = JSON.parse(t.response)
												t._url.includes('/cart/add') && (o = void 0),
													window.getCartInfo(0, o)
											}
										}
									}),
									!i && e && e.query)
								) {
									if (
										e.query.get('section_id') &&
										e.query.get('section_id').includes('cart')
									)
										(i = !0), window.getCartInfo()
									else {
										if (
											e.query.get('view') &&
											e.query
												.get('view')
												.includes('hulkapps_cart_collections')
										)
											return
										e.query.get('view') &&
											e.path.includes('/cart') &&
											!e.path.includes('/cart.js') &&
											((i = !0), window.getCartInfo())
									}
								}
								!i && e && '/cart' === e.path && window.getCartInfo()
							}
						},
						l = setInterval(function () {
							o || (n(), (o = !0)), o && clearInterval(l)
						}, 1e3)
				}),
				(i = hulkapps_jQuery),
				(Document.prototype._hulkappsAddEventListener =
					Document.prototype.addEventListener),
				(Document.prototype._hulkappsRemoveEventListener =
					Document.prototype.removeEventListener),
				(Document.prototype._hulkappsAddEventListener = function (t, i, e = !1) {
					this._hulkappsAddEventListener(t, i, e),
						this.hulkappsEventListenerList || (this.hulkappsEventListenerList = {}),
						this.hulkappsEventListenerList[t] ||
							(this.hulkappsEventListenerList[t] = []),
						this.hulkappsEventListenerList[t].push({
							type: t,
							listener: i,
							useCapture: e,
						})
				}),
				(Document.prototype._hulkappsRemoveEventListener = function (t, i, e = !1) {
					this._hulkappsRemoveEventListener(t, i, e),
						this.hulkappsEventListenerList || (this.hulkappsEventListenerList = {}),
						this.hulkappsEventListenerList[t] ||
							(this.hulkappsEventListenerList[t] = [])
					for (let a = 0; a < this.hulkappsEventListenerList[t].length; a++)
						if (
							this.hulkappsEventListenerList[t][a].listener === i &&
							this.hulkappsEventListenerList[t][a].useCapture === e
						) {
							this.hulkappsEventListenerList[t].splice(a, 1)
							break
						}
					0 == this.hulkappsEventListenerList[t].length &&
						delete this.hulkappsEventListenerList[t]
				}),
				(Document.prototype.hulkappsGetEventListeners = function (t) {
					return (this.hulkappsEventListenerList || (this.hulkappsEventListenerList = {}),
					void 0 === t)
						? this.hulkappsEventListenerList
						: this.hulkappsEventListenerList[t]
				}),
				i('body').on('click', '.edit_cart_option', function (t) {
					t.preventDefault()
					var e = i(this).data('key'),
						a = window.hulkapps.cart,
						o = window.hulkapps.store_id,
						n = i(this).data('product_id'),
						l = i(this).data('variant_id')
					i("[name^='properties']").each(function () {
						'' == i(this).val() && i(this).attr('disabled', !0)
					})
					var s = i(this)
					i.ajax({
						type: 'POST',
						url: window.hulkapps.po_url + '/api/v2/store/edit_cart_extension',
						data: {
							cart_data: a,
							item_key: e,
							store_id: o,
							variant_id: l,
							customer_tags:
								null != window.hulkapps.customer
									? window.hulkapps.customer.tags.split(',')
									: '',
							cart_collections: JSON.stringify(window.hulkapps.cart_collections),
						},
						cache: !1,
						crossDomain: !0,
						success: function (t) {
							if ('ok' == t) location.reload()
							else {
								;(window.currentEditOptionSelector = s),
									i('body').addClass('body_fixed'),
									i('#edit_cart_popup').last().html(t),
									i('.edit_popup').appendTo('body'),
									i('.edit_popup').show(),
									'undefined' != typeof jQuery && jQuery(document).off('focusin')
								let e = document.hulkappsGetEventListeners('focusin')
								if (e)
									for (let a in e)
										document.removeEventListener('focusin', e[a].listener)
								requireInventory(n, 'hulkapps_edit_product_options'),
									calc_options_total(n, 'hulkapps_edit_product_options'),
									conditional_rules(n, 'hulkapps_edit_product_options')
							}
						},
					})
				}),
				((e = hulkapps_jQuery).fn.fontselect = function (t, i) {
					var a = function (t, i) {
							return function () {
								return t.apply(i, arguments)
							}
						},
						t = t.googleFonts.split(','),
						o = {
							style: 'font-select',
							placeholder: 'Select a font',
							lookahead: 2,
							api: 'https://fonts.googleapis.com/css?family=',
						},
						n = (function () {
							function i(t, i) {
								;(this.$original = e(t)),
									(this.options = i),
									(this.active = !1),
									this.setupHtml(),
									this.getVisibleFonts(),
									this.bindEvents()
								var a = this.$original.val()
								a && (this.updateSelected(), this.addFontLink(a))
							}
							return (
								(i.prototype.bindEvents = function () {
									var t = this
									e(document).click(function (i) {
										t.active &&
											!e(i.target).parents('#fontSelect-' + t.$original.id)
												.length &&
											t.toggleDrop()
									}),
										e('li', this.$results)
											.click(a(this.selectFont, this))
											.mouseenter(a(this.activateFont, this))
											.mouseleave(a(this.deactivateFont, this)),
										e('span', this.$select).click(a(this.toggleDrop, this)),
										this.$arrow.click(a(this.toggleDrop, this))
								}),
								(i.prototype.toggleDrop = function (t) {
									this.active
										? (this.$element.removeClass('font-select-active'),
										  this.$drop.hide(),
										  clearInterval(this.visibleInterval))
										: (this.$element.addClass('font-select-active'),
										  this.$drop.show(),
										  this.moveToSelected(),
										  (this.visibleInterval = setInterval(
												a(this.getVisibleFonts, this),
												500
										  ))),
										(this.active = !this.active)
								}),
								(i.prototype.selectFont = function () {
									var t = e('li.active', this.$results).data('value')
									this.$original.val(t).change(),
										this.updateSelected(),
										this.toggleDrop()
								}),
								(i.prototype.moveToSelected = function () {
									var t,
										i = this.$original.val()
									;(t = i
										? e("li[data-value='" + i + "']", this.$results)
										: e('li', this.$results).first()),
										this.$results.scrollTop(t.addClass('active')[0].offsetTop)
								}),
								(i.prototype.activateFont = function (t) {
									e('li.active', this.$results).removeClass('active'),
										e(t.currentTarget).addClass('active')
								}),
								(i.prototype.deactivateFont = function (t) {
									e(t.currentTarget).removeClass('active')
								}),
								(i.prototype.updateSelected = function () {
									var t = this.$original.val()
									e('span', this.$element)
										.text(this.toReadable(t))
										.css(this.toStyle(t))
								}),
								(i.prototype.setupHtml = function () {
									this.$original.empty().hide(),
										(this.$element = e('<div>', {
											id: 'fontSelect-' + this.$original.id,
											class: this.options.style,
										})),
										(this.$arrow = e('<div><b></b></div>')),
										(this.$select = e(
											'<a><span tabindex="0">' +
												this.options.placeholder +
												'</span></a>'
										)),
										(this.$drop = e('<div>', { class: 'fs-drop' })),
										(this.$results = e('<ul>', { class: 'fs-results' })),
										this.$original.after(
											this.$element
												.append(this.$select.append(this.$arrow))
												.append(this.$drop)
										),
										this.$drop
											.append(this.$results.append(this.fontsAsHtml()))
											.hide()
								}),
								(i.prototype.fontsAsHtml = function () {
									for (var i, e, a = t.length, o = '', n = 0; n < a; n++)
										(i = this.toReadable(t[n])),
											(e = this.toStyle(t[n])),
											(o +=
												'<li tabindex="0" aria-label="' +
												t[n] +
												'"  data-value="' +
												t[n] +
												'" style="font-family: ' +
												e['font-family'] +
												'; font-weight: ' +
												e['font-weight'] +
												'">' +
												i +
												'</li>')
									return o
								}),
								(i.prototype.toReadable = function (t) {
									return t.replace(/[\+|:]/g, ' ')
								}),
								(i.prototype.toStyle = function (t) {
									var i = t.split(':')
									return {
										'font-family': this.toReadable(i[0]),
										'font-weight': i[1] || 400,
									}
								}),
								(i.prototype.getVisibleFonts = function () {
									if (!this.$results.is(':hidden')) {
										var t = this,
											i = this.$results.scrollTop(),
											a = i + this.$results.height()
										if (this.options.lookahead) {
											var o = e('li', this.$results).first().height()
											a += o * this.options.lookahead
										}
										e('li', this.$results).each(function () {
											var o = e(this).position().top + i
											if (o + e(this).height() >= i && o <= a) {
												var n = e(this).data('value')
												t.addFontLink(n)
											}
										})
									}
								}),
								(i.prototype.addFontLink = function (t) {
									var i = this.options.api + t
									0 === e("link[href*='" + t + "']").length &&
										e('link:last').after(
											'<link href="' +
												i +
												'" rel="stylesheet" type="text/css">'
										)
								}),
								i
							)
						})()
					return this.each(function () {
						return i && e.extend(o, i), new n(this, o)
					})
				}),
				(window.hulkDraftOrder = function () {
					return window.is_draft_order
				}),
				(window.hulkappsDoActions = function (i) {
					i.discounts.discount_show
						? t('.discount_code_box').css('display', 'block')
						: t('.discount_code_box').css('display', 'none'),
						i.discounts.plan && t('.edit_cart_option').css('display', 'block'),
						'object' == typeof i.discounts &&
							'object' == typeof i.discounts.cart &&
							'object' == typeof i.discounts.cart.items &&
							hulkappsShowCartDiscounts(i.discounts)
				}),
				t(document).on('click', checkout_selectors, function (i) {
					if (
						(i.preventDefault(),
						window.hulk_inventory_arr && window.hulk_inventory_arr.length > 0)
					) {
						var e = '<div class="hulkapps_summary inventory_validation_hulkapps">'
						return (
							window.hulk_inventory_arr.forEach(function (t) {
								e += t
							}),
							(e += '</div>'),
							t('.inventory_validation_hulkapps').remove(),
							t(this).parent().after(e),
							!1
						)
					}
					if (
						(t('.inventory_validation_hulkapps').remove(),
						window.is_draft_order &&
							window.hulk_inventory_arr &&
							window.hulk_inventory_arr.length <= 0)
					) {
						if (
							('function' != typeof hulkappsCheckout &&
								(window.location = '/checkout'),
							'undefined' == typeof IntegrationCheckoutClick)
						)
							hulkappsCheckout(null)
						else {
							var a = IntegrationCheckoutClick()
							!0 == a.required
								? hulkappsCheckout(a)
								: !1 != a.required && hulkappsCheckout(a)
						}
					} else window.location = '/checkout?locale=' + Shopify.locale
				}),
				(window.hulkappsShowCartDiscounts = function (i) {
					window.hulkapps.discounts = i
					var e = i.cart_item_price_selectors.split(','),
						a = i.cart_item_line_price_selectors.split(','),
						o = i.cart_total_price_selectors
					i.cart.items.forEach(function (i) {
						t.each(e, function (e, a) {
							t('' + a + "[data-key='" + i.key + "']").html(i.original_price_format)
						}),
							t.each(a, function (e, a) {
								t('' + a + "[data-key='" + i.key + "']").html(
									i.original_line_price_format
								)
							})
					})
					var n = parseFloat(i.discount_cut_price)
					;(o = o.split(',')),
						t.each(o, function (e, a) {
							i.discount_code && 1 == i.discount_error
								? (t(a).html(i.original_price_total),
								  hulkapps_jQuery('.hulkapps_summary').remove(),
								  t('.hulkapps_discount_hide').after(
										"<span class='hulkapps_summary'>Discount code does not match</span>"
								  ),
								  localStorage.removeItem('discount_code'),
								  t(a).html(i.original_price_total),
								  t(a).css('text-decoration', 'none'),
								  t('.hulkapps-summary-line-discount-code').html(''),
								  t('.after_discount_price').html(''))
								: i.is_free_shipping
								? (t('.hulkapps_summary').remove(),
								  t(a).html(i.original_price_total),
								  t(a).css('text-decoration', 'none'),
								  t('.hulkapps-summary-line-discount-code').html(''),
								  t('.after_discount_price').html(''),
								  t('.hulkapps_discount_hide').after(
										"<span class='hulkapps-summary-line-discount-code'><span class='discount-tag'>" +
											i.discount_code +
											"<span class='close-tag'></span></span>Free Shipping"
								  ))
								: i.discount_code &&
								  n <= 0 &&
								  t('.discount_code_box').is(':visible')
								? (t(a).html(i.original_price_total),
								  t('.hulkapps_discount_hide').after(
										"<span class='hulkapps_summary'>" +
											i.discount_code +
											' discount code isnâ€™t valid for the items in your cart</span>'
								  ),
								  t('.hulkapps_discount_code').val(''),
								  t(a).html(i.original_price_total),
								  t(a).css('text-decoration', 'none'),
								  t('.hulkapps-summary-line-discount-code').html(''),
								  t('.after_discount_price').html(''),
								  localStorage.removeItem('discount_code'))
								: i.discount_code && t('.discount_code_box').is(':visible')
								? (t('.discount_code_box').find('.hulkapps_summary').html(''),
								  t(
										'.hulkapps-summary-line-discount-code,.after_discount_price'
								  ).remove(),
								  t('.hulkapps_discount_hide').after(
										"<span class='hulkapps-summary-line-discount-code'><span class='discount-tag'>" +
											i.discount_code +
											"<span class='close-tag'></span></span><span class='hulkapps_with_discount'> -" +
											i.with_discount +
											"</span></span><span class='after_discount_price'><span class='final-total'>Total</span>" +
											i.final_with_discounted_price +
											'</span>'
								  ),
								  t(a).html(i.original_price_total),
								  i.original_price_total != i.final_with_discounted_price &&
										t(a).css('text-decoration', 'line-through'),
								  t('.hulkapps-cart-total').remove())
								: (t(a).html(i.original_price_total),
								  t(a).css('text-decoration', 'none'),
								  t('.hulkapps-summary-line-discount-code').html(''),
								  t('.after_discount_price').html(''),
								  t('.discount_code_box').find('.hulkapps_summary').html(''))
						})
				}),
				(window.hulkappsCheckout = function (i) {
					if (window.hulk_inventory_arr && window.hulk_inventory_arr.length > 0) return !1
					var e = {}
					null != i &&
						1 == i.shipping_status &&
						(e = { price: i.shipping_price, title: i.shipping_method })
					var a = localStorage.getItem('discount_code')
					t.getJSON('/cart.js', { _: new Date().getTime() }, function (i) {
						i &&
							i.item_count > 0 &&
							((window.hulkapps.cart = i),
							new Promise((i, e) => {
								t.ajax({
									url: '/cart?view=hulkapps_cart_collections.json',
									success: function (e) {
										try {
											if (e) {
												var a = JSON.parse(e)
												if (a) {
													var o = a.items
													t.each(o, function (t, i) {
														window.hulkapps.cart_collections[
															i.variant_id
														] = i.product_collections
													})
												}
											}
											i(window.hulkapps.cart_collections)
										} catch (n) {
											i(window.hulkapps.cart_collections)
										}
									},
									error: function (t) {
										i(window.hulkapps.cart_collections)
									},
								})
							})
								.then(function (i) {
									window.hulkapps.cart_collections = i
									var o = Shopify.locale
									t.ajax({
										type: 'POST',
										url: window.hulkapps.po_url + '/store/create_draft_order',
										data: {
											cart_json: window.hulkapps,
											store_id: window.hulkapps.store_id,
											discount_code: a,
											cart_collections: JSON.stringify(
												window.hulkapps.cart_collections
											),
											order_app: e,
											customer_tags:
												null != window.hulkapps.customer
													? window.hulkapps.customer.tags.split(',')
													: '',
											draft_order_language: void 0 != o ? o : '',
										},
										crossDomain: !0,
										success: function (t) {
											'string' == typeof t
												? (window.location.href = t)
												: (window.location.href = '/checkout'),
												localStorage.removeItem('discount_code')
										},
									})
								})
								.catch(function (t) {
									console.error(t)
								}))
					})
				}),
				(window.productPageAjax = function (t) {
					console.log('UCOAST PRODUCT PAGE AJAX')
					t.ajax({
						type: 'POST',
						url: window.hulkapps.po_url + '/api/v2/store/get_all_relationships',
						data: {
							pid: window.hulkapps.product_id,
							store_id: window.hulkapps.store_id,
							tags: window.hulkapps.product.tags,
							vendor: window.hulkapps.product.vendor,
							ptype: window.hulkapps.product.type,
							customer_tags:
								null != window.hulkapps.customer
									? window.hulkapps.customer.tags.split(',')
									: '',
							product_collections: window.hulkapps.product_collections,
						},
						sync: !1,
						crossDomain: !0,
						success: function (i) {
							console.log('AJAX Success', i)
							if (
								(window.$first_add_to_cart_el &&
									window.$first_add_to_cart_el.removeAttr('disabled'),
								'string' != t.type(i))
							) {
								var e = ''
								let a = {}
								if (void 0 != i.condition) {
									e += "<div id='conditional_rules' style='display:none'>"
									var o = ''
									t.each(i.condition, function (n, l) {
										var s = l.id,
											p = hulkapps_jQuery.parseJSON(l.conditions)
										if ('OR' == p.apply_rule) var r = '0'
										else var r = '1'
										;(e =
											e +
											"<div id='conditional_logic_" +
											s +
											"' name='conditional_logic_" +
											s +
											"' data-verify-all='" +
											r +
											"' style='display:none'>"),
											t.each(p.rules, function (t, a) {
												var o = parseInt(a.option)
												if (i.option_id_array.indexOf(o) >= 0) {
													if (1 == parseInt(a.rule_type)) var n = '=='
													else var n = '!='
													e =
														e +
														"<div name='conditional_logic_" +
														s +
														"' data-field-num='" +
														o +
														"' data-verify-all='" +
														r +
														"' class='step_1'>**value11**" +
														n +
														a.option_val +
														'</div>'
												}
											}),
											(e += '</div>')
										let d = []
										t.each(p.actions, function (t, e) {
											var a = parseInt(e.option)
											if ((d.push(a), i.option_id_array.indexOf(a) >= 0)) {
												if (1 == parseInt(e.action_type)) var n = 'show'
												else var n = 'hide'
												o += ' conditional_logic_' + s + '_' + n
												var l = 'condition_' + n + ' conditional'
												i.hide_show_array[a] = l
											}
										}),
											(a[s] = d)
									}),
										(e += '</div>')
								}
								var n = i.cart_selectors
								;(window.hulk_po_plan_id = i.plan_id),
									(window.hulk_po_plans_features = i.plans_features),
									(window.hulk_po_is_on_trial_period = i.is_on_trial_period)
								var l =
										0 != i.options_title.title_text.length
											? i.options_title.title_text
											: 'Choose Your Product Options:',
									s = '.hulkapps_option_title{'
								;(s +=
									0 != i.options_title.title_padding.length
										? 'padding: ' + i.options_title.title_padding + 'px;'
										: 'padding: 15px;'),
									(s +=
										0 != i.options_title.title_font_size.length
											? 'font-size: ' +
											  i.options_title.title_font_size +
											  'px;'
											: 'font-size: 16px;'),
									(s +=
										0 != i.options_title.title_text_align.length
											? 'text-align: ' +
											  i.options_title.title_text_align +
											  ';'
											: 'text-align: left;'),
									(s +=
										0 != i.options_title.title_background.length
											? 'background-color: ' +
											  i.options_title.title_background +
											  ';'
											: 'background-color: #ffffff;'),
									(s +=
										0 != i.options_title.title_border.length
											? 'border: 1px solid ' +
											  i.options_title.title_border +
											  ';'
											: 'border: 1px solid #000000;'),
									(s +=
										0 != i.options_title.title_font_color.length
											? 'color: ' + i.options_title.title_font_color + ';'
											: 'color:#000000;'),
									(s +=
										1 == parseInt(i.options_title.title_bold)
											? 'font-weight:bold;'
											: 'font-weight:normal;'),
									(s +=
										1 == parseInt(i.options_title.title_display)
											? ''
											: 'display:none;'),
									(s += 'border-bottom: none;'),
									(s += '}'),
									i.options_container_style.enable_tooltip
								var p = i.options_container_style.enable_helptext,
									r = '#hulkapps_option_list_' + i.pid + '{'
								;(r +=
									0 != i.options_container_style.background_color.length
										? 'background-color: ' +
										  i.options_container_style.background_color +
										  ';'
										: 'background-color: #fff;'),
									(r +=
										0 != i.options_container_style.border_color.length
											? 'border: 1px solid ' +
											  i.options_container_style.border_color +
											  ';'
											: 'border: 0 none;'),
									(r +=
										0 != i.options_container_style.padding.length
											? 'padding: ' +
											  i.options_container_style.padding +
											  'px;'
											: 'padding: 10px;'),
									(r +=
										'}.hulkapps_option {width: 100%;display: block;transition: 0.3s all;'),
									(r +=
										0 !=
										i.options_container_style.spacing_between_options.length
											? 'padding-bottom: 0px; margin-bottom: ' +
											  i.options_container_style.spacing_between_options +
											  'px;'
											: 'padding-bottom: 0; margin-bottom: 6px;'),
									(r +=
										0 != i.options_container_style.line_between_options.length
											? 'border-bottom: 1px solid ' +
											  i.options_container_style.line_between_options +
											  ';'
											: ''),
									(r += '}')
								var d = i.options_name_style.option_name_inline,
									u = i.display_settings.formula_option_name_inline,
									h = '.hulkapps_option_name {'
								;(h +=
									0 != i.options_name_style.option_name_width.length
										? 'width: ' + i.options_name_style.option_name_width + 'px;'
										: 'width: 180px;'),
									(h +=
										0 != i.options_name_style.option_name_font_size.length
											? 'font-size: ' +
											  i.options_name_style.option_name_font_size +
											  'px;'
											: 'font-size: 14px;'),
									(h +=
										0 != i.options_name_style.option_name_text_align.length
											? 'text-align: ' +
											  i.options_name_style.option_name_text_align +
											  ';'
											: 'text-align: left;'),
									(h +=
										0 != i.options_name_style.font_color.length
											? 'color: ' + i.options_name_style.font_color + ';'
											: 'color: #424242;'),
									(h +=
										1 == parseInt(i.options_name_style.on_title_bold)
											? 'font-weight: bold;'
											: 'font-weight: normal;'),
									(h =
										h +
										'min-width: ' +
										i.options_name_style.option_name_width +
										'px;padding-right: 15px;box-sizing: border-box;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;-ms-box-sizing: border-box;vertical-align: top;}'),
									i.option_values_style.ov_padding,
									i.option_values_style.ov_width,
									i.option_values_style.spacing_left_of_values
								var c = i.option_values_style.single_line,
									v = '.hulkapps_option_value {'
								;(v +=
									'width:100%;min-width: 100%;text-align: left;vertical-align: top;}'),
									(v +=
										'.hulkapps_option .hulkapps_option_value, .pn_render .hulkapps_option_child, .et_render .hulkapps_option_child, .tb_render .hulkapps_option_child, .ta_render .hulkapps_option_child, .fu_render .hulkapps_option_child, .dd_render .hulkapps_option_child, .dd_multi_render .hulkapps_option_child, .nf_render .hulkapps_option_child, .dp_render .hulkapps_option_child, .dt_render .hulkapps_option_child{'),
									(v +=
										0 != i.option_values_style.ov_font_size.length
											? 'font-size: ' +
											  i.option_values_style.ov_font_size +
											  'px !important;'
											: ''),
									(v +=
										0 != i.option_values_style.ov_font_color.length
											? 'color: ' +
											  i.option_values_style.ov_font_color +
											  ' !important;'
											: ''),
									(v +=
										void 0 != i.option_values_style.ov_font_weight &&
										1 == parseInt(i.option_values_style.ov_font_weight)
											? 'font-weight:bold;'
											: 'font-weight:normal;'),
									(v +=
										void 0 != i.option_values_style.ov_text_align
											? 'text-align: ' +
											  i.option_values_style.ov_text_align +
											  ' !important;'
											: ''),
									(v += '}')
								var f = '.hulkapps_helptext,.hulkapps_helptext a{'
								;(f +=
									void 0 != i.option_help_text_style &&
									void 0 != i.option_help_text_style.option_help_text_font_size
										? 'font-size: ' +
										  i.option_help_text_style.option_help_text_font_size +
										  'px !important;'
										: ''),
									(f +=
										void 0 != i.option_help_text_style &&
										void 0 !=
											i.option_help_text_style.option_help_text_font_color
											? 'color: ' +
											  i.option_help_text_style.option_help_text_font_color +
											  '!important;'
											: ''),
									(f +=
										void 0 != i.option_help_text_style &&
										1 == parseInt(i.option_help_text_style.on_help_text_bold)
											? 'font-weight: bold;'
											: 'font-weight: normal;'),
									(f += '}')
								var m =
									'.hulkapps-tooltip .hulkapps-tooltip-inner,.hulkapps-tooltip .hulkapps-tooltip-inner a{'
								;(m +=
									void 0 != i.option_tooltip_style &&
									void 0 != i.option_tooltip_style.option_tooltip_font_size
										? 'font-size: ' +
										  i.option_tooltip_style.option_tooltip_font_size +
										  'px !important;'
										: ''),
									(m +=
										void 0 != i.option_tooltip_style &&
										void 0 != i.option_tooltip_style.option_tooltip_font_color
											? 'color: ' +
											  i.option_tooltip_style.option_tooltip_font_color +
											  '!important;'
											: ''),
									(m +=
										void 0 != i.option_tooltip_style &&
										void 0 !=
											i.option_tooltip_style.option_tooltip_background_color
											? 'background-color: ' +
											  i.option_tooltip_style
													.option_tooltip_background_color +
											  '!important;'
											: ''),
									(m += '}'),
									(m += '.hulkapps-tooltip .hulkapps-tooltip-inner:after{'),
									(m +=
										void 0 != i.option_tooltip_style &&
										void 0 !=
											i.option_tooltip_style.option_tooltip_background_color
											? 'border-color: ' +
											  i.option_tooltip_style
													.option_tooltip_background_color +
											  ' transparent transparent transparent !important;'
											: ''),
									(m += '}'),
									(m +=
										'.hulkapps-tooltip .hulkapps-tooltip-inner.swatch-tooltip p,.hulkapps-tooltip .hulkapps-tooltip-inner.multiswatch-tooltip p{'),
									(m +=
										void 0 != i.option_tooltip_style &&
										void 0 != i.option_tooltip_style.option_tooltip_font_color
											? 'color: ' +
											  i.option_tooltip_style.option_tooltip_font_color +
											  '!important;'
											: ''),
									(m += '}')
								var k =
										0 != i.option_values_style.ov_font_size.length
											? parseInt(i.option_values_style.ov_font_size) - 2
											: 14,
									$ = '.has-float-label .floating_label{'
								;($ +=
									0 != i.option_values_style.ov_font_size.length
										? 'font-size: ' + i.option_values_style.ov_font_size + 'px;'
										: 'font-size: 14px;'),
									($ +=
										0 != i.option_values_style.ov_font_color.length
											? 'color: ' + i.option_values_style.ov_font_color + ';'
											: 'color: #424242;'),
									($ +=
										void 0 != parseInt(i.option_values_style.ov_font_weight) &&
										1 == parseInt(i.option_values_style.ov_font_weight)
											? 'font-weight: bold;'
											: 'font-weight: normal;'),
									($ += '}'),
									($ +=
										'.has-float-label .hulkapps_option_value input:focus-visible ~ .floating_label, .has-float-label .hulkapps_option_value textarea:focus ~ .floating_label, .has-float-label .hulkapps_option_value textarea:focus-visible ~ .floating_label, .has-float-label .hulkapps_option_value input:focus ~ .floating_label, .has-float-label .hulkapps_option_value textarea:focus-within ~ .floating_label, .has-float-label .hulkapps_option_value input:focus-within ~ .floating_label,  .has-float-label .hulkapps_option_value textarea:active ~ .floating_label, .has-float-label .hulkapps_option_value input:active ~ .floating_label,.has-float-label .hulkapps_option_value input.textbox_selected ~ .floating_label, .has-float-label .hulkapps_option_value input.numberfield_selected ~ .floating_label,.has-float-label .hulkapps_option_value input.emailbox_selected ~ .floating_label,.has-float-label .hulkapps_option_value textarea.textbox_selected ~ .floating_label, .has-float-label .hulkapps_option_value textarea.textarea_selected ~ .floating_label, .has-float-label,.hulkapps_option_value select ~ label.floating_label{'),
									($ +=
										0 != i.option_values_style.ov_font_size.length
											? 'font-size: ' + k + 'px !important;'
											: 'font-size: 14px;'),
									($ += '}')
								var g = i.advanced_users.custom_js,
									b = i.advanced_users.custom_css,
									y = parseInt(i.swatch_settings.swatch_width),
									x = parseInt(i.swatch_settings.swatch_height),
									_ = i.swatch_settings.tooltip_position,
									w = i.swatch_settings.tooltip_contains,
									C = parseInt(i.swatch_settings.tooltip_display),
									q = parseInt(i.swatch_settings.round_corners),
									S = parseInt(i.swatch_settings.enable_swatch_images),
									A = parseInt(i.swatch_settings.enable_swatch_with_text),
									y = '' == y || y < 0 ? 'width:35px;' : 'width:' + y + 'px;',
									x = '' == x || x < 0 ? 'height:35px;' : 'height:' + x + 'px;',
									_ = 'top' == _ ? 'top' : 'bottom',
									q =
										1 == q
											? '-webkit-border-radius: 50%;-moz-border-radius: 50%;border-radius: 50%;'
											: '',
									L =
										0 !=
										i.button_option_settings.button_option_background.length
											? 'background-color: ' +
											  i.button_option_settings.button_option_background +
											  ';'
											: '#ffffff',
									j =
										0 !=
										i.button_option_settings.button_option_font_color.length
											? 'color: ' +
											  i.button_option_settings.button_option_font_color +
											  ';'
											: '#777777',
									E =
										0 !=
										i.button_option_settings.button_option_border_color.length
											? 'border-color: ' +
											  i.button_option_settings.button_option_border_color +
											  ';'
											: '#777777',
									F =
										void 0 != i.label_setting &&
										'blocklable' == i.label_setting.lable_display
											? ''
											: void 0 == i.label_setting
											? ''
											: i.label_setting.lable_display
								if ('floatingLabels' == F) var O = 'has-float-label'
								if ('inlineLabels' == F) var O = 'has-inline-label'
								var z = i.premium_option_settings.update_total_text,
									I =
										void 0 == i.premium_option_settings.amount_note_display
											? 1
											: i.premium_option_settings.amount_note_display
								if (void 0 != i.premium_option_settings.price_setting)
									var I =
										'price_addtional_charge' ==
											i.premium_option_settings.price_setting ||
										'price_total_charge' ==
											i.premium_option_settings.price_setting
											? '1'
											: '0'
								var P =
									void 0 == i.premium_option_settings.disabled_option_price
										? 0
										: i.premium_option_settings.disabled_option_price
								;(currency_symbol = i.currency_symbol),
									(window.hulk_po_currency_symbol = i.currency_symbol),
									(display_price_setting = i.premium_option_settings)
								var T = i.premium_option_settings.post_total_text,
									D = i.premium_option_settings.total_container_background_color,
									N = i.premium_option_settings.total_container_border_color,
									B = i.premium_option_settings.total_container_font_color,
									U = i.premium_option_settings.total_container_price_color,
									M = '#option_total {'
								;(M +=
									'' !== D
										? 'background: none repeat scroll 0 0 ' + D + ';'
										: 'background: none repeat scroll 0 0 #fff;'),
									(M +=
										'' !== N
											? 'border:1px solid ' + N + ';'
											: 'border:1px solid #000000;'),
									(M += '' !== B ? 'color: ' + B + ';' : 'color: #000;'),
									(M += '}#formatted_option_total {'),
									(M += '' !== U ? 'color: ' + U + ';' : 'color: #000;'),
									(M += '}')
								var Q = 0 == parseInt(c) ? '0px' : '10px',
									R =
										void 0 != i.image_thumbnail_parents_selector
											? i.image_thumbnail_parents_selector
											: '',
									K = ''
								void 0 != R &&
									'' != R &&
									(image_parent_selector = R.split(',')).forEach(function (
										t,
										i,
										e
									) {
										i === e.length - 1
											? (K += t + '  img')
											: (K += t + '  img,')
									}),
									(window.image_parent = K)
								var J = i.button_option_settings.button_option_selected_background,
									V =
										i.button_option_settings
											.button_option_selected_border_color,
									H = i.button_option_settings.button_option_selected_font_color,
									Z =
										s +
										r +
										h +
										v +
										M +
										('#hulkapps_custom_options_' +
											i.pid +
											'{clear: both}#hulkapps_options_' +
											i.pid +
											'{margin:15px 0;}#hulkapps_option_list_' +
											i.pid +
											' select{width:100%;padding-top: 12px;padding-bottom: 12px}.popup_detail{position: fixed;background-color: #F7F7F7;padding: 15px;top: 50%;left: 50%;transform: translate(-50%, -50%);justify-content: space-between;z-index: 3;min-width: 300px;max-width: fit-content;overflow-y: auto;max-height: 300px;}.popup_detail a{cursor: pointer;}.popup_detail img{width: 15px;height: 15px;margin: 5px;}.popup_detail p{margin:0;}.overlay-popup{position: fixed;display: none;width: 100%;height: 100%;top: 0;left: 0;bottom: 0;background-color: rgba(0,0,0,0.5);z-index: 2;}.popup_render{margin-bottom:0!important;display:flex;align-items:center!important}.popup_render .hulkapps_option_value{min-width:auto!important}.popup_render a{margin-left: 4px;text-decoration:underline!important;transition:all .3s!important;font-weight: normal !important;}.popup_render a:hover{color:#6e6e6e}.cut-popup-icon{display:inline-flex;align-items:center}.cut-popup-icon-span{display:inline-flex}.des-detail{font-weight: normal;}#hulkapps_option_list_' +
											i.pid +
											" input[type='text']{width:100%;border-radius:0}#hulkapps_option_list_" +
											i.pid +
											' input,#hulkapps_option_list_' +
											i.pid +
											' textarea,#hulkapps_option_list_' +
											i.pid +
											' select{border:1px solid #DADADA;box-shadow: none;-webkit-appearance: none;padding:10px;min-height: 36px;}#hulkapps_option_list_' +
											i.pid +
											' .validation_error{color:#FF0808;background-color:#FFF8F7;border-style:solid;border-width:1px;border-color:#FFCBC9;border-bottom: 1px solid #ffcbc9;padding: 8px 8px ;display: inline-block;margin-top: 2px;}#hulkapps_option_list_' +
											i.pid +
											' .validation_error .hulkapps_option_value{color:#FF0808}#hulkapps_option_list_' +
											i.pid +
											' .validation_error .hulkapps_option_name{color:#FF0808}.hulkapps_option_value:first-child{display:flex;align-items: center;} .hulkapps_option_value:first-child span{display: flex;padding-right: 10px;}.hulkapps_option_value:first-child a{cursor: pointer;} .hulkapps_helptext{color: #000 !important;}.hulkapps_full_width{width:100%;display:block;}.hulkapps_check_option,.hulkapps_radio_option{display:block;margin-right:0;font-weight:normal !important;}.single_line .hulkapps_option_value .hulkapps_check_option,.single_line .hulkapps_option_value .hulkapps_radio_option{display:inline-flex;margin-right:20px;font-weight:normal; align-items: center; }#hulkapps_option_list_' +
											i.pid +
											" input[type='checkbox']{margin-right: 5px;vertical-align: baseline;min-height:auto; height: auto;display: none;-webkit-appearance: checkbox;-moz-appearance: checkbox;appearance: checkbox;}.hulkapps_check_option input[type='checkbox']{margin-right:5px;}#hulkapps_option_list_" +
											i.pid +
											" input[type='radio']{margin-right:5px;vertical-align:baseline;display: none;}i.hulkapps_tooltip_identifier{color:rgb(255, 255, 255);border-radius:12px;font-size:10px;margin-right:6px;margin-left:4px;padding:0px 4px;background:#000000}span.hulkapps_option_name_additional_info{position:relative}span.hulkapps_option_name_additional_info .hulkapps_tool_tip{display:none}span.hulkapps_option_name_additional_info:hover .hulkapps_tool_tip{content:attr(data-additional-info);padding:4px 8px;color:#fff;position:absolute;left:0;bottom:160%;z-index:20px;-moz-border-radius:5px;-webkit-border-radius:5px;border-radius:5px;display:block;background:#000000;width:150px}span.hulkapps_option_name_additional_info:hover:after{display:block}i.hulkapps_tooltip_identifier:before{content:'?';font-style:normal}#formatted_option_total{font-weight:bold;margin:0 7px}.td_render .hulkapps_option_name.full_name{float:none;width:auto}.hulkapps_option.full_width .hulkapps_option_name{width:100%;}.hulkapps_option.full_width .hulkapps_option_value{width:100%;display:block;}.hulkapps_option.full_width .hulkapps_option_name{padding-bottom:5px}.hulkapps_option:after{content:'';clear:both;display:block}.hulkapps_option_name a:link {color: grey;text-decoration: none;font-weight: normal;}.hulkapps_option_name a:hover {color: rgb(93, 156, 236);background: transparent;}.hulkapps_swatch_option .hulkapps_option_child:after{border: 1px solid #DADADA;cursor: pointer;content:'';position:absolute;top:-4px;right:-4px;bottom:-4px;left:-4px;" +
											q +
											"}.hulkapps_mswatch_option .hulkapps_option_child:after{border: 1px solid #DADADA;cursor: pointer;content:'';position:absolute;top:-4px;right:-4px;bottom:-4px;left:-4px; " +
											q +
											'}.hulkapps_radio_option .radio_selected{border: 2px solid #0090FA;background:#0090FA;color:#fff;}.radio_div{border: 2px solid #eee;padding: 8px 20px;padding: 6px 12px;}.radio_div:hover{border: 2px solid #0090FA;cursor:pointer;}.tooltip.in{opacity:1 !important;}#option_display_total_format{padding-left:5px;}.hulkapps_swatch_option .tooltip-inner{padding: 0px 5px !important;}.hulkapps_check_option,.hulkapps_radio_option{margin-right:' +
											Q +
											'}.hulkapps_swatch_option,.hulkapps_mswatch_option{ margin-right:10px !important; display: inline-block;vertical-align: middle;}.hulkapps-tooltip.tooltip-left-pos .hulkapps-tooltip-inner.swatch-tooltip{left: 0 !important;right: auto !important;}.hulkapps-tooltip.tooltip-left-pos .hulkapps-tooltip-inner.swatch-tooltip:after{right: auto !important;left: 10px !important;}.hulkapps-tooltip.tooltip-right-pos .hulkapps-tooltip-inner.swatch-tooltip{right: 0 !important;left: auto !important;}.hulkapps-tooltip.tooltip-right-pos .hulkapps-tooltip-inner.swatch-tooltip:after{left: auto !important;right: 10px !important;}.hulkapps-tooltip.tooltip-center-pos .hulkapps-tooltip-inner.swatch-tooltip{left: 50% !important;transform: translateX(-50%);}.hulkapps-tooltip.tooltip-center-pos .hulkapps-tooltip-inner.swatch-tooltip:after{left: 50% !important;transform: translateX(-50%);}.phone_number{padding-left: 50px !important;}#option_total{padding:3px 6px;}.hulkapps-tooltip.tooltip-left-pos .hulkapps-tooltip-inner.multiswatch-tooltip{left: 0 !important;right: auto !important;}.hulkapps-tooltip.tooltip-left-pos .hulkapps-tooltip-inner.multiswatch-tooltip:after{right: auto !important;left: 10px !important;}.hulkapps-tooltip.tooltip-right-pos .hulkapps-tooltip-inner.multiswatch-tooltip{right: 0 !important;left: auto !important;}.hulkapps-tooltip.tooltip-right-pos .hulkapps-tooltip-inner.multiswatch-tooltip:after{left: auto !important;right: 10px !important;}.hulkapps-tooltip.tooltip-center-pos .hulkapps-tooltip-inner.multiswatch-tooltip{left: 50% !important;transform: translateX(-50%);}.hulkapps-tooltip.tooltip-center-pos .hulkapps-tooltip-inner.multiswatch-tooltip:after{left: 50% !important;transform: translateX(-50%);}.hulkapps_swatch_option, .hulkapps_mswatch_option{margin-bottom: 10px !important;}.hulkapps_buton_option .hulkapps_option_child{ width: auto;min-height: 36px;padding: 15px;border: 1px solid;border-radius: 0;line-height: 1.13;font-weight: 400;display: flex;justify-content: center;align-items: center;margin-right: 0;margin-bottom: 8px;}.button_selected {color: ' +
											H +
											' !important;background-color: ' +
											J +
											' !important;border-color: ' +
											V) +
										" !important;font-weight: 400 !important;}.hulkapps_option_set input::placeholder,.hulkapps_option_set textarea::placeholder  {color: #a9a9a9;font-size: 16px !important;font-weight: 700;font-family: sans-serif;}.conditional, .is_hulk_hide{display:none !important}.has-float-label .hulkapps_option_name{display: none !important}.has-float-label .hulkapps_option_value{display: block;width: 100%}.has-inline-label .hulkapps_option_name{display: none !important}.has-inline-label .hulkapps_option_value{display: block;width: 100%}.has-float-label .hulkapps_option_value{ position: relative;}.has-float-label .hulkapps_option_value .floating_label{position: absolute;top: 24%;left: 10px;}input:focus .floating_label { position: absolute;top: 30%;left: 10px;}.has-float-label .hulkapps_option_value textarea,.has-float-label .hulkapps_option_value input,.has-float-label .hulkapps_option_value select{ position: relative;z-index: 1;background-color: transparent;}.has-float-label .hulkapps_option_value .floating_label {position: absolute;top: 24%;left: 10px;transition: all .2s;}.has-float-label .hulkapps_option_value select ~ label.floating_label {cursor: text;opacity: 1;transition: all .2s;top: -0.5em !important;z-index: 3;line-height: 1;padding: 0 1px;left: 10px;position: absolute; z-index: 2;}.has-float-label .hulkapps_option_value input:not(:focus) ~ .floating_label,.has-float-label .hulkapps_option_value textarea:not(:focus) ~ .floating_label {opacity: 1;top: 0.3em;}.has-float-label .hulkapps_option_value input:focus ~ .floating_label,.has-float-label .hulkapps_option_value textarea:focus ~ .floating_label{top: -0.9em !important;z-index: 2;}.has-float-label .hulkapps_option_value .floating_label:after,.has-float-label .hulkapps_option_value input:focus ~ .floating_label:after,.has-float-label .hulkapps_option_value textarea:focus ~ .floating_label:after {content: '';display: block; position: absolute; background: #F7F7F7;height: 2px;top: 50%;left: -0.2em;right: -0.2em;z-index: -1;} " +
										b +
										f +
										m +
										$,
									g =
										"<script>(function($) {$('.hulkapps_swatch_option, .hulkapps_mswatch_option').mouseover(function() {var x = $(this).find('.hulkapps-tooltip ').position();var right = $(window).width() - x.left - $(this).find('.hulkapps-tooltip ').width();if(x.left < 205){$(this).find('.hulkapps-tooltip ').addClass('tooltip-left-pos');}if(right < 160){$(this).find('.hulkapps-tooltip ').addClass('tooltip-right-pos');}});$(window).width()<=768&&$('.hulkapps-tooltip').each(function(){var t=$(this).position(),i=$(window).width()-t.left-$(this).width(),o=t.left-i;o<50&&o>-50?$(this).addClass('tooltip-center-pos'):t.left<i?$(this).addClass('tooltip-left-pos'):i<t.left&&$(this).addClass('tooltip-right-pos')});" +
										i.advanced_users.custom_js +
										'}(hulkapps_jQuery))</script>',
									X =
										"<div id='hulkapps_options_" +
										i.pid +
										"' class='hulkapps_product_options'>"
								;(X =
									(X =
										(X = X + '' + e + '<style>' + Z + '</style>' + g) +
										"<div class='hulkapps_option_title'>" +
										l +
										'</div>') +
									"<div id='hulkapps_option_list_" +
									i.pid +
									"' >"),
									'' !== I || 1 == parseInt(I)
										? (X +=
												"<input type='hidden' id='hulk_amount_dis' value='1'>")
										: (X +=
												"<input type='hidden' id='hulk_amount_dis' value='0'>"),
									i.relationship
								var W = ''
								;(window.opt_with_otc = {}), (window.is_hulk_required_options = !1)
								var G = []
								if (0 != i.relationship_option.length) {
									var Y = "<span class='hulkapps-required'> * </span>"
									;(X += "<div class='hulkapps_option_set'>"),
										t.each(i.relationship_option, function (e, o) {
											var n = parseInt(o[0])
											let l = []
											for (let [s, r] of Object.entries(a))
												r.includes(n) && l.push(s)
											var h =
												3 == o.length
													? o[1]
													: 'required' == o[1]
													? o[1]
													: ''
											if (
												('true' ==
													(3 == o.length
														? o[2]
														: 'true' == o[1]
														? o[1]
														: '') && G.push(parseInt(o[0])),
												i.option_id_array.indexOf(n) >= 0)
											) {
												var v = t.trim(
														i.option_associative_array[n].option_name
													),
													f = t.trim(
														i.option_associative_array[n]
															.is_one_time_charge
													),
													m = t.trim(
														i.option_associative_array[n]
															.option_unique_name
													),
													k = t.trim(i.image_color_position_class),
													$ = t.trim(i.image_color_shape_class),
													g = t.trim(
														i.option_associative_array[n].tooltip
													),
													b = t.trim(
														i.option_associative_array[n].helptext
													),
													z = t.trim(
														i.option_associative_array[n].id_name
													),
													I = '' != z ? 'id="' + z + '"' : '',
													T = t.trim(
														i.option_associative_array[n].class_name
													),
													D = t.trim(
														i.option_associative_array[n].placeholder
													),
													N = t.trim(
														i.option_associative_array[n]
															.tooltip_hyperlink
													),
													B = t.trim(
														i.option_associative_array[n]
															.helptext_hyperlink
													)
												if (g.length > 0) {
													var U =
														"<div class='hulkapps-tooltip'><span aria-describedby='tooltip_" +
														n +
														"' aria-label='" +
														g +
														"' tabindex='0' ><img src='" +
														window.hulkapps.po_url +
														"/tooltip.svg' style='width:15px;'></span><div class='hulkapps-tooltip-inner' id='tooltip_" +
														n +
														"' role='tooltip'>"
													if (N.length > 0)
														var U =
															U +
															'<a href="' +
															N +
															'" target="_blank"> ' +
															g +
															'</a></div></div>'
													else var U = U + g + '</div></div>'
												} else var U = ''
												if (b.length > 0) {
													if (B.length > 0)
														var M =
															'<span aria-label="' +
															b +
															'" tabindex="0" class="hulkapps_helptext"><a href="' +
															B +
															'" target="_blank"> ' +
															b +
															'</a></span>'
													else
														var M =
															"<span  aria-label='" +
															b +
															"' tabindex='0'  class='hulkapps_helptext'>" +
															b +
															'</span>'
												} else var M = ''
												var Q = i.option_associative_array[n].extra_field,
													R = i.option_associative_array[n].option_type,
													J =
														i.option_associative_array[n]
															.is_quantity_selector,
													V =
														i.option_associative_array[n]
															.is_thumbnail_change,
													H = i.option_associative_array[n].google_fonts,
													Z =
														i.option_associative_array[n]
															.google_font_with_price,
													X =
														i.option_associative_array[n]
															.default_selection_google_font,
													tt =
														i.option_associative_array[n]
															.default_selection_google_price,
													ti = n,
													te = t.parseJSON(
														i.option_associative_array[n].values_json
													),
													ta = i.hide_show_array[ti]
														? i.hide_show_array[ti]
														: ''
												let to = '',
													tn = ''
												var tl = {}
												let ts = '',
													tp = ''
												l.forEach((e) => {
													t.each(i.condition, function (i, a) {
														let o = a.id
														var n = hulkapps_jQuery.parseJSON(
															a.conditions
														)
														o == e &&
															(t.each(n.actions, function (t, i) {
																1 == parseInt(i.action_type) &&
																ta.includes('condition_show')
																	? (tn = 'show')
																	: ta.includes(
																			'condition_hide'
																	  ) && (tn = 'hide'),
																	tn &&
																		checkPlan(
																			'enhanced_conditional_logic',
																			'boolean'
																		) &&
																		i.action_option_value &&
																		(tl[
																			'conditional_logic_' +
																				e +
																				'_' +
																				tn
																		]
																			? tl[
																					'conditional_logic_' +
																						e +
																						'_' +
																						tn
																			  ].push(
																					i.action_option_value
																						.toString()
																						.trim()
																			  )
																			: (tl[
																					'conditional_logic_' +
																						e +
																						'_' +
																						tn
																			  ] = [
																					i.action_option_value
																						.toString()
																						.trim(),
																			  ]))
															}),
															t.each(n.actions, function (t, i) {
																return 1 ==
																	parseInt(i.action_type) &&
																	ta.includes('condition_show')
																	? ((to +=
																			' conditional_logic_' +
																			e +
																			'_' +
																			(tn = 'show')),
																	  !1)
																	: ta.includes('condition_hide')
																	? ((to +=
																			' conditional_logic_' +
																			e +
																			'_' +
																			(tn = 'hide')),
																	  !1)
																	: void 0
															}))
													})
												}),
													Object.keys(tl).length > 0 &&
														((ts = to), (tp = ta), (to = ''), (ta = ''))
												var tr = '',
													td = '',
													t8 = 'required' == h ? 'required' : '',
													tu = 'required' == h
												'required' == h &&
													(window.is_hulk_required_options = !0)
												var th = 0 == parseInt(d) ? 'full_width' : '',
													tc = 'required' == h ? Y : '',
													tv =
														'1' ==
														i.options_container_style.enable_tooltip
															? U
															: '',
													tf =
														'1' == p && M.length > 0
															? "<div class='hulkapps_helptext_div'>" +
															  M +
															  '</div>'
															: ''
												let tm = '_hin_' + m + '_hin_' + v
												window.opt_with_otc[tm] = f
												var tk = G.includes(n),
													t$ = ''
												if (
													(checkPlan(
														'image_change_based_on_multiple_option_value',
														'boolean'
													) &&
														!0 == tk &&
														(t$ = 'image_change_with_multiple'),
													'dropdown' == R)
												) {
													;(tS =
														"<div class='hulkapps_option dd_render " +
														t$ +
														' ' +
														O +
														' ' +
														to +
														' ' +
														t8 +
														' ' +
														th +
														' option_type_id_' +
														ti +
														' ' +
														ta +
														' ' +
														T +
														"' " +
														I +
														' data-parent-id= ' +
														ti +
														'>'),
														(tS +=
															"<div aria-label='" +
															v +
															"' tabindex='0' aria-required='" +
															tu +
															"' class='hulkapps_option_name'>" +
															v +
															' ' +
															tc +
															' ' +
															tv +
															' ' +
															tf +
															'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														(tS +=
															"<select class='hulkapps_option_child hulkapps_option_" +
															ti +
															"_visible hulkapps_full_width hulkapps_dd hulk_po_dropdown' data-parent='hulkapps_product_options' data-pid='" +
															i.pid +
															"' data-option-key='dd_" +
															ti +
															"' id='" +
															ti +
															"' >"),
														'inlineLabels' == F && (D = v),
														'' == D
															? (tS +=
																	"<option value='' class=" +
																	to +
																	'>Choose ' +
																	v +
																	'</option>')
															: (tS +=
																	"<option value='' class=" +
																	to +
																	'>' +
																	D +
																	'</option>')
													var tg = !1,
														tb = 'none',
														ty = '',
														tx = '',
														t_ = ''
													t.each(te, function (t, e) {
														var a = e[1]
														'percentage_charge' == e[9] &&
															null != a &&
															'' != a &&
															((a =
																((parseFloat(product_price) / 100) *
																	a) /
																100),
															(a = parseFloat(a.toFixed(2))))
														var o =
																null != a && '' != a
																	? ' [ ' +
																	  i.currency_symbol +
																	  a +
																	  ' ]'
																	: '',
															n =
																null != a && '' != a && 0 == P
																	? ' (+' +
																	  i.currency_symbol +
																	  a +
																	  ')'
																	: '',
															l = null != a && '' != a ? a : '0.00',
															s = e[4]
														!0 == s &&
															((tx = e[0].toString().trim() + o),
															(tb = 'block'))
														var p = !0 == s ? 'selected' : '',
															r = '' != l ? 'price-change' : '',
															d = '',
															u = ''
														let h =
																'' != e[5] && null != e[5]
																	? e[5]
																	: '',
															c = parseInt(e[6])
														var f = ''
														let m =
																'' != e[7] && null != e[7]
																	? e[7]
																	: '',
															k =
																'' != e[8] && null != e[8]
																	? e[8]
																	: ''
														var $ =
																'' != e[10] && null != e[10]
																	? e[10]
																	: '',
															g = 'disabled'
														if (
															(checkPlan(
																'inventory_and_sku_management',
																'boolean'
															) &&
																('true' == h.toString() &&
																	'true' != m.toString() &&
																	c <= 0 &&
																	('true' == k.toString()
																		? ((d = 'disabled'),
																		  (p = ''))
																		: ((u = 'is_hulk_hide'),
																		  (d = 'disabled'),
																		  (p = ''))),
																'true' == h.toString() && (tg = !0),
																'true' == h.toString() &&
																	'true' != m.toString() &&
																	((f = c),
																	!0 == s &&
																		'' == d &&
																		(ty =
																			e[0].toString().trim() +
																			o +
																			'_hin_' +
																			f)),
																((!0 == s &&
																	c > 0 &&
																	'true' != m.toString()) ||
																	(!0 == s &&
																		c <= 0 &&
																		'true' == m.toString())) &&
																	(g = ''),
																'' != $ &&
																	(t_ =
																		t_ +
																		"<input type='hidden' name='properties[_SKU_" +
																		v +
																		'(' +
																		e[0].toString().trim() +
																		")]' value='" +
																		$ +
																		"' class='hulk_unique_sku' data-sku-identifier='" +
																		e[0].toString().trim() +
																		"' " +
																		g +
																		'>')),
															(tr = ''),
															(td = ''),
															Object.keys(tl).length > 0)
														)
															for (let b in tl)
																tl.hasOwnProperty(b) &&
																	Array.isArray(tl[b]) &&
																	tl[b].includes(
																		e[0].toString().trim()
																	) &&
																	((tr += ` ${b} `), (td = tp))
														tS =
															tS +
															"<option  class='" +
															r +
															' ' +
															tr +
															' ' +
															td +
															' ' +
															u +
															"' " +
															p +
															" data-hinventory='" +
															f +
															"' " +
															d +
															" data-price='" +
															l +
															"' data-conditional-value='" +
															e[0].toString().trim() +
															"' value='" +
															e[0].toString().trim() +
															o +
															"'>" +
															e[0].toString().trim() +
															n +
															'</option>'
													})
													var tw = ''
													tg &&
														(tw =
															"<input type='hidden' name='properties[_hin_" +
															m +
															'_hin_' +
															v +
															"]' value='" +
															ty +
															"' class='hulk_unique_prop' data-unique_prop_name='_hin_" +
															m +
															'_hin_' +
															v +
															"'/>"),
														(tS += '</select>' + t_ + tw),
														checkPlan('quantity_selector', 'boolean') &&
															J &&
															(tS +=
																"<input style='display: " +
																tb +
																"' type='number' min='1' value='1' class='hulk_options_quantity hulk_po_dropdown_quantity' data-parent='hulkapps_product_options' data-pid='" +
																i.pid +
																"' id='quantity_" +
																ti +
																"'/>"),
														(tS +=
															"<input type='hidden' name='properties[" +
															v +
															"]' value='" +
															tx +
															"' class='hulk_dropdown_hidden_prop'/>"),
														'floatingLabels' == F &&
															(tS +=
																"<label class='floating_label'>" +
																v +
																'</label>'),
														(tS += '</div></div>'),
														checkPlan(
															'image_change_based_on_option_value',
															'boolean'
														) &&
															!0 == V &&
															'' != K &&
															(tS +=
																"<script>(function($) {$(document).on('change','.hulkapps_product_options #hulkapps_option_list_" +
																i.pid +
																' #' +
																ti +
																"', function()  { var option_val  = $(this).find(':selected').data('conditional-value');$('" +
																K +
																"').each(function(){data_title = $(this).attr('alt');if(option_val === data_title){$(this).click();}});});;}(hulkapps_jQuery))</script>"),
														(W += tS)
												} else if ('dropdown_multiple' == R) {
													var tC =
															void 0 != Q &&
															'' != Q &&
															'' != Q.minimum_selection &&
															void 0 != Q.minimum_selection
																? Q.minimum_selection.toString()
																: '0',
														t9 =
															void 0 != Q &&
															'' != Q &&
															'' != Q.maximum_selection &&
															void 0 != Q.maximum_selection
																? Q.maximum_selection.toString()
																: '0',
														tq =
															'0' != tC &&
															'0' != t9 &&
															checkPlan(
																'validation_for_min_max_option_selection',
																'boolean'
															)
																? '<span class="selection-text">[Choose from ' +
																  tC +
																  ' to ' +
																  t9 +
																  ' values]</span>'
																: '0' != tC &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  )
																? '<span class="selection-text">[Choose at least ' +
																  tC +
																  ' values]</span>'
																: '0' != t9 &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  )
																? '<span class="selection-text">[Choose upto ' +
																  t9 +
																  ' values]</span>'
																: '',
														tS =
															"<div class='hulkapps_option dd_multi_render " +
															O +
															' ' +
															to +
															' ' +
															t8 +
															' ' +
															th +
															'  option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"'>"
													;(tS +=
														"<div aria-label='" +
														v +
														"' tabindex='0' aria-required='" +
														tu +
														" ' class='hulkapps_option_name'>" +
														v +
														' ' +
														tc +
														' ' +
														tv +
														' ' +
														tq +
														tf +
														'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														(tS +=
															"<select multiple class='hulkapps_option_child hulkapps_option_" +
															ti +
															"_visible hulkapps_full_width hulkapps_dd hulk_po_dropdown_multiple' data-parent='hulkapps_product_options' data-pid='" +
															i.pid +
															"' data-option-key='dd_" +
															ti +
															"' id='" +
															ti +
															"' name='hulkapps_multiple_dropdown' style='background:none;' data-min='" +
															tC +
															"' data-max='" +
															t9 +
															"'>")
													var tx = [],
														ty = [],
														t0 = 0
													'inlineLabels' == F && (D = v),
														'' != D &&
															(tS +=
																"<option value='' class=" +
																to +
																'>' +
																D +
																'</option>')
													var t_ = ''
													t.each(te, function (t, e) {
														if (
															((tr = ''),
															(td = ''),
															Object.keys(tl).length > 0)
														)
															for (let a in tl)
																tl.hasOwnProperty(a) &&
																	Array.isArray(tl[a]) &&
																	tl[a].includes(
																		e[0].toString().trim()
																	) &&
																	((tr += ` ${a} `), (td = tp))
														var o = e[1]
														'percentage_charge' == e[9] &&
															null != o &&
															'' != o &&
															((o =
																((parseFloat(product_price) / 100) *
																	o) /
																100),
															(o = parseFloat(o.toFixed(2))))
														var n =
																null != o && '' != o
																	? ' [ ' +
																	  i.currency_symbol +
																	  o +
																	  ' ]'
																	: '',
															l =
																null != o && '' != o && 0 == P
																	? ' (+' +
																	  i.currency_symbol +
																	  o +
																	  ')'
																	: '',
															s = null != o && '' != o ? o : '0.00',
															p = e[4]
														!0 == p &&
															((t0 += 1),
															tx.push(e[0].toString().trim() + n))
														var r = !0 == p ? 'selected' : '',
															d = '' != s ? 'price-change' : '',
															u = '',
															h = ''
														let c =
																'' != e[5] && null != e[5]
																	? e[5]
																	: '',
															f = parseInt(e[6])
														var m = ''
														let k =
																'' != e[7] && null != e[7]
																	? e[7]
																	: '',
															$ =
																'' != e[8] && null != e[8]
																	? e[8]
																	: ''
														var g =
																'' != e[10] && null != e[10]
																	? e[10]
																	: '',
															b = 'disabled'
														checkPlan(
															'inventory_and_sku_management',
															'boolean'
														) &&
															('true' == c.toString() &&
																'true' != k.toString() &&
																f <= 0 &&
																('true' == $.toString()
																	? ((u = 'disabled'),
																	  (r = ''),
																	  (d = ''),
																	  !0 == p &&
																			tx.pop(
																				e[0]
																					.toString()
																					.trim() + n
																			))
																	: ((h = 'is_hulk_hide'),
																	  (u = 'disabled'),
																	  (r = ''),
																	  (d = ''),
																	  !0 == p &&
																			tx.pop(
																				e[0]
																					.toString()
																					.trim() + n
																			))),
															'true' == c.toString() && (tg = !0),
															'true' == c.toString() &&
																'true' != k.toString() &&
																((m = f),
																!0 == p &&
																	'' == h &&
																	'' == u &&
																	ty.push(
																		e[0].toString().trim() +
																			n +
																			'_hin_' +
																			m
																	)),
															((!0 == p &&
																f > 0 &&
																'true' != k.toString()) ||
																(!0 == p &&
																	f <= 0 &&
																	'true' == k.toString())) &&
																(b = ''),
															'' != g &&
																(t_ =
																	t_ +
																	"<input type='hidden' name='properties[_SKU_" +
																	v +
																	'(' +
																	e[0].toString().trim() +
																	")]' value='" +
																	g +
																	"' class='hulk_unique_sku' data-sku-identifier='" +
																	e[0].toString().trim() +
																	"' " +
																	b +
																	'>')),
															(tS =
																tS +
																"<option class='" +
																tr +
																' ' +
																td +
																' ' +
																d +
																' ' +
																h +
																"' " +
																r +
																" data-hinventory='" +
																m +
																"' " +
																u +
																" data-price='" +
																s +
																"' data-conditional-value='" +
																e[0].toString().trim() +
																"' value='" +
																e[0].toString().trim() +
																n +
																"'>" +
																e[0].toString().trim() +
																l +
																'</option>')
													}),
														t0 > 0 &&
															('0' != tC &&
															'0' != t9 &&
															checkPlan(
																'validation_for_min_max_option_selection',
																'boolean'
															)
																? (parseInt(t0) < parseInt(tC) ||
																		parseInt(t0) >
																			parseInt(t9)) &&
																  (tS +=
																		'</select><span class="validation_error error_span">Choose from ' +
																		tC +
																		' to ' +
																		t9 +
																		' values</span>')
																: '0' != tC &&
																  '0' == t9 &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  )
																? parseInt(t0) < parseInt(tC) &&
																  (tS +=
																		'</select><span class="validation_error error_span">Choose at least ' +
																		tC +
																		' values</span>')
																: '0' == tC &&
																  '0' != t9 &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  ) &&
																  parseInt(t0) > parseInt(t9) &&
																  (tS +=
																		'</select><span class="validation_error error_span">Choose upto ' +
																		t9 +
																		' values</span>')),
														'floatingLabels' == F &&
															(tS +=
																"</select><label class='floating_label'>" +
																v +
																'</label>')
													var tw = ''
													tg &&
														(tw =
															"<input type='hidden' name='properties[_hin_" +
															m +
															'_hin_' +
															v +
															"]' value='" +
															ty +
															"' class='hulk_unique_prop' data-unique_prop_name='_hin_" +
															m +
															'_hin_' +
															v +
															"' data-selection-multi='true'/>"),
														(tS += t_ + tw),
														(tS +=
															"<input class='hulkapps_option_child' type='hidden' value='" +
															tx.join(', ') +
															"' id='hulkapps_option_" +
															ti +
															"_hidden' name='properties[" +
															v +
															"]'></div></div>"),
														(W += tS)
												} else if ('swatch' == R) {
													var t1 = 0,
														tS =
															"<div class='hulkapps_option swatch_render " +
															t$ +
															' ' +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"' >"
													;(tS +=
														"<div aria-label='" +
														v +
														"' tabindex='0' aria-required='" +
														tu +
														" ' class='hulkapps_option_name'>" +
														v +
														' ' +
														tc +
														' ' +
														tv +
														' ' +
														tf +
														'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'>")
													var tg = !1,
														ty = '',
														tx = '',
														tb = 'none',
														t3 = !1
													t.each(te, function (t, e) {
														if (
															((tr = ''),
															(td = ''),
															Object.keys(tl).length > 0)
														)
															for (let a in tl)
																tl.hasOwnProperty(a) &&
																	Array.isArray(tl[a]) &&
																	tl[a].includes(
																		e[0].toString().trim()
																	) &&
																	((td = tp), (tr += ` ${a} `))
														var o = e[1]
														'percentage_charge' == e[9] &&
															null != o &&
															'' != o &&
															((o =
																((parseFloat(product_price) / 100) *
																	o) /
																100),
															(o = parseFloat(o.toFixed(2))))
														var n = '' != e[0] ? e[0] : '',
															l = '' != e[2] ? e[2] : '',
															s = '' != e[3] ? e[3] : '',
															p =
																null != o && '' != o
																	? ' [ ' +
																	  i.currency_symbol +
																	  o +
																	  ' ]'
																	: '',
															r =
																null != o && '' != o && 0 == P
																	? ' (+' +
																	  i.currency_symbol +
																	  o +
																	  ')'
																	: '',
															d = null != o && '' != o ? o : '0.00',
															u = '' != d ? 'price-change' : '',
															h = e[4]
														!0 == h &&
															((tx = e[0].toString().trim() + p),
															(tb = 'block'))
														var c = !0 == h ? 'swatch_selected' : '',
															f = !0 == h ? 'checked' : '',
															m =
																'<p>' +
																e[0] +
																' <br> ' +
																r +
																'</p>',
															k = '',
															$ = '',
															g = ''
														let b =
																'' != e[5] && null != e[5]
																	? e[5]
																	: '',
															S = parseInt(e[6])
														var L = ''
														let j =
																'' != e[7] && null != e[7]
																	? e[7]
																	: '',
															E =
																'' != e[8] && null != e[8]
																	? e[8]
																	: ''
														var F =
																'' != e[10] && null != e[10]
																	? e[10]
																	: '',
															O = '',
															z = 'disabled'
														checkPlan(
															'inventory_and_sku_management',
															'boolean'
														) &&
															('true' == b.toString() &&
																'true' != j.toString() &&
																S <= 0 &&
																('true' == E.toString()
																	? (($ = 'is_hulk_disabled'),
																	  (k = 'disabled'),
																	  (c = ' '),
																	  (u = ' '))
																	: ((g = 'is_hulk_hide'),
																	  (k = 'disabled'),
																	  (c = ''),
																	  (u = ''))),
															'true' == b.toString() && (tg = !0),
															'true' == b.toString() &&
																'true' != j.toString() &&
																((L = S),
																!0 == h &&
																	'' == g &&
																	'' == k &&
																	(ty =
																		e[0].toString().trim() +
																		p +
																		'_hin_' +
																		L)),
															((!0 == h &&
																S > 0 &&
																'true' != j.toString()) ||
																(!0 == h &&
																	S <= 0 &&
																	'true' == j.toString())) &&
																(z = ''),
															'' != F &&
																(O =
																	"<input type='hidden' name='properties[_SKU_" +
																	v +
																	'(' +
																	e[0].toString().trim() +
																	")]' value='" +
																	F +
																	"' class='hulk_unique_sku' " +
																	z +
																	'>'))
														var I = ''
														if ('image' == l)
															(N =
																'background-image:url(' +
																s +
																'); background-size:cover;background-position: center center;' +
																q),
																(B = "data-image='" + s + "'"),
																(I = s)
														else {
															try {
																var T = s.split(',')
															} catch (D) {
																T = null
															}
															if (null != T) {
																if (void 0 != T[1])
																	var N = (swatch_color_dual_ton =
																			'background: linear-gradient(to bottom, ' +
																			T[0] +
																			' 0%, ' +
																			T[0] +
																			' 50%, ' +
																			T[1] +
																			' 50%, ' +
																			T[1] +
																			' 100%); ' +
																			q),
																		B = "data-image=''"
																else
																	var N =
																			'background-color:' +
																			T[0] +
																			';' +
																			q,
																		B = "data-image=''"
															}
														}
														if (void 0 != m) {
															if (void 0 != s) {
																if ('both' == w)
																	var U =
																		"<div style='text-align:center;'><div class='swatch_tooltip_title'> " +
																		m +
																		"</div><div class='swatch_tooltip_data' style='width:100%;padding-top:100%;" +
																		N +
																		"'></div></div>"
																else
																	U =
																		'image_only' == w
																			? "<div style='text-align:center;'><div class='swatch_tooltip_data' style='width:100%;padding-top:100%;" +
																			  N +
																			  "'></div></div>"
																			: "<div style='text-align:center;'><div class='swatch_tooltip_title'> " +
																			  m +
																			  '</div></div>'
															} else
																U =
																	"<div style='text-align:center;'><div class='swatch_tooltip_title'> " +
																	m +
																	'</div></div>'
														} else U = "<div style='text-align:center;'><div class='swatch_tooltip_title'></div></div>"
														if (
															((tooltip_val =
																"<div class='hulkapps-tooltip-inner swatch-tooltip' style='width:200px;'><div>" +
																U +
																'</div></div>'),
															(tooltip_display_html =
																1 == parseInt(C)
																	? tooltip_val
																	: ''),
															(swatch_with_text =
																1 == parseInt(A) ? n : ''),
															'0' == t && '' == g)
														) {
															var M = 0
															t3 = !0
														} else if ('0' != t && !1 == t3) {
															var M = 0
															t3 = !0
														} else var M = -1
														;(tS +=
															"<label aria-label='" +
															e[0].toString().trim() +
															' ' +
															r +
															"' tabindex='" +
															M +
															"' class='hulkapps_swatch_option " +
															g +
															' ' +
															tr +
															' ' +
															td +
															' ' +
															$ +
															"' ><div class='hulkapps-tooltip " +
															_ +
															"'>" +
															tooltip_display_html +
															"<div class='  '><div id='" +
															ti +
															'_' +
															t1 +
															"' data-single_valid-class='swatch_render' data-val-selected-class='swatch_selected' data-radio-class='swatch_radio' data-hidden-class='hulk_swatch_hidden_prop' data-oid='" +
															ti +
															"' data-option-key='rb_" +
															ti +
															'_' +
															t1 +
															"' class='hulk_po_radio hulkapps_option_child " +
															c +
															' hulkapps_option_' +
															ti +
															' ' +
															u +
															" '  data-price='" +
															d +
															"' data-conditional-value='" +
															e[0].toString().trim() +
															"' data-parent='hulkapps_product_options' data-pid='" +
															i.pid +
															"' value='" +
															e[0].toString().trim() +
															"' style='" +
															y +
															x +
															N +
															"' " +
															_ +
															"><input name='hulk_swatch_" +
															ti +
															"' type='radio'  data-hinventory='" +
															L +
															"' " +
															k +
															" value='" +
															e[0].toString().trim() +
															p +
															"' class=' swatch_radio' " +
															f +
															" style='display:none;' " +
															B +
															" ></div></div></div><div style='display: inline-block;vertical-align: middle;margin-left: 10px;'>" +
															swatch_with_text +
															'</div>' +
															O +
															'</label>'),
															(t1 += 1)
													})
													var tw = ''
													tg &&
														(tw =
															"<input type='hidden' name='properties[_hin_" +
															m +
															'_hin_' +
															v +
															"]' value='" +
															ty +
															"' class='hulk_unique_prop' data-unique_prop_name='_hin_" +
															m +
															'_hin_' +
															v +
															"' />"),
														(tS += tw),
														checkPlan('quantity_selector', 'boolean') &&
															J &&
															(tS +=
																"<input style='display: " +
																tb +
																"'type='number' min='1' value='1' data-parent='hulkapps_product_options' data-pid='" +
																i.pid +
																"' class='hulk_options_quantity hulk_po_swatch_quantity'  id='quantity_" +
																ti +
																"'/>"),
														(tS +=
															"<input type='hidden' name='properties[" +
															v +
															"]' value='" +
															tx +
															"' class='hulk_swatch_hidden_prop'/></div></div>"),
														checkPlan(
															'image_change_based_on_option_value',
															'boolean'
														) &&
															!0 == V &&
															'' != K &&
															(tS +=
																"<script>(function($) {$('.hulkapps_product_options .hulkapps_option_" +
																ti +
																"').change(function() { var option_val  = $(this).data('conditional-value');$('" +
																K +
																"').each(function(){data_title = $(this).attr('alt');if(option_val === data_title){$(this).click();}});});;}(hulkapps_jQuery))</script>"),
														(W += tS)
												} else if ('color_image_dropdown' == R) {
													if (
														checkPlan('color_image_dropdown', 'boolean')
													) {
														;(tS =
															"<div class='hulkapps_option ci_render dd_render " +
															t$ +
															' ' +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															' data-parent-id= ' +
															ti +
															'>'),
															(tS +=
																"<div aria-label='" +
																v +
																"' tabindex='0' aria-required='" +
																tu +
																" ' class='hulkapps_option_name' data-option-name='" +
																v +
																"'>" +
																v +
																' ' +
																tc +
																' ' +
																tv +
																' ' +
																tf +
																'</div>'),
															(tS +=
																"<div class='hulkapps_option_value hulkapps_product_options_ul_parent'>"),
															(tS +=
																"<ul data-parent='hulkapps_product_options' data-pid='" +
																i.pid +
																"'  data-val-selected-class='dropdown_selected' class='hulkapps_option_child hulkapps_product_options_ul hulkapps_option_" +
																ti +
																"_visible hulkapps_full_width hulkapps_dd ' data-option-key='dd_" +
																ti +
																"' id='" +
																ti +
																"' >")
														var t2 = ''
														t2 =
															'' == D
																? "<li tabindex='0' value='' class='init'>Choose " +
																  v +
																  '</li>'
																: "<li value='' tabindex='0' class='init'>" +
																  D +
																  '</li>'
														var t5 = '',
															tg = !1,
															ty = '',
															tx = '',
															tb = 'none',
															t3 = !1
														t.each(te, function (t, e) {
															var a = 'image'
															'color' == e[2] && (a = 'color')
															var o = e[3],
																n = e[1]
															'percentage_charge' == e[9] &&
																null != n &&
																'' != n &&
																((n =
																	((parseFloat(product_price) /
																		100) *
																		n) /
																	100),
																(n = parseFloat(n.toFixed(2))))
															var l =
																	null != n && '' != n
																		? ' [ ' +
																		  i.currency_symbol +
																		  n +
																		  ' ]'
																		: '',
																s =
																	null != n && '' != n && 0 == P
																		? ' (+' +
																		  i.currency_symbol +
																		  n +
																		  ')'
																		: '',
																p =
																	null != n && '' != n
																		? n
																		: '0.00',
																r = e[4],
																d = !0 == r ? 'selected' : '',
																u = '' != p ? 'price-change' : '',
																h = '',
																c = '',
																f = ''
															let m =
																	'' != e[5] && null != e[5]
																		? e[5]
																		: '',
																g = parseInt(e[6])
															var b = ''
															let y =
																	'' != e[7] && null != e[7]
																		? e[7]
																		: '',
																x =
																	'' != e[8] && null != e[8]
																		? e[8]
																		: ''
															var _ =
																	'' != e[10] && null != e[10]
																		? e[10]
																		: '',
																w = '',
																C = 'disabled'
															if (
																(checkPlan(
																	'inventory_and_sku_management',
																	'boolean'
																) &&
																	('true' == m.toString() &&
																		'true' != y.toString() &&
																		g <= 0 &&
																		('true' == x.toString()
																			? ((c = 'disabled'),
																			  (h =
																					'is_hulk_disabled'),
																			  (d = ''))
																			: ((f = 'is_hulk_hide'),
																			  (c = 'disabled'),
																			  (d = ''))),
																	'true' == m.toString() &&
																		(tg = !0),
																	'true' == m.toString() &&
																		'true' != y.toString() &&
																		((b = g),
																		!0 == r &&
																			'' == c &&
																			(ty =
																				e[0]
																					.toString()
																					.trim() +
																				l +
																				'_hin_' +
																				b)),
																	((!0 == r &&
																		g > 0 &&
																		'true' != y.toString()) ||
																		(!0 == r &&
																			g <= 0 &&
																			'true' ==
																				y.toString())) &&
																		(C = ''),
																	'' != _ &&
																		(w =
																			"<input type='hidden' name='properties[_SKU_" +
																			v +
																			'(' +
																			e[0].toString().trim() +
																			")]' value='" +
																			_ +
																			"' class='hulk_unique_sku' " +
																			C +
																			'>')),
																(tr = ''),
																(td = ''),
																Object.keys(tl).length > 0)
															)
																for (let q in tl)
																	tl.hasOwnProperty(q) &&
																		Array.isArray(tl[q]) &&
																		tl[q].includes(
																			e[0].toString().trim()
																		) &&
																		((tr += ` ${q} `),
																		(td = tp))
															if ('0' == t && '' == f) {
																var S = 0
																t3 = !0
															} else if ('0' != t && !1 == t3) {
																var S = 0
																t3 = !0
															} else var S = -1
															!0 == r &&
																((tx = e[0].toString().trim() + l),
																(tb = 'block'),
																(t2 =
																	"<li aria-label='" +
																	e[0].toString().trim() +
																	"' tabindex='" +
																	S +
																	"' value='' class='init'><span class='dropdown-text'>" +
																	e[0].toString().trim() +
																	s +
																	'</span>'),
																(t2 =
																	'image' == a
																		? t2 +
																		  "<span class='dropdown_img " +
																		  $ +
																		  "'><img class='' src=" +
																		  o +
																		  '></span></li>'
																		: t2 +
																		  "<span class='dropdown_color " +
																		  $ +
																		  "' style='background-color: " +
																		  o +
																		  "'></span></li>")),
																(t5 =
																	t5 +
																	"<li aria-label='" +
																	e[0].toString().trim() +
																	l +
																	"' tabindex='" +
																	S +
																	"'  class='dropdown_swatch " +
																	k +
																	' ' +
																	h +
																	' ' +
																	u +
																	' ' +
																	tr +
																	' ' +
																	td +
																	' ' +
																	f +
																	"' " +
																	d +
																	" data-hinventory='" +
																	b +
																	"' " +
																	c +
																	" data-price='" +
																	p +
																	"' data-conditional-value='" +
																	e[0].toString().trim() +
																	"' data-value='" +
																	e[0].toString().trim() +
																	l +
																	"' value='" +
																	e[0].toString().trim() +
																	l +
																	"'><span class='dropdown-text'>" +
																	e[0].toString().trim() +
																	s +
																	'</span>'),
																(t5 =
																	'image' == a
																		? t5 +
																		  "<span class='dropdown_img " +
																		  $ +
																		  "'><img class='' src=" +
																		  o +
																		  '></span>' +
																		  w +
																		  '</li>'
																		: t5 +
																		  "<span class='dropdown_color " +
																		  $ +
																		  "' style='background-color: " +
																		  o +
																		  "'></span>" +
																		  w +
																		  '</li>')
														}),
															(tS = tS + t2 + t5)
														var tw = ''
														tg &&
															(tw =
																"<input type='hidden' name='properties[_hin_" +
																m +
																'_hin_' +
																v +
																"]' value='" +
																ty +
																"' class='hulk_unique_prop' data-unique_prop_name='_hin_" +
																m +
																'_hin_' +
																v +
																"'/>"),
															(tS +=
																"<input class='hulk_opt_prop' type='hidden' name='properties[" +
																v +
																"]'  value='" +
																tx +
																"'/></ul>"),
															checkPlan(
																'quantity_selector',
																'boolean'
															) &&
																J &&
																(tS +=
																	"<input style='display: " +
																	tb +
																	"' type='number' min='1' value='1' class='hulk_options_quantity' id='quantity_" +
																	ti +
																	"'/>"),
															(tS += tw + '</div></div>'),
															(W += tS)
													}
												} else if ('button' == R) {
													if (checkPlan('button_option', 'boolean')) {
														var t7 = 0,
															tS =
																"<div class='hulkapps_option button_render " +
																t$ +
																' ' +
																to +
																' ' +
																t8 +
																' ' +
																th +
																' option_type_id_' +
																ti +
																' ' +
																ta +
																' ' +
																T +
																"' " +
																I +
																" data-parent-id='" +
																ti +
																"' >"
														;(tS +=
															"<div aria-label='" +
															v +
															"' tabindex='0' aria-required='" +
															tu +
															" ' class='hulkapps_option_name'>" +
															v +
															' ' +
															tc +
															' ' +
															tv +
															' ' +
															tf +
															'</div>'),
															(tS +=
																"<div class='hulkapps_option_value'>")
														var tg = !1,
															ty = '',
															tx = '',
															tb = 'none',
															t3 = !1
														t.each(te, function (t, e) {
															if (
																((tr = ''),
																(td = ''),
																Object.keys(tl).length > 0)
															)
																for (let a in tl)
																	tl.hasOwnProperty(a) &&
																		Array.isArray(tl[a]) &&
																		tl[a].includes(
																			e[0].toString().trim()
																		) &&
																		((tr += ` ${a} `),
																		(td = tp))
															var o = e[1]
															'percentage_charge' == e[9] &&
																null != o &&
																'' != o &&
																((o =
																	((parseFloat(product_price) /
																		100) *
																		o) /
																	100),
																(o = parseFloat(o.toFixed(2)))),
																'' != e[0] && e[0]
															var n = '' != e[2] ? e[2] : '',
																l =
																	null != o && '' != o
																		? ' [ ' +
																		  i.currency_symbol +
																		  o +
																		  ' ]'
																		: '',
																s =
																	null != o && '' != o && 0 == P
																		? ' (+' +
																		  i.currency_symbol +
																		  o +
																		  ')'
																		: '',
																p =
																	null != o && '' != o
																		? o
																		: '0.00',
																r = '' != p ? 'price-change' : '',
																d = e[4]
															!0 == d &&
																((tx = e[0].toString().trim() + l),
																(tb = 'block'))
															var u =
																	!0 == d
																		? 'button_selected'
																		: '',
																h = !0 == d ? 'checked' : '',
																c = '',
																f = '',
																m = ''
															let k =
																	'' != e[5] && null != e[5]
																		? e[5]
																		: '',
																$ = parseInt(e[6])
															var g = ''
															let b =
																	'' != e[7] && null != e[7]
																		? e[7]
																		: '',
																y =
																	'' != e[8] && null != e[8]
																		? e[8]
																		: ''
															var x =
																	'' != e[10] && null != e[10]
																		? e[10]
																		: '',
																_ = '',
																w = 'disabled'
															checkPlan(
																'inventory_and_sku_management',
																'boolean'
															) &&
																('true' == k.toString() &&
																	'true' != b.toString() &&
																	$ <= 0 &&
																	('true' == y.toString()
																		? ((c = 'is_hulk_disabled'),
																		  (f = 'disabled'),
																		  (r = ''),
																		  (u = ''))
																		: ((m = 'is_hulk_hide'),
																		  (f = 'disabled'),
																		  (r = ''),
																		  (u = ''))),
																'true' == k.toString() && (tg = !0),
																'true' == k.toString() &&
																	'true' != b.toString() &&
																	((g = $),
																	!0 == d &&
																		'' == m &&
																		'' == f &&
																		(ty =
																			e[0].toString().trim() +
																			l +
																			'_hin_' +
																			g)),
																((!0 == d &&
																	$ > 0 &&
																	'true' != b.toString()) ||
																	(!0 == d &&
																		$ <= 0 &&
																		'true' == b.toString())) &&
																	(w = ''),
																'' != x &&
																	(_ =
																		"<input type='hidden' name='properties[_SKU_" +
																		v +
																		'(' +
																		e[0].toString().trim() +
																		")]' value='" +
																		x +
																		"' class='hulk_unique_sku'" +
																		w +
																		' />'))
															var q = e[0] + ' <br> ' + s
															if (
																((titlee =
																	void 0 != q
																		? "<div style='text-align:center;'><div class='button_tooltip_title'> " +
																		  q +
																		  '</div></div>'
																		: "<div style='text-align:center;'><div class='button_tooltip_title'></div></div>"),
																(tooltip_val =
																	"<div class='hulkapps-tooltip-inner button-tooltip'>" +
																	q +
																	'</div>'),
																(tooltip_display_html =
																	1 == parseInt(C)
																		? tooltip_val
																		: ''),
																'0' == t && '' == m)
															) {
																var S = 0
																t3 = !0
															} else if ('0' != t && !1 == t3) {
																var S = 0
																t3 = !0
															} else var S = -1
															;(tS +=
																"<label aria-label='" +
																e[0].toString().trim() +
																' ' +
																s +
																"'  tabindex='" +
																S +
																"' class='hulkapps_buton_option " +
																m +
																' ' +
																c +
																"'><div class='hulkapps-tooltip'>" +
																tooltip_display_html +
																"<div class='" +
																tr +
																' ' +
																td +
																" '><div id='" +
																ti +
																'_' +
																t7 +
																"' data-option-key='rb_" +
																ti +
																'_' +
																t7 +
																"' class='hulkapps_option_child " +
																u +
																' hulkapps_option_' +
																ti +
																' ' +
																r +
																" hulk_po_radio'  data-hidden-class='hulk_button_hidden_prop'  data-single_valid-class='button_render' data-val-selected-class='button_selected' data-radio-class='button_radio' data-oid='" +
																ti +
																"' data-pid='" +
																i.pid +
																"' data-parent='hulkapps_product_options' data-price='" +
																p +
																"' data-conditional-value='" +
																e[0].toString().trim() +
																"' value='" +
																e[0].toString().trim() +
																"' style='" +
																L +
																j +
																E +
																"'><input name='hulk_button_" +
																ti +
																"' type='radio' " +
																f +
																" data-hinventory='" +
																g +
																"' value='" +
																e[0].toString().trim() +
																l +
																"' class=' button_radio' " +
																h +
																" style='display:none;'><span>" +
																n +
																'</span></div></div></div>' +
																_ +
																'</label>'),
																(t7 += 1)
														})
														var tw = ''
														tg &&
															(tw =
																"<input type='hidden' name='properties[_hin_" +
																m +
																'_hin_' +
																v +
																"]' value='" +
																ty +
																"' class='hulk_unique_prop' data-unique_prop_name='_hin_" +
																m +
																'_hin_' +
																v +
																"'/>"),
															(tS += tw),
															checkPlan(
																'quantity_selector',
																'boolean'
															) &&
																J &&
																(tS +=
																	"<input style='display: " +
																	tb +
																	"' type='number' min='1' value='1' class='hulk_options_quantity hulk_po_button_quantity' data-parent='hulkapps_product_options' data-pid='" +
																	i.pid +
																	"' id='quantity_" +
																	ti +
																	"'/>"),
															(tS +=
																"<input type='hidden' name='properties[" +
																v +
																"]' value='" +
																tx +
																"' class='hulk_button_hidden_prop'/></div></div>"),
															checkPlan(
																'image_change_based_on_option_value',
																'boolean'
															) &&
																!0 == V &&
																'' != K &&
																(tS +=
																	"<script>(function($) {$('.hulkapps_product_options .hulkapps_option_" +
																	ti +
																	"').change(function() { var option_val  = $(this).data('conditional-value');$('" +
																	K +
																	"').each(function(){data_title = $(this).attr('alt');if(option_val === data_title){$(this).click();}});});;}(hulkapps_jQuery))</script>"),
															(W += tS)
													}
												} else if ('swatch_multiple' == R) {
													var tC =
															void 0 != Q &&
															void 0 != Q.minimum_selection &&
															'' != Q &&
															'' != Q.minimum_selection
																? Q.minimum_selection.toString()
																: '0',
														t9 =
															void 0 != Q &&
															void 0 != Q.maximum_selection &&
															'' != Q &&
															'' != Q.maximum_selection
																? Q.maximum_selection.toString()
																: '0',
														t1 = 0,
														tq =
															'0' != tC &&
															'0' != t9 &&
															checkPlan(
																'validation_for_min_max_option_selection',
																'boolean'
															)
																? '<span aria-label="Choose from ' +
																  tC +
																  ' to ' +
																  t9 +
																  ' values" tabindex="0" class="selection-text">[Choose from ' +
																  tC +
																  ' to ' +
																  t9 +
																  ' values]</span>'
																: '0' != tC &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  )
																? '<span aria-label="Choose at least ' +
																  tC +
																  ' values" tabindex="0" class="selection-text">[Choose at least ' +
																  tC +
																  ' values]</span>'
																: '0' != t9 &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  )
																? '<span aria-label="Choose upto ' +
																  t9 +
																  ' values" tabindex="0" class="selection-text">[Choose upto ' +
																  t9 +
																  ' values]</span>'
																: '',
														tS =
															"<div class='hulkapps_option multiswatch_render " +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"' >"
													;(tS +=
														"<div aria-label='" +
														v +
														"' tabindex='0' aria-required='" +
														tu +
														" ' class='hulkapps_option_name'><div>" +
														v +
														' ' +
														tc +
														' ' +
														tv +
														' </div> ' +
														tq +
														' ' +
														tf +
														'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'>")
													var tx = [],
														t0 = 0,
														ty = [],
														t3 = !1
													t.each(te, function (t, e) {
														if (
															((tr = ''),
															(td = ''),
															Object.keys(tl).length > 0)
														)
															for (let a in tl)
																tl.hasOwnProperty(a) &&
																	Array.isArray(tl[a]) &&
																	tl[a].includes(
																		e[0].toString().trim()
																	) &&
																	((tr += ` ${a} `), (td = tp))
														var o = e[1]
														'percentage_charge' == e[9] &&
															null != o &&
															'' != o &&
															((o =
																((parseFloat(product_price) / 100) *
																	o) /
																100),
															(o = parseFloat(o.toFixed(2))))
														var n = '' != e[0] ? e[0] : '',
															l = '' != e[2] ? e[2] : '',
															s = '' != e[3] ? e[3] : '',
															p =
																null != o && '' != o
																	? ' [ ' +
																	  i.currency_symbol +
																	  o +
																	  ' ]'
																	: '',
															r =
																null != o && '' != o && 0 == P
																	? ' (+' +
																	  i.currency_symbol +
																	  o +
																	  ')'
																	: '',
															d = null != o && '' != o ? o : '0.00',
															u = '' != d ? 'price-change' : '',
															h = e[4]
														!0 == h &&
															((t0 += 1),
															tx.push(e[0].toString().trim() + p))
														var c = !0 == h ? 'swatch_selected' : '',
															f = !0 == h ? 'checked' : '',
															m =
																'<p>' +
																e[0] +
																' <br> ' +
																r +
																'</p>',
															k = '',
															$ = '',
															g = ''
														let b =
																'' != e[5] && null != e[5]
																	? e[5]
																	: '',
															S = parseInt(e[6])
														var L = ''
														let j =
																'' != e[7] && null != e[7]
																	? e[7]
																	: '',
															E =
																'' != e[8] && null != e[8]
																	? e[8]
																	: ''
														var F =
																'' != e[10] && null != e[10]
																	? e[10]
																	: '',
															O = '',
															z = 'disabled'
														checkPlan(
															'inventory_and_sku_management',
															'boolean'
														) &&
															('true' == b.toString() &&
																'true' != j.toString() &&
																S <= 0 &&
																('true' == E.toString()
																	? (($ = 'disabled'),
																	  (k = 'is_hulk_disabled'),
																	  (u = ''),
																	  (c = ''),
																	  tx.pop(
																			e[0].toString().trim() +
																				p
																	  ))
																	: ((g = 'is_hulk_hide'),
																	  ($ = 'disabled'),
																	  (u = ''),
																	  (c = ''),
																	  tx.pop(
																			e[0].toString().trim() +
																				p
																	  ))),
															'true' == b.toString() && (tg = !0),
															'true' == b.toString() &&
																'true' != j.toString() &&
																((L = S),
																!0 == h &&
																	'' == g &&
																	'' == $ &&
																	ty.push(
																		e[0].toString().trim() +
																			p +
																			'_hin_' +
																			L
																	)),
															((!0 == h &&
																S > 0 &&
																'true' != j.toString()) ||
																(!0 == h &&
																	S <= 0 &&
																	'true' == j.toString())) &&
																(z = ''),
															'' != F &&
																(O =
																	"<input type='hidden' name='properties[_SKU_" +
																	v +
																	'(' +
																	e[0].toString().trim() +
																	")]' value='" +
																	F +
																	"' class='hulk_unique_sku' " +
																	z +
																	'/>'))
														var I = ''
														if ('image' == l)
															(N =
																'background-image:url(' +
																s +
																');background-size:cover;background-position: center center;' +
																q),
																(B = "data-image='" + s + "'"),
																(I = s)
														else {
															try {
																var T = s.split(',')
															} catch (D) {
																T = null
															}
															if (null != T) {
																if (null != T[1])
																	var N = (swatch_color_dual_ton =
																			'background: linear-gradient(to bottom, ' +
																			T[0] +
																			' 0%, ' +
																			T[0] +
																			' 50%, ' +
																			T[1] +
																			' 50%, ' +
																			T[1] +
																			' 100%); ' +
																			q),
																		B = "data-image=''"
																else
																	var N =
																			'background-color:' +
																			T[0] +
																			';' +
																			q,
																		B = "data-image=''"
															}
														}
														if (void 0 != m) {
															if ('' != s) {
																if ('both' == w)
																	var U =
																		"<div style='text-align:center;'><div class='multiswatch_tooltip_title'> " +
																		m +
																		"</div><div class='multiswatch_tooltip_data' style='width:100%;padding-top:100%;" +
																		N +
																		"'></div></div>"
																else
																	U =
																		'image_only' == w
																			? "<div style='text-align:center;'><div class='multiswatch_tooltip_data' style='width:100%;padding-top:100%;" +
																			  N +
																			  "'></div></div>"
																			: "<div style='text-align:center;'><div class='multiswatch_tooltip_title'> " +
																			  m +
																			  '</div></div>'
															} else
																U =
																	"<div style='text-align:center;'><div class='multiswatch_tooltip_title'> " +
																	m +
																	'</div></div>'
														} else U = "<div style='text-align:center;'><div class='swatch_tooltip_title'></div></div>"
														if (
															((tooltip_val =
																"<div class='hulkapps-tooltip-inner multiswatch-tooltip' style='width:200px;'><div>" +
																U +
																'</div></div>'),
															(tooltip_display_html =
																1 == parseInt(C)
																	? tooltip_val
																	: ''),
															(swatch_with_text =
																1 == parseInt(A) ? n : ''),
															'0' == t && '' == g)
														) {
															var M = 0
															t3 = !0
														} else if ('0' != t && !1 == t3) {
															var M = 0
															t3 = !0
														} else var M = -1
														;(tS +=
															"<label aria-label='" +
															e[0].toString().trim() +
															' ' +
															r +
															"' tabindex='" +
															M +
															"' class='hulkapps_mswatch_option " +
															tr +
															' ' +
															td +
															' ' +
															g +
															' ' +
															k +
															"'><div class='hulkapps-tooltip " +
															_ +
															"'>" +
															tooltip_display_html +
															"<div class=''><div id='" +
															ti +
															'_' +
															t1 +
															"' data-option-key='rb_" +
															ti +
															'_' +
															t1 +
															"' data-oid='" +
															ti +
															"' data-min='" +
															tC +
															"' data-single_valid-class='multiswatch_render' data-max='" +
															t9 +
															"' data-parent='hulkapps_product_options' data-pid='" +
															i.pid +
															"' class='hulk_po_checkbox hulkapps_option_child  " +
															c +
															' hulkapps_option_' +
															ti +
															' ' +
															u +
															"'  data-price=" +
															d +
															" data-conditional-value='" +
															e[0].toString().trim() +
															"' value='" +
															e[0].toString().trim() +
															"' style='" +
															y +
															x +
															N +
															"' " +
															_ +
															"><input type='checkbox'  data-conditional-value='" +
															e[0].toString().trim() +
															"' data-price=" +
															d +
															" data-hinventory='" +
															L +
															"' " +
															$ +
															" id='" +
															ti +
															"' value='" +
															e[0].toString().trim() +
															p +
															"' class='hulk_po_swatch_multiple_checkbox swatch_checkbox hulkapps_option_child hulkapps_option_" +
															ti +
															'_visible ' +
															u +
															" ' " +
															f +
															" style='display:none !important;' " +
															B +
															" ></div></div></div><div style='display: inline-block;vertical-align: middle;margin-left: 10px;'>" +
															swatch_with_text +
															'</div>' +
															O +
															'</label>'),
															(t1 += 1)
													}),
														1 == S &&
															(tS +=
																'var swatch_image_url = ' +
																t(this)
																	.find('.swatch_radio')
																	.attr('data-image') +
																'if (' +
																swatch_image_url +
																" != ''){$('.hulkapps_swatch_image_change img').attr('src'," +
																swatch_image_url +
																");$('.hulkapps_swatch_image_change img').attr('srcset'," +
																swatch_image_url +
																");$('.hulkapps_swatch_image_change img').attr('data-srcset'," +
																swatch_image_url +
																');}'),
														t0 > 0 &&
															('0' != tC &&
															'0' != t9 &&
															checkPlan(
																'validation_for_min_max_option_selection',
																'boolean'
															)
																? (parseInt(t0) < parseInt(tC) ||
																		parseInt(t0) >
																			parseInt(t9)) &&
																  (tS +=
																		'<span class="validation_error error_span">Choose from ' +
																		tC +
																		' to ' +
																		t9 +
																		' values</span>')
																: '0' != tC &&
																  '0' == t9 &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  )
																? parseInt(t0) < parseInt(tC) &&
																  (tS +=
																		'<span class="validation_error error_span">Choose at least ' +
																		tC +
																		' values</span>')
																: '0' == tC &&
																  '0' != t9 &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  ) &&
																  parseInt(t0) > parseInt(t9) &&
																  (tS +=
																		'<span class="validation_error error_span">Choose upto ' +
																		t9 +
																		' values</span>'))
													var tw = ''
													tg &&
														(tw =
															"<input type='hidden' name='properties[_hin_" +
															m +
															'_hin_' +
															v +
															"]'  value='" +
															ty +
															"' class='hulk_unique_prop' data-unique_prop_name='_hin_" +
															m +
															'_hin_' +
															v +
															"' data-selection-multi='true'/>"),
														(tS += tw),
														(tS +=
															"<input class='hulkapps_option_child' value='" +
															tx.join(', ') +
															"' type='hidden' id='hulkapps_option_" +
															ti +
															"_hidden' name='properties[" +
															v +
															"]'></div></div>"),
														(W += tS)
												} else if ('checkbox' == R) {
													var tC =
															void 0 != Q &&
															'' != Q &&
															void 0 != Q.minimum_selection &&
															'' != Q.minimum_selection
																? Q.minimum_selection.toString()
																: '0',
														t9 =
															void 0 != Q &&
															'' != Q &&
															void 0 != Q.maximum_selection &&
															'' != Q.maximum_selection
																? Q.maximum_selection.toString()
																: '0',
														tA = 1 == parseInt(c) ? 'single_line' : '',
														tq =
															'0' != tC &&
															'0' != t9 &&
															checkPlan(
																'validation_for_min_max_option_selection',
																'boolean'
															)
																? '<span aria-label="Choose from ' +
																  tC +
																  ' to ' +
																  t9 +
																  ' values" tabindex="0" class="selection-text">[Choose from ' +
																  tC +
																  ' to ' +
																  t9 +
																  ' values]</span>'
																: '0' != tC &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean',
																		i.plan_id,
																		i.plans_features
																  )
																? '<span aria-label="Choose at least ' +
																  tC +
																  ' values" tabindex="0"  class="selection-text">[Choose at least ' +
																  tC +
																  ' values]</span>'
																: '0' != t9 &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  )
																? '<span aria-label="Choose upto ' +
																  t9 +
																  ' values" tabindex="0" class="selection-text">[Choose upto ' +
																  t9 +
																  ' values]</span>'
																: '',
														tS =
															"<div class='hulkapps_option cb_render " +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' ' +
															tA +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"' data-min='" +
															tC +
															"' data-max='" +
															t9 +
															"'>"
													;(tS +=
														"<div aria-label='" +
														v +
														"' tabindex='0' aria-required='" +
														tu +
														" ' class='hulkapps_option_name'><div>" +
														v +
														' ' +
														tc +
														' ' +
														tv +
														'  </div>' +
														tq +
														' ' +
														tf +
														'</div>'),
														(tS +=
															"<div class='hulkapps_option_value hulkapps_product_page_options'>")
													var tx = [],
														t0 = 0,
														ty = [],
														t3 = !1
													t.each(te, function (t, e) {
														if (
															((tr = ''),
															(td = ''),
															Object.keys(tl).length > 0)
														)
															for (let a in tl)
																tl.hasOwnProperty(a) &&
																	Array.isArray(tl[a]) &&
																	tl[a].includes(
																		e[0].toString().trim()
																	) &&
																	((tr += ` ${a} `), (td = tp))
														var o = e[1]
														'percentage_charge' == e[9] &&
															null != o &&
															'' != o &&
															((o =
																((parseFloat(product_price) / 100) *
																	o) /
																100),
															(o = parseFloat(o.toFixed(2))))
														var n =
																null != o && '' != o
																	? ' [ ' +
																	  i.currency_symbol +
																	  o +
																	  ' ]'
																	: '',
															l =
																null != o && '' != o && 0 == P
																	? ' (+' +
																	  i.currency_symbol +
																	  o +
																	  ')'
																	: '',
															s = null != o && '' != o ? o : '0.00',
															p = e[4]
														!0 == p &&
															((t0 += 1),
															tx.push(e[0].toString().trim() + n))
														var r = !0 == p ? 'checked' : '',
															d = '' != s ? 'price-change' : '',
															u = '',
															h = '',
															c = ''
														let f =
																'' != e[5] && null != e[5]
																	? e[5]
																	: '',
															m = parseInt(e[6])
														var k = ''
														let $ =
																'' != e[7] && null != e[7]
																	? e[7]
																	: '',
															g =
																'' != e[8] && null != e[8]
																	? e[8]
																	: ''
														var b =
																'' != e[10] && null != e[10]
																	? e[10]
																	: '',
															y = '',
															x = 'disabled'
														if (
															(checkPlan(
																'inventory_and_sku_management',
																'boolean'
															) &&
																('true' == f.toString() &&
																	'true' != $.toString() &&
																	m <= 0 &&
																	('true' == g.toString()
																		? ((u = 'disabled'),
																		  (c = 'is_hulk_disabled'),
																		  (r = ''),
																		  (d = ''),
																		  !0 == p &&
																				tx.pop(
																					e[0]
																						.toString()
																						.trim() + n
																				))
																		: ((h = 'is_hulk_hide'),
																		  (r = ''),
																		  (d = ''),
																		  !0 == p &&
																				tx.pop(
																					e[0]
																						.toString()
																						.trim() + n
																				))),
																'true' == f.toString() && (tg = !0),
																'true' == f.toString() &&
																	'true' != $.toString() &&
																	((k = m),
																	!0 == p &&
																		'' == h &&
																		'' == u &&
																		ty.push(
																			e[0].toString().trim() +
																				n +
																				'_hin_' +
																				k
																		)),
																((!0 == p &&
																	m > 0 &&
																	'true' != $.toString()) ||
																	(!0 == p &&
																		m <= 0 &&
																		'true' == $.toString())) &&
																	(x = ''),
																'' != b &&
																	(y =
																		"<input type='hidden' name='properties[_SKU_" +
																		v +
																		'(' +
																		e[0].toString().trim() +
																		")]' value='" +
																		b +
																		"' class='hulk_unique_sku' " +
																		x +
																		'/>')),
															'0' == t && '' == h)
														) {
															var _ = 0
															t3 = !0
														} else if ('0' != t && !1 == t3) {
															var _ = 0
															t3 = !0
														} else var _ = -1
														tS +=
															"<label  aria-label='" +
															e[0].toString().trim() +
															' ' +
															l +
															"' tabindex='" +
															_ +
															"' class='hulkapps_check_option " +
															c +
															' ' +
															tr +
															' ' +
															td +
															' ' +
															h +
															"'><input type='checkbox' " +
															r +
															" data-option-key='cbm_" +
															ti +
															"' data-hinventory='" +
															k +
															"' " +
															u +
															" data-parent='hulkapps_product_options' data-pid='" +
															i.pid +
															"' data-single_valid-class='cb_render' data-min='" +
															tC +
															"' data-max='" +
															t9 +
															"' data-oid='" +
															ti +
															"' id='" +
															ti +
															"' class='  hulk_po_checkbox hulkapps_option_child hulkapps_option_" +
															ti +
															'_visible hulkapps_product_option_' +
															ti +
															'_visible ' +
															d +
															"' data-price='" +
															s +
															" '  data-conditional-value='" +
															e[0].toString().trim() +
															"' value='" +
															e[0].toString().trim() +
															n +
															'\'><div class=\'hulkapps-custom-check\'><svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.46989 6.79557L0.219933 4.69527C-0.073311 4.42153 -0.073311 3.97907 0.219933 3.70533C0.513177 3.43159 0.987167 3.43159 1.28041 3.70533L2.95738 5.27075L7.68078 0.244745C7.95078 -0.049296 8.42402 -0.0829008 8.73751 0.168435C9.0525 0.42047 9.08925 0.861532 8.81926 1.15487L3.56936 6.75566C3.43362 6.90408 3.23712 6.99229 3.02863 6.99999C2.80138 7.00069 2.61013 6.92718 2.46989 6.79557Z" fill="white" style="&#10;"/></svg></div>' +
															e[0].toString().trim() +
															l +
															y +
															' </label>'
													}),
														t0 > 0 &&
															('0' != tC &&
															'0' != t9 &&
															checkPlan(
																'validation_for_min_max_option_selection',
																'boolean'
															)
																? (parseInt(t0) < parseInt(tC) ||
																		parseInt(t0) >
																			parseInt(t9)) &&
																  (tS +=
																		'</select><span class="validation_error error_span">Choose from ' +
																		tC +
																		' to ' +
																		t9 +
																		' values</span>')
																: '0' != tC &&
																  '0' == t9 &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  )
																? parseInt(t0) < parseInt(tC) &&
																  (tS +=
																		'</select><span class="validation_error error_span">Choose at least ' +
																		tC +
																		' values</span>')
																: '0' == tC &&
																  '0' != t9 &&
																  checkPlan(
																		'validation_for_min_max_option_selection',
																		'boolean'
																  ) &&
																  parseInt(t0) > parseInt(t9) &&
																  (tS +=
																		'</select><span class="validation_error error_span">Choose upto ' +
																		t9 +
																		' values</span>'))
													var tw = ''
													tg &&
														(tw =
															"<input type='hidden' name='properties[_hin_" +
															m +
															'_hin_' +
															v +
															"]' value='" +
															ty +
															"' class='hulk_unique_prop' data-unique_prop_name='_hin_" +
															m +
															'_hin_' +
															v +
															"' data-selection-multi='true'/>"),
														(tS += tw),
														(tS +=
															"<input class='hulkapps_option_child' value='" +
															tx.join(', ') +
															"' type='hidden' id='hulkapps_option_" +
															ti +
															"_hidden' name='properties[" +
															v +
															"]'></div></div>"),
														(W += tS)
												} else if ('textbox' == R) {
													var t6 = '',
														tL =
															void 0 != Q &&
															checkPlan(
																'character_limit',
																'boolean'
															) &&
															'' != Q.character_limit &&
															void 0 != Q.character_limit
																? '[Maximum ' +
																  Q.character_limit +
																  ' character]'
																: '',
														tS =
															"<div class='hulkapps_option tb_render " +
															O +
															' ' +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"'>"
													;(tS +=
														"<div aria-label='" +
														v +
														"' tabindex='0' aria-required='" +
														tu +
														" ' class='hulkapps_option_name'><div>" +
														v +
														' ' +
														tc +
														' ' +
														tv +
														' </div> ' +
														tL +
														' ' +
														tf +
														'</div>'),
														'inlineLabels' == F && (D = v),
														'floatingLabels' == F && (D = ''),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, e) {
															var a = e[1]
															'percentage_charge' == e[9] &&
																null != a &&
																'' != a &&
																((a =
																	((parseFloat(product_price) /
																		100) *
																		a) /
																	100),
																(a = parseFloat(a.toFixed(2)))),
																null != a &&
																	'' != a &&
																	i.currency_symbol
															var o =
																	null != a && '' != a
																		? a
																		: '0.00',
																n = '',
																l = '' != o ? 'price-change' : ''
															void 0 != Q &&
																checkPlan(
																	'character_limit',
																	'boolean'
																) &&
																'' != Q.character_limit &&
																void 0 != Q.character_limit &&
																(n =
																	'maxlength=' +
																	Q.character_limit),
																(tS +=
																	"<input type='text' data-single_valid-class='tb_render' data-val-selected-class='textbox_selected'  data-option-key='tb_" +
																	ti +
																	"' id='" +
																	ti +
																	"' placeholder='" +
																	D +
																	"' data-parent='hulkapps_product_options' data-pid='" +
																	i.pid +
																	"' class='hulkapps_option_child hulk_po_other_options hulkapps_full_width hulkapps_option_" +
																	ti +
																	' ' +
																	l +
																	"' data-price='" +
																	o +
																	"' " +
																	n +
																	"><input type='hidden' name='properties[" +
																	v +
																	"]' class='tb_property_val other_options_prop_val'>"),
																'floatingLabels' == F &&
																	(tS +=
																		"<label class='floating_label'>" +
																		v +
																		'</label>'),
																void 0 != Q &&
																	checkPlan(
																		'character_limit',
																		'boolean'
																	) &&
																	'' != Q.character_limit &&
																	void 0 != Q.character_limit &&
																	(tS +=
																		"<input type='hidden' value='" +
																		Q.character_limit +
																		"' class='character_count'><div id='char_count_" +
																		ti +
																		"'>" +
																		Q.character_limit +
																		' ' +
																		i.display_settings
																			.charcter_count_message +
																		'</div>'),
																void 0 != Q &&
																	checkPlan(
																		'character_limit',
																		'boolean'
																	) &&
																	'' != Q.character_limit &&
																	void 0 != Q.character_limit &&
																	(t6 +=
																		"<script>(function($) {$(document).on('input', '.hulkapps_product_options .hulkapps_option_" +
																		ti +
																		"', function() { check_character_limit(" +
																		Q.character_limit +
																		",'" +
																		ti +
																		"','" +
																		i.display_settings
																			.charcter_count_message +
																		"','hulkapps_product_options');});}(hulkapps_jQuery))</script>")
														}),
														(W += tS = tS + t6 + '</div></div>')
												} else if ('textarea' == R) {
													var t6 = '',
														tL =
															void 0 != Q &&
															checkPlan(
																'character_limit',
																'boolean'
															) &&
															'' != Q.character_limit &&
															void 0 != Q.character_limit
																? '[Maximum ' +
																  Q.character_limit +
																  ' character]'
																: '',
														tS =
															"<div class='hulkapps_option ta_render " +
															O +
															' ' +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"'>"
													;(tS +=
														"<div aria-label='" +
														v +
														"' tabindex='0' aria-required='" +
														tu +
														" ' class='hulkapps_option_name'><div>" +
														v +
														' ' +
														tc +
														' ' +
														tv +
														' </div> ' +
														tL +
														' ' +
														tf +
														'</div>'),
														'inlineLabels' == F && (D = v),
														'floatingLabels' == F && (D = ''),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, e) {
															var a = e[1]
															'percentage_charge' == e[9] &&
																null != a &&
																'' != a &&
																((a =
																	((parseFloat(product_price) /
																		100) *
																		a) /
																	100),
																(a = parseFloat(a.toFixed(2)))),
																null != a &&
																	'' != a &&
																	i.currency_symbol
															var o =
																	null != a && '' != a
																		? a
																		: '0.00',
																n = '',
																l = '' != o ? 'price-change' : ''
															void 0 != Q &&
																checkPlan(
																	'character_limit',
																	'boolean'
																) &&
																'' != Q.character_limit &&
																void 0 != Q.character_limit &&
																(n =
																	'maxlength=' +
																	Q.character_limit),
																(tS +=
																	"<textarea placeholder='" +
																	D +
																	"' data-single_valid-class='ta_render' data-val-selected-class='textbox_selected' data-option-key='ta_" +
																	ti +
																	"' id='" +
																	ti +
																	"' data-pid='" +
																	i.pid +
																	"' data-parent='hulkapps_product_options' class='hulk_po_other_options hulkapps_option_child hulkapps_full_width hulkapps_option_" +
																	ti +
																	' ' +
																	l +
																	"' data-price='" +
																	o +
																	"' " +
																	n +
																	'></textarea>'),
																'floatingLabels' == F &&
																	(tS +=
																		"<label class='floating_label'>" +
																		v +
																		'</label>'),
																(tS +=
																	"<input type='hidden' name='properties[" +
																	v +
																	"]' class='ta_property_val other_options_prop_val'>"),
																void 0 != Q &&
																	checkPlan(
																		'character_limit',
																		'boolean'
																	) &&
																	'' != Q.character_limit &&
																	void 0 != Q.character_limit &&
																	(tS +=
																		"<input type='hidden' value='" +
																		Q.character_limit +
																		"' class='character_count'><div id='char_count_" +
																		ti +
																		"'>" +
																		Q.character_limit +
																		' ' +
																		i.display_settings
																			.charcter_count_message +
																		'</div>'),
																void 0 != Q &&
																	checkPlan(
																		'character_limit',
																		'boolean'
																	) &&
																	'' != Q.character_limit &&
																	void 0 != Q.character_limit &&
																	(t6 +=
																		"<script>(function($) {$(document).on('input', '.hulkapps_product_options .hulkapps_option_" +
																		ti +
																		"', function() { check_character_limit(" +
																		Q.character_limit +
																		",'" +
																		ti +
																		"','" +
																		i.display_settings
																			.charcter_count_message +
																		"','hulkapps_product_options');});}(hulkapps_jQuery))</script>")
														}),
														(W += tS = tS + t6 + '</div></div>')
												} else if ('radiobutton' == R) {
													var t4 = 0,
														tA = 1 == parseInt(c) ? 'single_line' : ''
													;(tS =
														"<div class='hulkapps_option rb_render " +
														t$ +
														'  ' +
														to +
														' ' +
														t8 +
														' ' +
														th +
														' ' +
														tA +
														'  option_type_id_' +
														ti +
														' ' +
														ta +
														' ' +
														T +
														"' " +
														I +
														" data-parent-id='" +
														ti +
														"' >"),
														(tS +=
															"<div aria-label='" +
															v +
															"' tabindex='0' aria-required='" +
															tu +
															" ' class='hulkapps_option_name'>" +
															v +
															' ' +
															tc +
															' ' +
															tv +
															' ' +
															tf +
															'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'>")
													var ty = '',
														tx = '',
														tb = 'none',
														t3 = !1
													t.each(te, function (t, e) {
														if (
															((tr = ''),
															(td = ''),
															Object.keys(tl).length > 0)
														)
															for (let a in tl)
																tl.hasOwnProperty(a) &&
																	Array.isArray(tl[a]) &&
																	tl[a].includes(
																		e[0].toString().trim()
																	) &&
																	((tr += ` ${a} `), (td = tp))
														var o = e[1]
														'percentage_charge' == e[9] &&
															null != o &&
															'' != o &&
															((o =
																((parseFloat(product_price) / 100) *
																	o) /
																100),
															(o = parseFloat(o.toFixed(2))))
														var n =
																null != o && '' != o
																	? ' [ ' +
																	  i.currency_symbol +
																	  o +
																	  ' ]'
																	: '',
															l =
																null != o && '' != o && 0 == P
																	? ' (+' +
																	  i.currency_symbol +
																	  o +
																	  ')'
																	: '',
															s = null != o && '' != o ? o : '0.00',
															p = e[4]
														!0 == p && (tx = e[0].toString().trim() + n)
														var r = !0 == p ? 'radio_selected' : '',
															d = !0 == p ? 'checked' : '',
															u = '' != s ? 'price-change' : '',
															h = '',
															c = '',
															f = ''
														let m =
																'' != e[5] && null != e[5]
																	? e[5]
																	: '',
															k = parseInt(e[6])
														var $ = ''
														let g =
																'' != e[7] && null != e[7]
																	? e[7]
																	: '',
															b =
																'' != e[8] && null != e[8]
																	? e[8]
																	: ''
														var y =
																'' != e[10] && null != e[10]
																	? e[10]
																	: '',
															x = '',
															_ = 'disabled'
														if (
															(checkPlan(
																'inventory_and_sku_management',
																'boolean'
															) &&
																('true' == m.toString() &&
																	'true' != g.toString() &&
																	k <= 0 &&
																	('true' == b.toString()
																		? ((h = 'disabled'),
																		  (c = 'is_hulk_disabled'),
																		  (r = ''),
																		  (d = ''),
																		  (u = ''))
																		: ((f = 'is_hulk_hide'),
																		  (h = 'disabled'),
																		  (r = ''),
																		  (d = ''),
																		  (u = ''))),
																'true' == m.toString() && (tg = !0),
																'true' == m.toString() &&
																	'true' != g.toString() &&
																	(($ = k),
																	!0 == p &&
																		'' == h &&
																		((tb = 'block'),
																		(ty =
																			e[0].toString().trim() +
																			n +
																			'_hin_' +
																			$))),
																((!0 == p &&
																	k > 0 &&
																	'true' != g.toString()) ||
																	(!0 == p &&
																		k <= 0 &&
																		'true' == g.toString())) &&
																	(_ = ''),
																'' != y &&
																	(x =
																		"<input type='hidden' name='properties[_SKU_" +
																		v +
																		'(' +
																		e[0].toString().trim() +
																		")]' value='" +
																		y +
																		"' class='hulk_unique_sku' " +
																		_ +
																		'>')),
															'0' == t && '' == f)
														) {
															var w = 0
															t3 = !0
														} else if ('0' != t && !1 == t3) {
															var w = 0
															t3 = !0
														} else var w = -1
														;(tS +=
															"<label aria-label='" +
															e[0].toString().trim() +
															' ' +
															l +
															"' aria-required='true' tabindex='" +
															w +
															"' class='hulkapps_radio_option " +
															tr +
															'  ' +
															f +
															' ' +
															c +
															' ' +
															td +
															"'><input name='hulk_radio_" +
															ti +
															"' data-val-selected-class='radio_selected'  data-oid='" +
															ti +
															"' data-pid='" +
															i.pid +
															"' data-parent='hulkapps_product_options' id='" +
															ti +
															'_' +
															t4 +
															"' data-option-key='rb_" +
															ti +
															'_' +
															t4 +
															"'  data-hinventory='" +
															$ +
															"' type='radio' " +
															d +
															' ' +
															h +
															" class='hulkapps_option_child hulk_po_radiobutton hulkapps_option_" +
															ti +
															' ' +
															u +
															" ' data-price='" +
															s +
															"' data-conditional-value='" +
															e[0].toString().trim() +
															"' value='" +
															e[0].toString().trim() +
															n +
															"'><div class='radio_div " +
															r +
															"' for='" +
															ti +
															'_' +
															t4 +
															"'>" +
															e[0].toString().trim() +
															l +
															'</div>' +
															x +
															'</label>'),
															(t4 += 1)
													})
													var tw = ''
													tg &&
														(tw =
															"<input type='hidden' name='properties[_hin_" +
															m +
															'_hin_' +
															v +
															"]' value='" +
															ty +
															"' class='hulk_unique_prop' data-unique_prop_name='_hin_" +
															m +
															'_hin_' +
															v +
															"'/>"),
														(tS += tw),
														checkPlan('quantity_selector', 'boolean') &&
															J &&
															(tS +=
																"<input style='display: " +
																tb +
																"' type='number'  min='1' value='1' class='hulk_options_quantity hulk_po_radiobutton_quanity' data-parent='hulkapps_product_options' data-pid='" +
																i.pid +
																"' id='quantity_" +
																ti +
																"'/>"),
														(tS +=
															"<input type='hidden' name='properties[" +
															v +
															"]' value='" +
															tx +
															"' class='hulk_radiobutton_hidden_prop'/></div></div>"),
														checkPlan(
															'image_change_based_on_option_value',
															'boolean'
														) &&
															!0 == V &&
															'' != K &&
															(tS +=
																"<script>(function($) {$('.hulkapps_product_options .hulkapps_option_" +
																ti +
																"').change(function() { var option_val  = $(this).data('conditional-value');$('" +
																K +
																"').each(function(){data_title = $(this).attr('alt');if(option_val === data_title){$(this).click();}});});;}(hulkapps_jQuery))</script>"),
														(W += tS)
												} else if ('file_upload' == R)
													(tS =
														"<div class='hulkapps_option fu_render " +
														to +
														' ' +
														t8 +
														' ' +
														th +
														' option_type_id_' +
														ti +
														' ' +
														ta +
														' ' +
														T +
														"' " +
														I +
														"  data-parent-id='" +
														ti +
														"'>"),
														(tS +=
															"<div aria-label='" +
															v +
															"' tabindex='0' aria-required='" +
															tu +
															" ' class='hulkapps_option_name'>" +
															v +
															' ' +
															tc +
															' ' +
															tv +
															' ' +
															tf +
															'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'><div class='file-upload' tabindex='0' aria-label='Choose File'> <div class='file-select'> <div class='file-select-name noFile' >No file chosen...</div><div class='file-select-button' id='fileName' >Choose File</div><input type='file' data-option-key='fu_" +
															ti +
															"' id='" +
															ti +
															"' class='hulkapps_option_child hulkapps_full_width hulk_file_upload hulkapps_option_" +
															ti +
															"' name='properties[" +
															v +
															"]'> </div></div><script>(function($) {$('.hulkapps_product_options #" +
															ti +
															"').change(function (){ conditional_rules(" +
															i.pid +
															",'hulkapps_product_options');validate_single_option('option_type_id_" +
															ti +
															"','fu_render','hulkapps_product_options');})}(hulkapps_jQuery))</script></div></div>"),
														(W += tS)
												else if ('email' == R) {
													var t6 = ''
													;(tS =
														"<div class='hulkapps_option et_render " +
														O +
														' ' +
														to +
														' ' +
														t8 +
														' ' +
														th +
														' option_type_id_' +
														ti +
														' ' +
														ta +
														' ' +
														T +
														"' " +
														I +
														" data-parent-id='" +
														ti +
														"'>"),
														(tS +=
															"<div aria-label='" +
															v +
															"' tabindex='0' aria-required='" +
															tu +
															" ' class='hulkapps_option_name'>" +
															v +
															' ' +
															tc +
															' ' +
															tv +
															' ' +
															tf +
															' </div>'),
														'inlineLabels' == F && (D = v),
														'floatingLabels' == F && (D = ''),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, e) {
															var a = e[1]
															'percentage_charge' == e[9] &&
																null != a &&
																'' != a &&
																((a =
																	((parseFloat(product_price) /
																		100) *
																		a) /
																	100),
																(a = parseFloat(a.toFixed(2)))),
																null != a &&
																	'' != a &&
																	i.currency_symbol,
																null != a &&
																	'' != a &&
																	i.currency_symbol
															var o =
																	null != a && '' != a
																		? a
																		: '0.00',
																n =
																	(e[4],
																	'' != o ? 'price-change' : '')
															;(tS +=
																"<input type='email' placeholder='" +
																D +
																"' data-option-key='et_" +
																ti +
																"' data-parent='hulkapps_product_options' data-pid='" +
																i.pid +
																"' data-val-selected-class='emailbox_selected' data-single_valid-class='et_render' id='" +
																ti +
																"' class='hulk_po_other_options hulkapps_option_child hulkapps_full_width hulkapps_option_" +
																ti +
																' ' +
																n +
																"' data-price='" +
																o +
																"'><input type='hidden' name='properties[" +
																v +
																"]' class='et_property_val other_options_prop_val'>"),
																'floatingLabels' == F &&
																	(tS +=
																		"<label class='floating_label'>" +
																		v +
																		'</label>')
														}),
														(W += tS = tS + t6 + '</div></div>')
												} else if ('date_picker' == R) {
													var t6 = ''
													;(tS =
														"<div class='hulkapps_option dp_render " +
														to +
														' ' +
														t8 +
														' ' +
														th +
														' option_type_id_' +
														ti +
														' ' +
														ta +
														' ' +
														T +
														"' " +
														I +
														" data-parent-id='" +
														ti +
														"'>"),
														(tS +=
															"<div aria-label='" +
															v +
															"' tabindex='0' aria-required='" +
															tu +
															" ' class='hulkapps_option_name'>" +
															v +
															' ' +
															tc +
															' ' +
															tv +
															' ' +
															tf +
															'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, e) {
															var a = e[1]
															'percentage_charge' == e[9] &&
																null != a &&
																'' != a &&
																((a =
																	((parseFloat(product_price) /
																		100) *
																		a) /
																	100),
																(a = parseFloat(a.toFixed(2)))),
																null != a &&
																	'' != a &&
																	i.currency_symbol,
																null != a &&
																	'' != a &&
																	i.currency_symbol
															var o =
																	null != a && '' != a
																		? a
																		: '0.00',
																n =
																	(e[4],
																	'' != o ? 'price-change' : '')
															tS +=
																"<input type='date' tabindex='0' data-parent='hulkapps_product_options' data-pid='" +
																i.pid +
																"' data-single_valid-class='dp_render'  data-val-selected-class='datepicker_selected'  data-option-key='dp_" +
																ti +
																"' id='" +
																ti +
																"' name='input' placeholder='mm/dd/yyyy' class='hulk_po_other_options hulkapps_option_child hulkapps_full_width hulkapps_option_" +
																ti +
																' ' +
																n +
																"' data-price='" +
																o +
																"'><input type='hidden' name='properties[" +
																v +
																"]' class='dp_property_val other_options_prop_val'>"
														}),
														(tS += '</div></div>'),
														(W += tS)
												} else if ('time_picker' == R) {
													var t6 = ''
													;(tS =
														"<div class='hulkapps_option dt_render " +
														to +
														' ' +
														t8 +
														' ' +
														th +
														' option_type_id_' +
														ti +
														' ' +
														ta +
														' ' +
														T +
														"' " +
														I +
														" data-parent-id='" +
														ti +
														"'>"),
														(tS +=
															"<div aria-label='" +
															v +
															"' tabindex='0' aria-required='" +
															tu +
															" ' class='hulkapps_option_name'>" +
															v +
															' ' +
															tc +
															' ' +
															tv +
															' ' +
															tf +
															'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, e) {
															var a = e[1]
															'percentage_charge' == e[9] &&
																null != a &&
																'' != a &&
																((a =
																	((parseFloat(product_price) /
																		100) *
																		a) /
																	100),
																(a = parseFloat(a.toFixed(2)))),
																null != a &&
																	'' != a &&
																	i.currency_symbol,
																null != a &&
																	'' != a &&
																	i.currency_symbol
															var o =
																	null != a && '' != a
																		? a
																		: '0.00',
																n =
																	(e[4],
																	'' != o ? 'price-change' : '')
															tS +=
																"<input type='time' data-parent='hulkapps_product_options' data-pid='" +
																i.pid +
																"' data-single_valid-class='dt_render'  data-val-selected-class='datetimepicker_selected'  data-option-key='dt_" +
																ti +
																"' id='" +
																ti +
																"' name='input' placeholder='mm/dd/yyyy' class='hulk_po_other_options hulkapps_option_child hulkapps_full_width hulkapps_option_" +
																ti +
																' ' +
																n +
																"' data-price='" +
																o +
																"'><input type='hidden' name='properties[" +
																v +
																"]' class='dp_property_val other_options_prop_val'>"
														}),
														(tS += '</div></div>'),
														(W += tS)
												} else if ('color_picker' == R) {
													if (
														checkPlan('color_picker_option', 'boolean')
													) {
														var t6 = ''
														;(tS =
															"<div class='hulkapps_option cp_render " +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"'>"),
															(tS +=
																"<div aria-label='" +
																v +
																"' tabindex='0' aria-required='" +
																tu +
																" ' class='hulkapps_option_name'>" +
																v +
																' ' +
																tc +
																' ' +
																tv +
																' ' +
																tf +
																'</div>'),
															(tS +=
																"<div class='hulkapps_option_value'>"),
															t.each(te, function (t, e) {
																var a = e[1]
																'percentage_charge' == e[9] &&
																	null != a &&
																	'' != a &&
																	((a =
																		((parseFloat(
																			product_price
																		) /
																			100) *
																			a) /
																		100),
																	(a = parseFloat(a.toFixed(2)))),
																	null != a &&
																		'' != a &&
																		i.currency_symbol,
																	null != a &&
																		'' != a &&
																		i.currency_symbol
																var o =
																		null != a && '' != a
																			? a
																			: '0.00',
																	n =
																		'' != o
																			? 'price-change'
																			: ''
																tS +=
																	"<input type='color' data-parent='hulkapps_product_options' data-pid='" +
																	i.pid +
																	"' data-val-selected-class='colorpicker_selected' data-single_valid-class='cp_render'  data-option-key='cp_" +
																	ti +
																	"' id='" +
																	ti +
																	"' name='input' style='padding: 0;width: 100px;' class='hulk_po_other_options hulkapps_option_child  hulkapps_option_" +
																	ti +
																	' ' +
																	n +
																	"' data-price='" +
																	o +
																	"'><input type='hidden' name='properties[" +
																	v +
																	"]' class='cp_property_val other_options_prop_val'>"
															}),
															(tS += '</div></div>'),
															(W += tS)
													}
												} else if ('number_field' == R) {
													;(t6 = ''),
														void 0 != Q &&
															checkPlan(
																'character_limit',
																'boolean',
																i.plan_id,
																i.plans_features
															) &&
															'' != Q.character_limit &&
															Q.character_limit
													var tL =
															void 0 != Q &&
															checkPlan(
																'character_limit',
																'boolean'
															) &&
															'' != Q.character_limit &&
															void 0 != Q.character_limit
																? '[Maximum ' +
																  Q.character_limit +
																  ' character]'
																: '',
														tS =
															"<div class='hulkapps_option nf_render " +
															O +
															' ' +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"'>"
													;(tS +=
														"<div aria-label='" +
														v +
														"' tabindex='0' aria-required='" +
														tu +
														" ' class='hulkapps_option_name'><div>" +
														v +
														' ' +
														tc +
														' ' +
														tv +
														' </div> ' +
														tL +
														' ' +
														tf +
														'</div>'),
														'inlineLabels' == F && (D = v),
														'floatingLabels' == F && (D = ''),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, e) {
															var a = e[1]
															'percentage_charge' == e[9] &&
																null != a &&
																'' != a &&
																((a =
																	((parseFloat(product_price) /
																		100) *
																		a) /
																	100),
																(a = parseFloat(a.toFixed(2)))),
																null != a &&
																	'' != a &&
																	i.currency_symbol
															var o =
																	null != a && '' != a
																		? a
																		: '0.00',
																n = '',
																l = '',
																s = '' != o ? 'price-change' : ''
															void 0 != Q &&
																checkPlan(
																	'character_limit',
																	'boolean'
																) &&
																'' != Q.character_limit &&
																void 0 != Q.character_limit &&
																((n =
																	'maxlength=' +
																	Q.character_limit),
																(l =
																	"onKeyPress='if(this.value.length==" +
																	Q.character_limit +
																	") return false;'")),
																(tS +=
																	"<input type='number' " +
																	l +
																	" pattern='d*' min=0 step='any' data-parent='hulkapps_product_options' data-pid='" +
																	i.pid +
																	"' data-val-selected-class='numberfield_selected' data-single_valid-class='nf_render' data-option-key='nf_" +
																	ti +
																	"' id='" +
																	ti +
																	"' placeholder='" +
																	D +
																	"'  class='hulk_po_other_options hulkapps_option_child hulkapps_full_width hulkapps_option_" +
																	ti +
																	' ' +
																	s +
																	"' data-price='" +
																	o +
																	"' " +
																	n +
																	"><input type='hidden' name='properties[" +
																	v +
																	"]' class='nf_property_val other_options_prop_val'>"),
																'floatingLabels' == F &&
																	(tS +=
																		"<label class='floating_label'>" +
																		v +
																		'</label>'),
																void 0 != Q &&
																	checkPlan(
																		'character_limit',
																		'boolean'
																	) &&
																	'' != Q.character_limit &&
																	void 0 != Q.character_limit &&
																	(tS +=
																		"<input type='hidden' value='" +
																		Q.character_limit +
																		"' class='character_count'><div id='char_count_" +
																		ti +
																		"'>" +
																		Q.character_limit +
																		' ' +
																		i.display_settings
																			.charcter_count_message +
																		'</div>'),
																void 0 != Q &&
																	checkPlan(
																		'character_limit',
																		'boolean'
																	) &&
																	'' != Q.character_limit &&
																	void 0 != Q.character_limit &&
																	(t6 +=
																		"<script>(function($) {$(document).on('input', '.hulkapps_product_options .hulkapps_option_" +
																		ti +
																		"', function() { if(this.value.length > Number($(this).attr('maxlength'))){val=this.value.slice(0, $(this).attr('maxlength'));$(this).val(val);}check_character_limit(" +
																		Q.character_limit +
																		",'" +
																		ti +
																		"','" +
																		i.display_settings
																			.charcter_count_message +
																		"','hulkapps_product_options');});}(hulkapps_jQuery))</script>")
														}),
														(W += tS = tS + t6 + '</div></div>')
												} else if ('phone_number' == R) {
													var t6 = '',
														tS =
															"<div class='hulkapps_option pn_render " +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"'>"
													;(tS +=
														"<div aria-label='" +
														v +
														"' tabindex='0' aria-required='" +
														tu +
														" ' class='hulkapps_option_name'>" +
														v +
														' ' +
														tc +
														' ' +
														tv +
														' ' +
														tf +
														'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, e) {
															var a = e[1]
															'percentage_charge' == e[9] &&
																null != a &&
																'' != a &&
																((a =
																	((parseFloat(product_price) /
																		100) *
																		a) /
																	100),
																(a = parseFloat(a.toFixed(2)))),
																null != a &&
																	'' != a &&
																	i.currency_symbol
															var o =
																null != a && '' != a ? a : '0.00'
															;(tS +=
																"<input type='textbox' data-option-key='tb_" +
																ti +
																"' id='" +
																ti +
																"' class='phone_number phone_number" +
																ti +
																' hulkapps_option_child hulkapps_full_width hulkapps_option_' +
																ti +
																' ' +
																('' != o ? 'price-change' : '') +
																"' data-price='" +
																o +
																"'><input type='hidden' name='properties[" +
																v +
																"]' class='tb_property_val '><span id='valid-msg' class='hide'>âœ“ Valid</span><span id='error-msg' class='hide' tabindex='0' aria-label='Invalid number'>Invalid number</span>"),
																(t6 +=
																	"<script>(function($) {$(document).ready(function(){$('.hulkapps_product_options .phone_number" +
																	ti +
																	"').keypress(function (e) {if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {return false;}});var telInput = $('.hulkapps_product_options').find('.phone_number" +
																	ti +
																	"');var errorMsg = $('.hulkapps_product_options').find('.phone_number" +
																	ti +
																	"').closest('.hulkapps_option_value').find('#error-msg');var validMsg = $('.hulkapps_product_options').find('.phone_number" +
																	ti +
																	"').closest('.hulkapps_option_value').find('#valid-msg');var iti = window.intlTelInput(telInput.get(0), {initialCountry: 'auto',geoIpLookup: function(callback) {var countryCode = '" +
																	i.country +
																	"';callback(countryCode);},customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {return 'e.g. ' + selectedCountryPlaceholder;}, utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.min.js'});var reset = function() {telInput.removeClass('error');errorMsg.innerHTML = '';errorMsg.addClass('hide');validMsg.addClass('hide');};telInput.blur(function() {reset();if ($.trim($('.phone_number" +
																	ti +
																	"').val())) {if(iti.isValidNumber()){validMsg.removeClass('hide');$('.hulkapps_product_options').find('.phone_number" +
																	ti +
																	"').parents('.hulkapps_option_value').find('#error-msg').css('cssText', 'display: none !important');telInput.val(iti.getNumber(intlTelInputUtils.numberFormat.E164));var tb_val = $('.hulkapps_product_options').find('.phone_number" +
																	ti +
																	"').val();var price = $(this).data('price');if(price != '0.00'){var res = tb_val + ' [ " +
																	i.currency_symbol +
																	"' + price + ' ]';}else{var res = tb_val}$(this).parents('.hulkapps_option_value').find('.tb_property_val').val(res);$(this).addClass('textbox_selected');} else {telInput.addClass('error');$('.hulkapps_product_options').find('.phone_number" +
																	ti +
																	"').parents('.hulkapps_option_value').find('#error-msg').css('cssText', 'display: block !important');$(this).parents('.hulkapps_option_value').find('.tb_property_val').val(res);$(this).removeClass('textbox_selected');}}else{$('.hulkapps_product_options').find('.phone_number').parents('.hulkapps_option_value').find('#error-msg').css('cssText', 'display: none !important');$(this).parents('.hulkapps_option_value').find('.tb_property_val').val(res);$(this).removeClass('textbox_selected');}conditional_rules(" +
																	i.pid +
																	",'hulkapps_product_options');if($('#hulk_amount_dis').val() == '1'){calc_options_total(" +
																	i.pid +
																	",'hulkapps_product_options');}validate_single_option('option_type_id_" +
																	ti +
																	"', 'pn_render','hulkapps_product_options');});});}(hulkapps_jQuery))</script>")
														}),
														(W += tS = tS + t6 + '</div></div>')
												} else if ('hidden' == R)
													checkPlan('hidden_field_option', 'boolean') &&
														(t.each(te, function (t, i) {
															tS =
																"<input type='hidden' name='properties[" +
																v +
																"]' class='hf_property_val   hulkapps_option_" +
																ti +
																' ' +
																to +
																' ' +
																ta +
																"' value='" +
																i[0] +
																"'>"
														}),
														(W += tS))
												else if ('popup' == R)
													checkPlan('popup_option', 'boolean') &&
														((tS =
															"<div class='hulkapps_option popup_render " +
															to +
															' ' +
															t8 +
															' ' +
															th +
															' option_type_id_' +
															ti +
															' ' +
															ta +
															' ' +
															T +
															"' " +
															I +
															" data-parent-id='" +
															ti +
															"'>"),
														(tS +=
															"<div class='hulkapps_option_name' style='display: none !important;'>" +
															v +
															' ' +
															tc +
															' ' +
															tv +
															' ' +
															tf +
															'</div>'),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, i) {
															var e = i[0],
																a = null != i[3] ? i[3] : ''
															'' != a
																? (tS +=
																		"<div  class='cut-popup-icon'><span class='cut-popup-icon-span'><img src='" +
																		a +
																		"' style='width: 24px;'></span><a  tabindex='0' aria-label='" +
																		e +
																		"' style='cursor: pointer;' data-id='" +
																		ti +
																		"' data-option-key='popup_" +
																		ti +
																		"' id='" +
																		ti +
																		"' class='hulkapps_option_child hulkapps_full_width popup_open_link hulkapps_option_" +
																		ti +
																		"'>" +
																		e +
																		'</a></div>')
																: (tS +=
																		"<div style='display: flex; align-items: center;'><a  tabindex='0' aria-label='" +
																		e +
																		"'  style='cursor: pointer;' data-id='" +
																		ti +
																		"' data-option-key='popup_" +
																		ti +
																		"' id='" +
																		ti +
																		"' class='hulkapps_option_child hulkapps_full_width popup_open_link hulkapps_option_" +
																		ti +
																		"'>" +
																		e +
																		'</a></div>'),
																(tS +=
																	"<div class='popup_detail'  id='popupdetailsdesing_" +
																	ti +
																	"' style='display: none'><div><div class='des-title'></div><div tabindex='0' aria-label='" +
																	i[2] +
																	"'class='des-detail' style='padding: 10px;'>" +
																	i[2] +
																	"</div></div><a class='popup_close_link' tabindex='0' aria-label='close popup' data-id='" +
																	ti +
																	"'><img src='" +
																	window.hulkapps.po_url +
																	"/images/close.png' alt='close-icon'></a></div><div class='overlay-popup'></div>")
														}),
														(tS += '</div></div>'),
														(W += tS))
												else if ('information' == R)
													(tS =
														"<div class='hulkapps_option information_render " +
														to +
														' ' +
														t8 +
														' ' +
														th +
														' option_type_id_' +
														ti +
														' ' +
														ta +
														' ' +
														T +
														"' " +
														I +
														" data-parent-id='" +
														ti +
														"'>"),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, i) {
															i[0],
																(tS +=
																	"<div tabindex='0' aria-label='" +
																	i[2].replace(/<\/?p>/g, '') +
																	"'>" +
																	i[2] +
																	'</div>')
														}),
														(tS += '</div></div>'),
														(W += tS)
												else if ('google_font' == R) {
													if (
														checkPlan('google_font_option', 'boolean')
													) {
														var t6 = ''
														if (
															((tS =
																"<div class='hulkapps_option gf_render " +
																to +
																' ' +
																t8 +
																' ' +
																th +
																' option_type_id_' +
																ti +
																' ' +
																ta +
																' ' +
																T +
																"' " +
																I +
																" data-parent-id='" +
																ti +
																"'>"),
															(tS +=
																"<div aria-label='" +
																v +
																"' tabindex='0' aria-required='" +
																tu +
																" ' class='hulkapps_option_name'>" +
																v +
																' ' +
																tc +
																' ' +
																tv +
																' ' +
																tf +
																' </div>'),
															(tS +=
																"<div class='hulkapps_option_value'>"),
															(tF = ''),
															(option_charge_type =
																tt.option_charge_type),
															(tt = tt.price),
															'percentage_charge' ==
																option_charge_type &&
																null != tt &&
																'' != tt &&
																((tt =
																	((parseFloat(product_price) /
																		100) *
																		tt) /
																	100),
																(tt = parseFloat(tt.toFixed(2)))),
															null != tt && '' != tt)
														)
															var tj = 'price-change',
																tE = 'googlefont_selected',
																tF =
																	' [ ' +
																	i.currency_symbol +
																	tt +
																	' ]'
														else {
															tt = '0.00'
															var tj = 'price-change'
														}
														;(tS +=
															"<input type='text' tabindex='0' data-option-key='gf_" +
															ti +
															"' id='" +
															ti +
															"' value='" +
															X +
															"' class='hulkapps_option_child hulkapps_full_width hulkapps_option_" +
															ti +
															' ' +
															tj +
															' ' +
															tE +
															" ' data-price='" +
															tt +
															"'>"),
															'' == tF
																? (tS +=
																		"<input type='hidden' name='properties[" +
																		v +
																		"]' class='gf_property_val'>")
																: (tS +=
																		"<input type='hidden' name='properties[" +
																		v +
																		"]' class='gf_property_val' value='" +
																		X +
																		' ' +
																		tF +
																		"'>"),
															(t6 +=
																'<script>(function($) {var google_font_with_price_format = ' +
																JSON.stringify(Z) +
																";$('.hulkapps_option_" +
																ti +
																"').fontselect({googleFonts: '" +
																H +
																"'}).change(function(){var font = $(this).val().replace('/+/g', ' ');font = font.split(':')[0];var option_charge_type = google_font_with_price_format[font]['option_charge_type'];var price=google_font_with_price_format[font]['price'];if(option_charge_type == 'percentage_charge' && price != null && price != ''){price = ((parseFloat(product_price)/100)*price)/100;price = parseFloat(price.toFixed(2));}if(price == null){price = '0.00'};$('.hulkapps_option_" +
																ti +
																"').attr('data-price',price)});$(document).on('change','.hulkapps_product_options .hulkapps_option_" +
																ti +
																"',function() {var price = $(this).attr('data-price');var gf_val = $(this).val();if (gf_val != '') {if(price != '0.00'){var res = gf_val + ' [ " +
																i.currency_symbol +
																"' + price + ' ]';}else{var res = gf_val}$(this).parent().find('.gf_property_val').val(res);$(this).addClass('googlefont_selected');}else{ $(this).parent().find('.gf_property_val').val('');$(this).removeClass('googlefont_selected');}conditional_rules(" +
																i.pid +
																",'hulkapps_product_options');if($('#hulk_amount_dis').val() == '1'){calc_options_total(" +
																i.pid +
																",'hulkapps_product_options');}validate_single_option('option_type_id_" +
																ti +
																"', 'gf_render','hulkapps_product_options');});}(hulkapps_jQuery))</script>"),
															(W += tS = tS + t6 + '</div></div>')
													}
												} else if ('formula_based_options' == R) {
													tS =
														"<div class='hulkapps_option fm_render required " +
														t8 +
														' ' +
														to +
														'  ' +
														(!0 == u ? '' : 'full_width') +
														' option_type_id_' +
														ti +
														' ' +
														ta +
														' ' +
														T +
														"' " +
														I +
														' data-parent-id= ' +
														ti +
														" ><div class='hulkapps_option_name'  aria-label='" +
														v +
														"' tabindex='0' >" +
														v +
														' ' +
														tc +
														' ' +
														tv +
														' ' +
														tf +
														"</div><div class='hulkapps_option_value fm_option_val' data-parent='hulkapps_product_options' data-pid='" +
														i.pid +
														"'>"
													var tx = '',
														tO = !1
													t.each(te, function (t, i) {
														if (((e = ''), i[4]))
															var e =
																"<div class='hulkapps-tooltip'><span aria-describedby='tooltip_" +
																n +
																"' aria-label='" +
																i[4] +
																"' tabindex='0' ><img src='" +
																window.hulkapps.po_url +
																"/tooltip.svg' style='width:15px;'></span><div class='hulkapps-tooltip-inner' id='tooltip_" +
																n +
																"' role='tooltip'>" +
																i[4] +
																'</div></div>'
														if ('plus' == i[3]) var a = '+'
														else if ('minus' == i[3]) var a = '-'
														else if ('divide' == i[3]) var a = '/'
														else if ('multiple' == i[3]) var a = '*'
														var o = ''
														'default_value' == i[0]
															? (o =
																	"<div class='hulk-form-field'><div class='hulkapps_option_name' tabindex='0' aria-label='" +
																	i[1] +
																	"' >" +
																	i[1] +
																	"</div><div class='hulkapps_option_value'><input type='number'   value='" +
																	parseFloat(i[2]) +
																	"' data-oid='" +
																	ti +
																	"' class='po_changed_formula' data-arithmatic='" +
																	a +
																	"' readonly data-name='" +
																	i[1] +
																	"' min='" +
																	i[5] +
																	"' max='" +
																	i[6] +
																	"'>" +
																	e +
																	'</div></div>')
															: ((tO = !0),
															  (o =
																	"<div class='hulk-form-field'><div class='hulkapps_option_name' tabindex='0' aria-label='" +
																	i[1] +
																	"'>" +
																	i[1] +
																	"</div><div class='hulkapps_option_value'><input type='number'  data-oid='" +
																	ti +
																	"'  data-arithmatic='" +
																	a +
																	"' class='po_changed_formula hulkapps_option_child' data-name='" +
																	i[1] +
																	"'  min='" +
																	i[5] +
																	"' max='" +
																	i[6] +
																	"' >" +
																	e +
																	'</div></div>')),
															(tS += o)
													}),
														(tS +=
															"<input type='hidden' name='properties[" +
															v +
															"]'  class='hulk_formula_hidden_prop hulkapps_option_child'/>"),
														(tS += `<script>(function($) {if(${tO} != true){$('.option_type_id_${ti}').find('.po_changed_formula').change();}}(hulkapps_jQuery))</script></div></div>`),
														(W += tS)
												} else if (
													'short_text_group' == R &&
													checkPlan(
														'short_text_group',
														'boolean',
														i.plan_id,
														i.plans_features,
														i.is_on_trial_period
													)
												) {
													var t6 = ''
													;(tS =
														"<div class='hulkapps_option stg_render " +
														to +
														' ' +
														t8 +
														' ' +
														th +
														' option_type_id_' +
														ti +
														' ' +
														ta +
														' ' +
														T +
														"' " +
														I +
														" data-parent-id='" +
														ti +
														"'>"),
														(tS +=
															"<div aria-label='" +
															v +
															"' tabindex='0' aria-required='" +
															tu +
															" ' class='hulkapps_option_name'>" +
															v +
															' ' +
															tc +
															' ' +
															tv +
															' ' +
															tf +
															' </div>'),
														(tS +=
															"<div class='hulkapps_option_value'>"),
														t.each(te, function (t, e) {
															var a = e[0],
																o = e[1]
															'percentage_charge' == e[9] &&
																null != o &&
																'' != o &&
																((o =
																	((parseFloat(product_price) /
																		100) *
																		o) /
																	100),
																(o = parseFloat(o.toFixed(2)))),
																null != o &&
																	'' != o &&
																	i.currency_symbol
															var n =
																null != o && '' != o ? o : '0.00'
															if (
																((tr = ''),
																(td = ''),
																Object.keys(tl).length > 0)
															)
																for (let l in tl)
																	tl.hasOwnProperty(l) &&
																		Array.isArray(tl[l]) &&
																		tl[l].includes(
																			e[0].toString().trim()
																		) &&
																		((tr += ` ${l} `),
																		(td = tp))
															'none' != a
																? ((tS +=
																		"<div class='hulkapps_short_option_value " +
																		tr +
																		' ' +
																		td +
																		"' ><div class='hulkapps_option_name' tabindex='0' aria-label='" +
																		e[0] +
																		"'>" +
																		e[0] +
																		' </div>'),
																  (tS =
																		tS +
																		"<input type='text' placeholder='" +
																		D +
																		"' data-option-key='stg_" +
																		ti +
																		"' id='" +
																		ti +
																		"' class='hulkapps_option_child hulkapps_full_width hulkapps_option_" +
																		ti +
																		' ' +
																		tj +
																		"' data-price='" +
																		n +
																		"' data-pid='" +
																		i.pid +
																		"'  data-oid='" +
																		ti +
																		"' data-parent='hulkapps_product_options' data-key-name='" +
																		a +
																		"' data-single_valid-class='stg_render' data-val-selected-class='stg_selected'></div>"))
																: (tS =
																		tS +
																		"<input type='hidden' placeholder='" +
																		D +
																		"' data-option-key='stg_" +
																		ti +
																		"' id='" +
																		ti +
																		"' class='hulkapps_option_child stg_hidden stg_hidden_" +
																		ti +
																		' hulkapps_full_width hulkapps_option_' +
																		ti +
																		' ' +
																		tj +
																		"' data-price='" +
																		n +
																		"' data-currency-symbol='" +
																		i.currency_symbol +
																		"' data-pid='" +
																		i.pid +
																		"' data-oid='" +
																		ti +
																		"' data-parent='hulkapps_product_options' data-single_valid-class='stg_render' data-val-selected-class='stg_selected'>")
														}),
														(tS =
															tS +
															"<input type='hidden' name='properties[" +
															v +
															"]' class='stg_property_val'>"),
														(tS += '</div></div>'),
														(W += tS)
												}
											}
										})
									var tt =
										"<input type='hidden' name='currency_symbol' value='" +
										i.currency_symbol +
										"'>"
									'' !== W && (X = X + W + tt),
										(X += '</div>'),
										(1 == parseInt(I) || '' == I) &&
											(X +=
												"<div id='option_total' style='display: none;'><input type='hidden' id='raw_option_total' value='0'><div id='option_display_total_format' tabindex='0'>" +
												z +
												"<span id='formatted_option_total'>" +
												i.currency_symbol +
												"<span id='calculated_option_total'>0.00</span></span>" +
												T +
												'</div></div>'),
										(X += "<div id='error_text'></div>"),
										(X += '</div></div>')
								}
								console.log(
									'UCOAST CUSTOM OPTIONS',
									t('#hulkapps_custom_options_' + window.hulkapps.product_id)
										.length
								)
								if (
									0 ==
									t('#hulkapps_custom_options_' + window.hulkapps.product_id)
										.length
								) {
									console.log('UCOAST NO CUSTOM OPTIONS')
									let ti = 0
									n.split(',').forEach(function (i) {
										;(ti += t(i).length),
											null == window.hulk_add_to_cart_ele &&
												ti &&
												(window.hulk_add_to_cart_ele = t(i).first())
									})
									var te = window.hulk_add_to_cart_ele
									te.parent().is('div') && (te = te.parent()),
										te.before(
											'<div id="hulkapps_custom_options_' +
												window.hulkapps.product_id +
												'"></div><div class="product-hulkapps-discount-code-html"></div>'
										)
								}
								t('#hulkapps_custom_options_' + window.hulkapps.product_id).html(X),
									requireInventory(
										window.hulkapps.product_id,
										'hulkapps_product_options'
									),
									keybordAccess(),
									(window.dynamic_checkout_button_integration =
										i.display_settings.dynamic_checkout_button_integration),
									(window.is_product_page_doscount_code =
										i.display_settings.dynamic_checkout_discount_code),
									conditional_rules(
										window.hulkapps.product_id,
										'hulkapps_product_options'
									),
									t('#hulkapps_options_' + window.hulkapps.product_id)
										.closest('form')
										.find(':submit')
										.addClass('hulkapps_submit_cart'),
									'' ==
										t(
											'#hulkapps_option_list_' +
												window.hulkapps.product_id +
												' .hulkapps_option_set'
										).html() &&
										t('#hulkapps_options_' + window.hulkapps.product_id).css(
											'display',
											'none'
										)
							} else {
								console.log('NOT RUNNING THIS')
							}
						},
						error: function (t, i) {
							console.log('AJAX ERROR', { t, i })
							window.$first_add_to_cart_el &&
								window.$first_add_to_cart_el.removeAttr('disabled')
						},
					})
				}),
				(window.hulkappsStart = function (t) {
					console.log('UCOAST HULK APPS START')
					window.$first_add_to_cart_el = null
					var i = 0
					if (
						([
							"input[name='add']",
							"button[name='add']",
							'#add-to-cart',
							'#AddToCartText',
							'#AddToCart',
							'form[action="/cart/add"] :input[type="submit"]',
						].forEach(function (e) {
							;(i += t(e).length),
								null == window.$first_add_to_cart_el &&
									i &&
									(window.$first_add_to_cart_el = t(e).first())
						}),
						window.$first_add_to_cart_el &&
							(window.$first_add_to_cart_el.attr('disabled', !0),
							setTimeout(function () {
								window.$first_add_to_cart_el.removeAttr('disabled')
							}, 2500)),
						'product' == window.hulkapps.page_type &&
							window.hulkapps.product_id &&
							window.hulkapps.store_id)
					) {
						product_page_btn_condition()
						var e = [],
							a = document.querySelectorAll(
								".single-option-selector,.swatch-element input[type='radio'],.single-option-selector__radio, select[data-option='option1'], select[data-option='option1']:checked, select[data-option='option2'], select[data-option='option1']:checked, select[data-option='option3'], select[data-option='option3']:checked, select[data-index='option1'], select[data-index='option1']:checked, select[data-index='option2'], select[data-index='option1']:checked, select[data-index='option3'], select[data-index='option3']:checked, ul li div[swatch-option='option1'], input[type='radio']"
							)
						a.forEach(function (t) {
							t.addEventListener('change', (t) => {
								;(e = []),
									a.forEach(function (t) {
										var i =
											!!t.options &&
											t.options[t.options.selectedIndex].selected
										;(t.checked || i) && e.push(t.value)
									}),
									(e = e.join(' / ')),
									Object.keys(hulk_variants).forEach(function (i) {
										var a = hulk_variants[i]
										if (a.options.length < 2) {
											selected_variant_title = t.target.value
												.toString()
												.toLowerCase()
											var o = a.title.toString().toLowerCase()
											o.trim() == selected_variant_title.trim() &&
												(a.id,
												(window.hulkapps.product.selected_variant = a.id),
												(product_price = a.price),
												(window.hulkapps.product.selected_variant_price =
													product_price))
										} else {
											selected_variant_title = e.toString().toLowerCase()
											var o = a.title.toString().toLowerCase()
											selected_variant_title.includes(o) &&
												(a.id,
												(window.hulkapps.product.selected_variant = a.id),
												(product_price = a.price),
												(window.hulkapps.product.selected_variant_price =
													product_price))
										}
									}),
									setTimeout(function () {
										calc_options_total(
											window.hulkapps.product_id,
											'hulkapps_product_options'
										)
									}, 500)
							})
						}),
							productPageAjax(t)
					}
					t('body').on('change', 'input[name="updates[]"]', function (i) {
						t('[name="update"]').click()
					})
				}),
				(window.hulkappsParseURL = function (t) {
					if (t) {
						var i = RegExp(
								'^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?'
							),
							e = t.match(i),
							a = e[7]
						return (
							a && (a = new URLSearchParams(a)),
							{ scheme: e[2], authority: e[4], path: e[5], query: a, fragment: e[9] }
						)
					}
				}),
				hulkappsStart(t)
		}),
		(window.getCartInfo = function (t = 0, i = '', e = hulkapps_jQuery) {
			var i = i
			if (0 != t) {
				var a = t.key
				let o = t.properties
				if (o) {
					var n = ''
					Object.keys(o).forEach(function (t) {
						if (o[t].includes('uploads')) {
							var i = o[t].split('/'),
								e = i[i.length - 1]
							n +=
								'<div class="product-option"><dt>' +
								t +
								': </dt><dd>  <a href="' +
								o[t] +
								'" class="link" target="_blank">' +
								e +
								'</a></dd></div>'
						} else t.startsWith('_hin') || t.startsWith('_SKU') || (n += '<div class="product-option"><dt>' + t + ': </dt><dd>' + o[t] + '</dd></div>')
					}),
						window.currentEditOptionSelector
							.parents(window.cart_lineitem_parents_selectors)
							.find(window.cart_item_properties_selectors)
							.html(n)
				} else
					window.currentEditOptionSelector
						.parents(window.cart_lineitem_parents_selectors)
						.find(window.cart_item_properties_selectors)
						.html('')
			}
			new Promise(function (t, a) {
				i
					? t(i)
					: e.getJSON('/cart.js', { _: new Date().getTime() }, function (i) {
							t(i)
					  })
			})
				.then(function (t) {
					if (t && t.item_count > 0) {
						var i = localStorage.getItem('discount_code')
						;(window.hulkapps.cart = t),
							new Promise((t, i) => {
								e.ajax({
									url: '/cart?view=hulkapps_cart_collections.json',
									success: function (i) {
										try {
											if (i) {
												var a = JSON.parse(i)
												if (a) {
													var o = a.items
													e.each(o, function (t, i) {
														window.hulkapps.cart_collections[
															i.variant_id
														] = i.product_collections
													})
												}
											}
											t(window.hulkapps.cart_collections)
										} catch (n) {
											t(window.hulkapps.cart_collections)
										}
									},
									error: function (i) {
										t(window.hulkapps.cart_collections)
									},
								})
							})
								.then(function (o) {
									if (((window.hulkapps.cart_collections = o), '' != i)) {
										e('.hulkapps_discount_code').val(i)
										var n = {
											cart_data: window.hulkapps,
											store_id: window.hulkapps.store_id,
											discount_code: i,
											cart_collections: JSON.stringify(
												window.hulkapps.cart_collections
											),
											customer_tags:
												null != window.hulkapps.customer
													? window.hulkapps.customer.tags.split(',')
													: '',
										}
									} else var n = { cart_data: window.hulkapps, store_id: window.hulkapps.store_id, cart_collections: JSON.stringify(window.hulkapps.cart_collections), customer_tags: null != window.hulkapps.customer ? window.hulkapps.customer.tags.split(',') : '' }
									var l = 0
									t.items.forEach(function (t) {
										null != t.properties && t.properties != {} && l++
									}),
										l > 1
											? e(checkout_selectors).attr('disabled', !0)
											: e(checkout_selectors).attr('disabled', !1),
										e(checkout_selectors).attr('disabled', !0),
										e.ajax({
											type: 'POST',
											url: window.hulkapps.po_url + '/store/get_cart_details',
											data: n,
											crossDomain: !0,
											success: function (t) {
												if (
													(e(checkout_selectors).attr('disabled', !1),
													!e.isEmptyObject(t))
												) {
													var i = t.discounts.cart_item_price_selectors
													window.hulk_po_currency_symbol =
														t.discounts.currency_symbol
													var o =
														t.discounts.cart_item_line_price_selectors
													;(window.cart_lineitem_parents_selectors =
														t.discounts.cart_lineitem_parents_selectors.split(
															','
														)[0]),
														(window.cart_item_properties_selectors =
															t.discounts.cart_item_properties_selectors.split(
																','
															)[0]),
														t.discounts.cart.items.forEach(function (
															t,
															n
														) {
															setTimeout(function () {
																a &&
																	t.key == a &&
																	((i = i.split(',')),
																	e.each(i, function (i, e) {
																		window.currentEditOptionSelector
																			.parents(
																				window.cart_lineitem_parents_selectors
																			)
																			.find(e)
																			.html(
																				t.original_price_format
																			)
																	}),
																	(o = o.split(',')),
																	e.each(o, function (i, e) {
																		window.currentEditOptionSelector
																			.parents(
																				window.cart_lineitem_parents_selectors
																			)
																			.find(e)
																			.html(
																				t.original_line_price_format
																			)
																	}))
															}, 500)
														}),
														hulkappsDoActions(t),
														(window.hulk_inventory_arr =
															t.discounts.inventory_arr),
														t.discounts.is_draft_order
															? (window.is_draft_order = !0)
															: (window.is_draft_order = !1),
														t.discounts.inventory_arr &&
															t.discounts.inventory_arr.length <= 0 &&
															e(
																'.inventory_validation_hulkapps'
															).remove()
												}
											},
											error: function (t, i) {
												e(checkout_selectors).attr('disabled', !1)
											},
										})
								})
								.catch(function (t) {
									console.error(t)
								})
					}
				})
				.catch(function (t) {})
		}),
		(window.cartPageJS = function (t) {
			t(document).on('keypress', '.hulkapps_discount_code', function (i) {
				13 == i.which && t('.hulkapps_discount_button').click()
			}),
				t(document).on('click', '.hulkapps_discount_button', function (i) {
					i.preventDefault()
					var e = t(this)
						.parents('.discount_code_box')
						.find('.hulkapps_discount_code')
						.val()
					'' == (e = t.trim(e))
						? t('.hulkapps_discount_code').addClass('discount_error')
						: (localStorage.setItem('discount_code', e),
						  t('.hulkapps_discount_code').removeClass('discount_error')),
						window.getCartInfo()
				}),
				t(document).on('click', '.close-tag', function (t) {
					localStorage.removeItem('discount_code'), window.getCartInfo()
				}),
				t(document).on('click', '.hulkapp_save', function (i) {
					i.preventDefault()
					var e =
							parseInt(
								t(this)
									.parents('.hulkapp_popupBox')
									.find('.hulkapp_mainContent')
									.find('.h_index')
									.val()
							) + 1,
						a = t(this).attr('data-quantity'),
						o = t(this)
							.parents('.hulkapp_popupBox')
							.find('.hulkapp_mainContent')
							.find('.h_variant_id')
							.val(),
						n = {}
					new Promise((i, e) => {
						var a = validate_options(
							t(this).data('product_id'),
							'hulkapps_edit_product_options',
							t(this).attr('data-quantity')
						)
						i(a)
					})
						.then(function (i) {
							if (i) {
								if (
									(t(checkout_selectors).attr('disabled', !0),
									t("#edit_cart_popup [name^='properties']").each(function (
										i,
										e
									) {
										var a
										'' == t(this).val() && t(this).remove(),
											'radio' == this.type
												? this.checked &&
												  ((a = this.name
														.replace('properties[', '')
														.replace(']', '')),
												  t.trim(this.value).length > 0 &&
														(n[a] = this.value))
												: (this.type,
												  (a = this.name
														.replace('properties[', '')
														.replace(']', '')),
												  t.trim(this.value).length > 0 &&
														(n[a] = this.value))
									}),
									t.isEmptyObject(n))
								)
									'' != t('.upload_cls').val()
										? t('.upload_h_cls').remove()
										: t('.upload_cls').remove(),
										t('#edit_cart_popup .conditional').each(function (i, e) {
											t(this)
												.find('.hulkapps_option_value input[type="hidden"]')
												.val('')
										}),
										t("[name^='properties']").each(function (i, e) {
											'' == t(this).val() && t(this).remove()
										}),
										t.ajax({
											type: 'POST',
											url: '/cart/change.js',
											data: { quantity: 0, line: e },
											dataType: 'json',
											success: function (i) {
												'' != t('.upload_cls').val()
													? t('.upload_h_cls').remove()
													: t('.upload_cls').remove(),
													t('#edit_cart_popup .conditional').each(
														function (i, e) {
															t(this)
																.find(
																	'.hulkapps_option_value input[type="hidden"]'
																)
																.val('')
														}
													),
													t("[name^='properties']").each(function (i, e) {
														'' == t(this).val() && t(this).remove()
													}),
													t.ajax({
														type: 'POST',
														url: '/cart/add.js',
														data: { quantity: a, id: o },
														dataType: 'json',
														success: function (i) {
															window.currentEditOptionSelector.data(
																'key',
																i.key
															),
																window.getCartInfo(i),
																t('.hulkapp_close').click()
														},
													})
											},
										})
								else {
									var l = new FormData(t('#edit_cart_popup')[0])
									l.append('quantity', a),
										l.append('line', e),
										'' != t('.upload_cls').val()
											? t('.upload_h_cls').remove()
											: t('.upload_cls').remove(),
										t('#edit_cart_popup .conditional').each(function (i, e) {
											t(this)
												.find('.hulkapps_option_value input[type="hidden"]')
												.val('')
										}),
										t("[name^='properties']").each(function (i, e) {
											'' == t(this).val() && t(this).remove()
										}),
										t.ajax({
											type: 'POST',
											url: '/cart/change.js',
											data: { quantity: 0, line: e },
											dataType: 'json',
											success: function (i) {
												'' != t('.upload_cls').val()
													? t('.upload_h_cls').remove()
													: t('.upload_cls').remove(),
													t('#edit_cart_popup .conditional').each(
														function (i, e) {
															t(this)
																.find(
																	'.hulkapps_option_value input[type="hidden"]'
																)
																.val('')
														}
													),
													t("[name^='properties']").each(function (i, e) {
														'' == t(this).val() && t(this).remove()
													}),
													t.ajax({
														type: 'POST',
														url: '/cart/add.js',
														data: l,
														dataType: 'json',
														contentType: !1,
														processData: !1,
														success: function (i) {
															window.currentEditOptionSelector.data(
																'key',
																i.key
															),
																window.getCartInfo(i),
																t('.hulkapp_close').click()
														},
													})
											},
										})
								}
							}
						})
						.catch(function (t) {
							console.log(t)
						})
				}),
				t(document).on('click touchstart', '.hulkapp_close', function (i) {
					t('.edit_popup').hide(), t('body').removeClass('body_fixed')
				})
		}),
		(window.productPageJS = function ($) {
			function resolveInventory(t, i, e = '') {
				var e = e,
					a = {},
					o = !1
				return (
					!1 == i && (o = !0),
					new Promise((t, i) => {
						$.getJSON('/cart.js', { _: new Date().getTime() }, function (i) {
							i &&
								i.item_count > 0 &&
								i.items.forEach(function (t) {
									var i = t.quantity
									null != t.properties &&
										t.properties != {} &&
										$.each(t.properties, function (t, e) {
											if (t.startsWith('_hin') && e) {
												if (
													((!0 == window.opt_with_otc[t] ||
														'true' == window.opt_with_otc[t]) &&
														(i = 1),
													e.includes(','))
												)
													e.split(',').forEach(function (e) {
														let o = e.split('_hin_')[0]
														a[(o = t + $.trim(o.split('[')[0]))]
															? (a[o] = a[o] + i)
															: (a[o] = i)
													})
												else {
													var o = $.trim(
														e.split('_hin_')[1].split('|')[1]
													)
													;(o = o.includes(')')
														? parseInt(o.split(')'))
														: 1) <= 0 && (o = 1)
													let n =
														t +
														$.trim(e.split('_hin_')[0].split('[')[0])
													a[n] ? (a[n] = a[n] + i * o) : (a[n] = i * o)
												}
											}
										})
								}),
								t(a)
						})
					})
						.then(function (a) {
							return (
								$('.' + t)
									.find('.inventory_error')
									.remove(),
								$('.' + t)
									.find('.hulk_unique_prop')
									.each(function () {
										var t = $(this).data('selection-multi')
										if (void 0 != t && !0 == t) {
											var n = $(this),
												l = $(this).val().split(', ')
											$.each(l, function (t, l) {
												if ('' != l) {
													var s = l.split('_hin_')[1]
													if (
														((s = parseInt(s)),
														!0 ==
															window.opt_with_otc[
																n.data('unique_prop_name')
															] ||
															'true' ==
																window.opt_with_otc[
																	n.data('unique_prop_name')
																])
													)
														var p = 1
													else if ('' != e) var p = parseInt(e)
													else
														var p = parseInt(
															$('input[name=quantity]').val()
														)
													let r = l.split('_hin_')[0]
													if (
														a[
															(r =
																n.attr('data-unique_prop_name') +
																$.trim(r.split('[')[0]))
														]
													) {
														var d = a[r]
														p += parseInt(d)
													}
													if (d) var u = parseInt(s) - parseInt(d)
													else var u = parseInt(s)
													s < p
														? ($(n)
																.parents('.hulkapps_option')
																.addClass('validation_error'),
														  u > 0
																? $(n)
																		.parents('.hulkapps_option')
																		.append(
																			`<p class="inventory_error" tabindex="0" aria-label="Only ${u} inventory available for this ${
																				l.split('_hin_')[0]
																			} option. </p>">Only ${u} inventory available for this ${
																				l.split('_hin_')[0]
																			} option. </p>`
																		)
																: $(n)
																		.parents('.hulkapps_option')
																		.append(
																			`<p class="inventory_error" tabindex="0" aria-label="Not enough items in the inventory for ${
																				l.split('_hin_')[0]
																			}.">Not enough items in the inventory for ${
																				l.split('_hin_')[0]
																			}. </p>`
																		),
														  (o = !0),
														  (i = !1))
														: ($(n)
																.parents('.hulkapps_option')
																.removeClass('validation_error'),
														  $(n)
																.parents('.hulkapps_option')
																.find('.inventory_error')
																.remove(),
														  (o = !1),
														  (i = !0))
												}
											})
										} else if ('' != $(this).val()) {
											var s = $(this).val().split('_hin_')[1]
											if (
												((s = parseInt(s)),
												!0 ==
													window.opt_with_otc[
														$(this).data('unique_prop_name')
													] ||
													'true' ==
														window.opt_with_otc[
															$(this).data('unique_prop_name')
														])
											)
												var p = 1
											else if ('' != e) var p = parseInt(e)
											else var p = parseInt($('input[name=quantity]').val())
											var r = 1
											$(this)
												.parents('.hulkapps_option_value')
												.find('.hulk_options_quantity').length > 0 &&
												(r = parseInt(
													$(this)
														.parents('.hulkapps_option_value')
														.find('.hulk_options_quantity')
														.val()
												)) <= 0 &&
												(r = 1),
												(p *= r)
											let d = $(this).val().split('_hin_')[0]
											if (
												a[
													(d =
														$(this).attr('data-unique_prop_name') +
														$.trim(d.split('[')[0]))
												] &&
												'' == e
											) {
												var u = a[d]
												p += parseInt(u)
											}
											if (u) var h = parseInt(s) - parseInt(u)
											else var h = parseInt(s)
											s < p
												? ($(this)
														.parents('.hulkapps_option')
														.addClass('validation_error'),
												  $(this)
														.parents('.hulkapps_option')
														.find('.inventory_error')
														.remove(),
												  h > 0
														? $(this)
																.parents('.hulkapps_option')
																.append(
																	`<p class="inventory_error" tabindex="0" aria-label="Only ${h} inventory available for this ${
																		$(this)
																			.val()
																			.split('_hin_')[0]
																	} option.">Only ${h} inventory available for this ${
																		$(this)
																			.val()
																			.split('_hin_')[0]
																	} option. </p>`
																)
														: $(this)
																.parents('.hulkapps_option')
																.append(
																	`<p class="inventory_error" tabindex="0" aria-label="Not enough items in the inventory for ${
																		$(this)
																			.val()
																			.split('_hin_')[0]
																	}">Not enough items in the inventory for ${
																		$(this)
																			.val()
																			.split('_hin_')[0]
																	}. </p>`
																),
												  (o = !0),
												  (i = !1))
												: ($(this)
														.parents('.hulkapps_option')
														.find('.inventory_error')
														.remove(),
												  $(this)
														.parents('.hulkapps_option')
														.removeClass('validation_error'),
												  (i = !0),
												  (o = !1))
										}
									}),
								!0 != o && i
							)
						})
						.catch(function (t) {
							return !0
						})
				)
			}
			$(document).on('click', '.popup_open_link', function (t) {
				var i = $(this).attr('data-id')
				$('#popupdetailsdesing_' + i).css('display', 'flex'),
					$('.overlay-popup').css('display', 'block')
			}),
				$(document).on('click', '.popup_close_link', function (t) {
					var i = $(this).attr('data-id')
					$('#popupdetailsdesing_' + i).css('display', 'none'),
						$('.overlay-popup').css('display', 'none')
				}),
				(window.conditional_rules = function (prod_id, hulkapps_parents = '') {
					var hulkapps_parents = hulkapps_parents
					if (
						('' == hulkapps_parents && (hulkapps_parents = 'hulkapps_product_options'),
						window.dynamic_checkout_button_integration &&
							'hulkapps_product_options' == hulkapps_parents)
					) {
						var i,
							total = 0
						for (
							window.hulkapps.money_format,
								checked_variant = $(
									'.' +
										hulkapps_parents +
										' #hulkapps_option_list_' +
										window.hulkapps.product_id +
										':visible .price-change:checked, .' +
										hulkapps_parents +
										' #hulkapps_option_list_' +
										window.hulkapps.product_id +
										':visible .price-change:selected, .' +
										hulkapps_parents +
										' .hulkapps_swatch_option .swatch_selected,.' +
										hulkapps_parents +
										' .textarea_selected,.' +
										hulkapps_parents +
										' .textbox_selected,.' +
										hulkapps_parents +
										' .emailbox_selected,.' +
										hulkapps_parents +
										' .datepicker_selected,.' +
										hulkapps_parents +
										' .numberfield_selected,.' +
										hulkapps_parents +
										' .colorpicker_selected,.' +
										hulkapps_parents +
										' .button_selected,.' +
										hulkapps_parents +
										' .googlefont_selected, .' +
										hulkapps_parents +
										' .ci_render .hulkapps_option_value .hulkapps_option_child .dropdown_selected'
								),
								i = 0;
							i < checked_variant.length;
							i++
						)
							$(checked_variant[i])
								.parents('.hulkapps_option')
								.hasClass('conditional') ||
								(total =
									Number($(checked_variant[i]).attr('data-price')) +
									Number(total))
						if (total > 0 || window.is_hulk_required_options) {
							var is_hulk_payment_set = !1
							let hulk_shopify_button = setInterval(function () {
								$('.shopify-payment-button').length > 0 &&
									($('.shopify-payment-button')
										.html()
										.includes('ShopifyPay-button') ||
										$('.shopify-payment-button')
											.html()
											.includes('Checkout-button')) &&
									($('.hulk_buy_now_handle').length <= 0
										? ($('.shopify-payment-button')
												.html()
												.includes('ShopifyPay-button')
												? $('.shopify-payment-button').wrap(
														"<a class='hulk-buy_now hulk_buy_now_handle' data-testid='ShopifyPay-button'></div>"
												  )
												: $('.shopify-payment-button').wrap(
														"<a class='hulk-buy_now hulk_buy_now_handle' data-testid='Checkout-button'></div>"
												  ),
										  $('.shopify-payment-button').css({
												'pointer-events': 'none',
										  }))
										: ($('.hulk_buy_now_handle').addClass('hulk-buy_now'),
										  $('.shopify-payment-button').css({
												'pointer-events': 'none',
										  }))),
									(is_hulk_payment_set = !0),
									clearInterval(hulk_shopify_button)
							}, 1e3)
							$('.shopify-payment-button').length > 0 &&
								($('.shopify-payment-button')
									.html()
									.includes('ShopifyPay-button') ||
									$('.shopify-payment-button')
										.html()
										.includes('Checkout-button')) &&
								($('.hulk_buy_now_handle').length <= 0
									? ($('.shopify-payment-button')
											.html()
											.includes('ShopifyPay-button')
											? $('.shopify-payment-button').wrap(
													"<a class='hulk-buy_now hulk_buy_now_handle' data-testid='ShopifyPay-button'></div>"
											  )
											: $('.shopify-payment-button').wrap(
													"<a class='hulk-buy_now hulk_buy_now_handle' data-testid='Checkout-button'></div>"
											  ),
									  $('.shopify-payment-button').css({
											'pointer-events': 'none',
									  }))
									: ($('.hulk_buy_now_handle').addClass('hulk-buy_now'),
									  $('.shopify-payment-button').css({
											'pointer-events': 'none',
									  })))
						} else
							$('.shopify-payment-button').css({ 'pointer-events': 'inherit' }),
								$('.hulk_buy_now_handle').removeClass('hulk-buy_now')
					}
					;(pass = !1),
						(verify_all = []),
						(verify_any = []),
						(verified_condition = []),
						(pass_array = []),
						$('.' + hulkapps_parents)
							.find('.condition_hide')
							.removeClass('conditional'),
						$('.' + hulkapps_parents)
							.find('.condition_show')
							.addClass('conditional'),
						$('.' + hulkapps_parents + '  #conditional_rules')
							.children()
							.each(function () {
								;(pass_array = []),
									(pass = !1),
									$(this)
										.children()
										.each(function () {
											pass = !1
											var field_value,
												condition_rule = $(this).text()
											if (
												!0 ==
												$('.' + hulkapps_parents)
													.find(
														'.option_type_id_' +
															$(this).attr('data-field-num')
													)
													.hasClass('dd_multi_render')
											) {
												var aa = condition_rule
												aa.indexOf('!=') >= 0 && (pass = !0)
												var count = $('.' + hulkapps_parents).find(
														'.hulkapps_option_' +
															$(this).attr('data-field-num') +
															'_visible:visible :selected'
													).length,
													ct = 1,
													selected_array = []
												$('.' + hulkapps_parents).find(
													'.hulkapps_option_' +
														$(this).attr('data-field-num') +
														'_visible:visible :selected'
												).length > 0
													? $('.' + hulkapps_parents)
															.find(
																'.hulkapps_option_' +
																	$(this).attr('data-field-num') +
																	'_visible:visible :selected'
															)
															.each(function () {
																var condition_rule = aa
																if (
																	((field_value =
																		$(this).data(
																			'conditional-value'
																		)),
																	(condition_rule =
																		condition_rule.replace(
																			'**value11**',
																			field_value
																		)).indexOf('==') >= 0)
																) {
																	var condition_rule =
																		condition_rule.split('==')
																	pass =
																		condition_rule[0] ==
																		condition_rule[1]
																} else {
																	var condition_rule =
																		condition_rule.split('!=')
																	pass =
																		condition_rule[0] !=
																		condition_rule[1]
																}
																if (
																	(selected_array.push(pass),
																	ct == count && count > 1)
																) {
																	var result =
																		selected_array.join(' || ')
																	;(result = eval(result)),
																		pass_array.push(result)
																} else 1 == count && pass_array.push(pass)
																ct += 1
															})
													: pass_array.push(!1)
											} else if (
												!0 ==
												$(
													'.option_type_id_' +
														$(this).attr('data-field-num')
												).hasClass('cb_render')
											) {
												var aa = condition_rule
												aa.indexOf('!=') >= 0 && (pass = !0)
												var ctt = 1,
													checked_array = [],
													countt = $('.' + hulkapps_parents).find(
														'.hulkapps_option_' +
															$(this).attr('data-field-num') +
															'_visible:checked'
													).length
												$('.' + hulkapps_parents)
													.find(
														'.hulkapps_option_' +
															$(this).attr('data-field-num') +
															'_visible:checked'
													)
													.each(function () {
														var condition_rule = aa
														if (
															((field_value =
																$(this).data('conditional-value')),
															(condition_rule =
																condition_rule.replace(
																	'**value11**',
																	field_value
																)).indexOf('==') >= 0)
														) {
															var condition_rule =
																condition_rule.split('==')
															pass =
																condition_rule[0] ==
																condition_rule[1]
														} else {
															var condition_rule =
																condition_rule.split('!=')
															pass =
																condition_rule[0] !=
																condition_rule[1]
														}
														if (
															(checked_array.push(pass),
															ctt == countt && countt > 1)
														) {
															var result = checked_array.join(' || ')
															;(result = eval(result)),
																pass_array.push(result)
														} else 1 == countt && pass_array.push(pass)
														ctt += 1
													})
											} else if (
												!0 ==
												$('.' + hulkapps_parents)
													.find(
														'#hulkapps_option_list_' +
															prod_id +
															' .option_type_id_' +
															$(this).attr('data-field-num')
													)
													.hasClass('multiswatch_render')
											) {
												var aa = condition_rule
												aa.indexOf('!=') >= 0 && (pass = !0)
												var ctt = 1,
													checked_array = [],
													countt = $('.' + hulkapps_parents).find(
														'#hulkapps_option_list_' +
															prod_id +
															' .hulkapps_option_' +
															$(this).attr('data-field-num') +
															'_visible:checked'
													).length
												$('.' + hulkapps_parents)
													.find(
														'#hulkapps_option_list_' +
															prod_id +
															' .hulkapps_option_' +
															$(this).attr('data-field-num') +
															'_visible:checked'
													)
													.each(function () {
														var condition_rule = aa
														if (
															((field_value =
																$(this).data('conditional-value')),
															(condition_rule =
																condition_rule.replace(
																	'**value11**',
																	field_value
																)).indexOf('==') >= 0)
														) {
															var condition_rule =
																condition_rule.split('==')
															pass =
																condition_rule[0] ==
																condition_rule[1]
														} else {
															var condition_rule =
																condition_rule.split('!=')
															pass =
																condition_rule[0] !=
																condition_rule[1]
														}
														if (
															(checked_array.push(pass),
															ctt == countt && countt > 1)
														) {
															var result = checked_array.join(' || ')
															;(result = eval(result)),
																pass_array.push(result)
														} else 1 == countt && pass_array.push(pass)
														ctt += 1
													})
											} else {
												if (
													((pass = !1),
													!0 ==
														$('.' + hulkapps_parents)
															.find(
																'.option_type_id_' +
																	$(this).attr('data-field-num')
															)
															.hasClass('ci_render'))
												)
													field_value = $('.' + hulkapps_parents)
														.find('#' + $(this).attr('data-field-num'))
														.find('.dropdown_selected')
														.attr('data-conditional-value')
												else if (
													!0 ==
													$('.' + hulkapps_parents)
														.find(
															'.option_type_id_' +
																$(this).attr('data-field-num')
														)
														.hasClass('dd_render')
												)
													field_value = $('.' + hulkapps_parents)
														.find(
															'#' +
																$(this).attr('data-field-num') +
																' option:selected'
														)
														.attr('data-conditional-value')
												else if (
													!0 ==
													$('.' + hulkapps_parents)
														.find(
															'.option_type_id_' +
																$(this).attr('data-field-num')
														)
														.hasClass('rb_render')
												)
													field_value = $('.' + hulkapps_parents)
														.find(
															'.hulkapps_option_' +
																$(this).attr('data-field-num') +
																':checked'
														)
														.data('conditional-value')
												else if (
													!0 ==
													$('.' + hulkapps_parents)
														.find(
															'.option_type_id_' +
																$(this).attr('data-field-num')
														)
														.hasClass('swatch_render')
												)
													field_value = $('.' + hulkapps_parents)
														.find(
															'.hulkapps_option_' +
																$(this).attr('data-field-num') +
																'.swatch_selected'
														)
														.data('conditional-value')
												else if (
													!0 ==
													$('.' + hulkapps_parents)
														.find(
															'.option_type_id_' +
																$(this).attr('data-field-num')
														)
														.hasClass('button_render')
												)
													field_value = $('.' + hulkapps_parents)
														.find(
															'.hulkapps_option_' +
																$(this).attr('data-field-num') +
																'.button_selected'
														)
														.data('conditional-value')
												else if (
													!0 ==
													$('.' + hulkapps_parents)
														.find(
															'.option_type_id_' +
																$(this).attr('data-field-num')
														)
														.hasClass('dp_render')
												) {
													if (
														void 0 !=
														(field_value = $('.' + hulkapps_parents)
															.find(
																'.hulkapps_option_' +
																	$(this).attr('data-field-num') +
																	'.datepicker_selected'
															)
															.val())
													) {
														var splitedValues = field_value.split('-')
														field_value =
															splitedValues[1] +
															'/' +
															splitedValues[2] +
															'/' +
															splitedValues[0]
													}
												} else
													field_value =
														!0 ==
														$('.' + hulkapps_parents)
															.find(
																'.option_type_id_' +
																	$(this).attr('data-field-num')
															)
															.hasClass('dt_render')
															? $('.' + hulkapps_parents)
																	.find(
																		'.hulkapps_option_' +
																			$(this).attr(
																				'data-field-num'
																			) +
																			'.datetimepicker_selected'
																	)
																	.val()
															: $('.' + hulkapps_parents)
																	.find(
																		'#' +
																			$(this).attr(
																				'data-field-num'
																			)
																	)
																	.val()
												if (
													(condition_rule = condition_rule.replace(
														'**value11**',
														field_value
													)).indexOf('==') >= 0
												) {
													var condition_rule = condition_rule.split('==')
													pass = condition_rule[0] == condition_rule[1]
												} else {
													var condition_rule = condition_rule.split('!=')
													pass = condition_rule[0] != condition_rule[1]
												}
												pass_array.push(pass)
											}
										})
								var type_rule = $(this).attr('data-verify-all'),
									condition_id = $(this).attr('name')
								if ('0' == type_rule) var res = pass_array.join(' || ')
								else var res = pass_array.join(' && ')
								;(res = eval(res)) &&
									($('.' + hulkapps_parents)
										.find('.' + condition_id + '_show')
										.removeClass('conditional'),
									$('.' + hulkapps_parents)
										.find('.' + condition_id + '_hide')
										.addClass('conditional'),
									$('.' + hulkapps_parents)
										.find('.conditional')
										.removeClass('validation_error'))
							}),
						$('.' + hulkapps_parents + ' #conditional_rules')
							.children()
							.each(function () {
								var t = $(this).attr('name'),
									i = $('.' + hulkapps_parents).find(
										'.' + t + '_hide.conditional'
									),
									e = $('.' + hulkapps_parents).find(
										'.' + t + '_show.conditional'
									)
								i.each(function () {
									var t = $(this).hasClass('price-change'),
										i = $(this)
									t
										? $(this)
												.parent('.hulkapps_option_child')
												.each(function () {
													'UL' == $(this).prop('tagName')
														? $(this)
																.children('.dropdown_selected')
																.data('value') == i.data('value') &&
														  conditional_change($(this))
														: $(this).val().includes(i.val()) &&
														  conditional_change($(this))
												})
										: $(this)
												.find('.hulkapps_option_child')
												.each(function () {
													conditional_change($(this))
												})
								}),
									e.each(function () {
										var t = $(this).hasClass('price-change'),
											i = $(this)
										t
											? $(this)
													.parent('.hulkapps_option_child')
													.each(function () {
														$(this).val().includes(i.val()) &&
															conditional_change($(this))
													})
											: $(this)
													.find('.hulkapps_option_child')
													.each(function () {
														conditional_change($(this))
													})
									})
							}),
						calc_options_total(prod_id, hulkapps_parents)
				}),
				(window.conditional_change = function (t) {
					if ('select-one' == t.prop('type'))
						t.val() &&
							(t.val('').change(),
							t.parent().find('.hulk_unique_sku').prop('disabled', 'true'),
							t.parent().removeClass('selected'))
					else if ('select-multiple' == t.prop('type'))
						t.val() &&
							(t.parent().find('.hulk_unique_sku').prop('disabled', 'true'),
							t.val(''),
							t.parent('.hulkapps_option_value').find('input[type=hidden]').val(''),
							t.parent().removeClass('selected'))
					else if ('radio' == t.prop('type'))
						t.prop('checked') &&
							(t
								.parents('.hulkapps_option_value')
								.find('.hulk_radiobutton_hidden_prop')
								.val(''),
							t.parents('.hulkapps_option_value').find('.hulk_unique_prop').val(''),
							t.prop('checked', !1),
							t.parent().find('.radio_selected').removeClass('radio_selected'),
							t.parent('label').find('.hulk_unique_sku').prop('disabled', 'true'))
					else if ('file' == t.prop('type'))
						t.val(''), t.parent('.hulkapps_option_value').find('.upload_h_cls').val('')
					else if (
						'text' == t.prop('type') &&
						t.parents('.hulkapps_option').hasClass('gf_render')
					)
						t.val() &&
							(t.parents('.hulkapps_option_value').find('.gf_property_val').val(''),
							t.parents('.hulkapps_option_value').find('#valid-msg').remove())
					else if (
						'textarea' == t.prop('type') ||
						'number' == t.prop('type') ||
						'text' == t.prop('type') ||
						'hidden' == t.prop('type') ||
						'file' == t.prop('type') ||
						'email' == t.prop('type')
					)
						t.val() &&
							(t.val('').change(),
							t.parents('.hulkapps_option_value').find('.tb_property_val').val(''),
							t.parents('.hulkapps_option_value').find('#valid-msg').remove())
					else if ('color' == t.prop('type') || 'color_picker' == t.prop('type'))
						t.val() &&
							(t.parents('.hulkapps_option_value').find('.cp_property_val').val(''),
							t.parents('.hulkapps_option_value').find('#valid-msg').remove())
					else if ('date' == t.prop('type') || 'date_picker' == t.prop('type'))
						t.val() &&
							(t.val('').change(),
							t.parents('.hulkapps_option_value').find('.dp_property_val').val(''),
							t.parents('.hulkapps_option_value').find('#valid-msg').remove())
					else if ('checkbox' == t.prop('type'))
						t.prop('checked') &&
							(t.prop('checked', !1).change(),
							t.parent().removeClass('swatch_selected'))
					else if ('DIV' == t.prop('tagName')) {
						if (
							(t.find('.swatch_radio').prop('checked') &&
								(t.find('.swatch_radio').prop('checked', !1),
								t.find('.swatch_radio').removeAttr('checked'),
								t
									.parents('.hulkapps_option_value')
									.find('.hulk_swatch_hidden_prop')
									.val(''),
								t
									.parents('.hulkapps_option_value')
									.find('.hulk_unique_prop')
									.val(''),
								t.removeClass('swatch_selected'),
								t
									.parents('label')
									.find('.hulk_unique_sku')
									.prop('disabled', 'true')),
							t.find('.button_radio').prop('checked') &&
								(t
									.parents('.hulkapps_option_value')
									.find('.hulk_button_hidden_prop')
									.val(''),
								t
									.parents('.hulkapps_option_value')
									.find('.hulk_unique_prop')
									.val(''),
								t.find('.button_radio').removeAttr('checked'),
								t.removeClass('button_selected'),
								t
									.parents('label')
									.find('.hulk_unique_sku')
									.prop('disabled', 'true')),
							t.find('.swatch_checkbox').prop('checked'))
						) {
							t.find('.swatch_checkbox').prop('checked', !1)
							var i = t.parent().parent().parent().parent('.hulkapps_option_value'),
								e = []
							i.find('input[type=checkbox]:checked').each(function () {
								e.push($(this).val())
							}),
								i
									.find('input[type=hidden]')
									.not('.hulk_unique_sku')
									.val(e.join(',')),
								t.removeClass('swatch_selected'),
								t.parents('label').find('.hulk_unique_sku').prop('disabled', 'true')
						}
					} else if ('UL' == t.prop('tagName')) {
						if (
							(t.find('.hulk_unique_sku').prop('disabled', 'true'),
							t.find('.dropdown_selected').length > 0)
						) {
							var a = t
								.parents('.ci_render')
								.find('.hulkapps_option_name')
								.attr('data-option-name')
							t
								.find('.init')
								.html('')
								.html('Choose ' + a),
								t.find('.dropdown_selected').removeClass('dropdown_selected'),
								t.parent('.hulkapps_option_value').find('.hulk_opt_prop').val(''),
								t
									.parent('.hulkapps_option_value')
									.find('.hulk_unique_prop')
									.val(''),
								t.find('.hulk_unique_sku').prop('disabled', 'false')
						}
					} else if (
						'LABEL' == t.prop('tagName') &&
						(t.find('.swatch_radio').prop('checked') &&
							(t.find('.swatch_radio').prop('checked', !1).change(),
							t.find('.swatch_radio').removeAttr('checked'),
							t.removeClass('swatch_selected'),
							t.parents('label').find('.hulk_unique_sku').prop('disabled', 'true')),
						t.find('.button_radio').prop('checked') &&
							(t.find('.button_radio').prop('checked', !1).change(),
							t.find('.button_radio').removeAttr('checked'),
							t.removeClass('button_selected'),
							t.parents('label').find('.hulk_unique_sku').prop('disabled', 'true')),
						t.find('.swatch_checkbox').prop('checked'))
					) {
						t.find('.swatch_checkbox').prop('checked', !1)
						var i = t.parent('.hulkapps_option_value'),
							e = []
						i.find('input[type=checkbox]:checked').each(function () {
							e.push($(this).val())
						}),
							i.find('input[type=hidden]').val(e.join(',')),
							t.removeClass('swatch_selected')
					}
				}),
				(window.calc_options_total = function (t, i = '') {
					if (
						'price_addtional_charge' ==
							(price_setting = display_price_setting.price_setting) ||
						'price_total_charge' == price_setting ||
						'price_append' == price_setting ||
						'price_addtional_charge_beside_price' == price_setting ||
						(1 == display_price_setting.amount_note_display && void 0 == price_setting)
					) {
						var e,
							i = i
						'' == i && (i = 'hulkapps_product_options')
						var a = 0
						for (
							window.hulkapps.money_format,
								checked_variant = $(
									'.' +
										i +
										' #hulkapps_option_list_' +
										t +
										':visible .price-change:checked, .' +
										i +
										' #hulkapps_option_list_' +
										t +
										':visible .price-change:selected, .' +
										i +
										' .hulkapps_swatch_option .swatch_selected,.' +
										i +
										' .textarea_selected,.' +
										i +
										' .textbox_selected,.' +
										i +
										' .emailbox_selected,.' +
										i +
										' .datepicker_selected,.' +
										i +
										' .numberfield_selected,.' +
										i +
										' .colorpicker_selected,.' +
										i +
										' .button_selected,.' +
										i +
										' .googlefont_selected, .' +
										i +
										' .datetimepicker_selected,.' +
										i +
										' .ci_render .hulkapps_option_value .hulkapps_option_child .dropdown_selected, .' +
										i +
										' .formula_selected,.' +
										i +
										' .stg_selected'
								),
								e = 0;
							e < checked_variant.length;
							e++
						)
							if (
								!$(checked_variant[e])
									.parents('.hulkapps_option')
									.hasClass('conditional')
							) {
								var o = 1
								if (
									$(checked_variant[e])
										.parents('.hulkapps_option_value')
										.find('.hulk_options_quantity').length > 0
								)
									var o = parseInt(
										$(checked_variant[e])
											.parents('.hulkapps_option')
											.find('.hulk_options_quantity')
											.val()
									)
								a = Number($(checked_variant[e]).attr('data-price') * o) + Number(a)
							}
						if (
							('price_total_charge' == price_setting &&
								(a = Number(product_price / 100) + Number(a)),
							'price_append' == price_setting &&
								((n = display_price_setting.price_class),
								(a = currency_conversion(Number(product_price / 100) + Number(a))),
								$('#' + n).length > 0
									? $('#' + n).html("<span class='money'>" + a + '</span>')
									: $('.' + n).length > 0 &&
									  $('.' + n).html("<span class='money'>" + a + '</span>'),
								(a = 0)),
							'price_addtional_charge_beside_price' == price_setting)
						) {
							if (a > 0) {
								a = currency_conversion(Number(a))
								var n = display_price_setting.price_class,
									l =
										'1' == display_price_setting.price_display_brackets
											? ''
											: '(',
									s = '1' == display_price_setting.price_plus_sign ? '' : '+',
									p =
										'1' == display_price_setting.price_display_brackets
											? ''
											: ')',
									r = '.hulk_price_addtional_charge_beside_price{'
								;(r +=
									void 0 != display_price_setting.addition_price_font_color
										? 'color: ' +
										  display_price_setting.addition_price_font_color +
										  ';'
										: ''),
									(r +=
										void 0 != display_price_setting.addition_price_font_size
											? 'font-size: ' +
											  display_price_setting.addition_price_font_size +
											  'px;'
											: '')
								var d = '<style>' + (r += '}') + '</style>'
								$('.' + i).append(d),
									$('#' + n).length > 0
										? $('#' + n).html(
												"<span class='money hulk_price_addtional_charge_beside_price'>" +
													l +
													s +
													a +
													p +
													'</span>'
										  )
										: $('.' + n).length > 0 &&
										  $('.' + n).html(
												"<span class='money hulk_price_addtional_charge_beside_price'>" +
													l +
													s +
													a +
													p +
													'</span>'
										  )
							} else {
								var n = display_price_setting.price_class
								$('#' + n).html(''), $('.' + n).html('')
							}
							a = 0
						}
						$('.' + i + ' #raw_option_total').val(a),
							$('.' + i + ' #calculated_option_total').html(a.toFixed(2)),
							$('.' + i + ' #option_display_total_format').attr(
								'aria-label',
								$('.' + i + ' #option_display_total_format').text()
							),
							a > 0
								? $('.' + i + ' #option_total').slideDown()
								: $('.' + i + ' #option_total').slideUp()
					}
				}),
				(window.currency_conversion = function (t) {
					let i = window.hulkapps.money_format
					if (i.includes('{{ amount }}') || i.includes('{{amount}}'))
						return ((t = t
							.toFixed(2)
							.toString()
							.replace(/\B(?=(\d{3})+(?!\d))/g, ',')),
						i.includes('{{ amount }}'))
							? i.replace('{{ amount }}', t)
							: i.replace('{{amount}}', t)
					if (
						i.includes('{{ amount_no_decimals }}') ||
						i.includes('{{amount_no_decimals}}')
					)
						return ((t = Math.round(Number(t))
							.toString()
							.replace(/\B(?=(\d{3})+(?!\d))/g, ',')),
						i.includes('{{ amount_no_decimals }}'))
							? i.replace('{{ amount_no_decimals }}', t)
							: i.replace('{{amount_no_decimals}}', t)
					if (
						i.includes('{{ amount_with_comma_separator }}') ||
						i.includes('{{amount_with_comma_separator}}')
					) {
						if (
							(t = t.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')).includes('.')
						) {
							let e = (t = t.replace(/\B(?=(\d{3})+(?!\d))/g, '.')).lastIndexOf('.')
							t = t.slice(0, e) + t.slice(e).replace('.', ',')
						} else t = t.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
						return i.includes('{{ amount_with_comma_separator }}')
							? i.replace('{{ amount_with_comma_separator }}', t)
							: i.replace('{{amount_with_comma_separator}}', t)
					}
					if (
						i.includes('{{ amount_no_decimals_with_comma_separator }}') ||
						i.includes('{{amount_no_decimals_with_comma_separator}}')
					)
						return ((t = Math.round(Number(t))
							.toString()
							.replace(/\B(?=(\d{3})+(?!\d))/g, '.')),
						i.includes('{{ amount_no_decimals_with_comma_separator }}'))
							? i.replace('{{ amount_no_decimals_with_comma_separator }}', t)
							: i.replace('{{amount_no_decimals_with_comma_separator}}', t)
					if (
						!(
							i.includes('{{ amount_with_apostrophe_separator }}') ||
							i.includes('{{amount_with_apostrophe_separator}}')
						)
					)
						return t
					else
						return ((t = t
							.toFixed(2)
							.toString()
							.replace(/\B(?=(\d{3})+(?!\d))/g, "'")),
						i.includes('{{ amount_with_apostrophe_separator }}'))
							? i.replace('{{ amount_with_apostrophe_separator }}', t)
							: i.replace('{{amount_with_apostrophe_separator}}', t)
				}),
				(window.checkPlan = function (t, i) {
					var e = !0,
						a = window.hulk_po_plan_id,
						o = window.hulk_po_plans_features,
						n = window.hulk_po_is_on_trial_period
					return (
						t && i && o && a && o[a]
							? ('string' == $.type(o) && (o = JSON.parse(o)),
							  !1 == o[a][t] && 'boolean' == i && (e = !1),
							  !0 == n && !0 == o[a][t] && (e = !0))
							: (e = !1),
						e
					)
				}),
				(window.check_character_limit = function (t, i, e, a = '') {
					var a = a
					'' == a && (a = 'hulkapps_product_options')
					var o = $('.' + a + ' .hulkapps_option_value .hulkapps_option_' + i).val()
							.length,
						n = t - o
					$('.' + a + ' #char_count_' + i).html(n + ' ' + e)
				}),
				(window.requireInventory = async function (t, i) {
					$('.' + i)
						.find(
							'#hulkapps_option_list_' +
								t +
								':visible .dd_render.required:visible,.dd_multi_render.required:visible,.swatch_render.required:visible,.cb_render.required:visible,.multiswatch_render.required:visible,.ci_render.required:visible,.rb_render.required:visible,.button_render.required:visible'
						)
						.each(function () {
							if ($(this).hasClass('ci_render')) {
								var t = $(this).find("li[value !='']").length,
									i = $(this).find("li[value !=''].is_hulk_disabled").length
								t == i &&
									($(this).removeClass('required'),
									$(this).find('.hulkapps-required').remove())
							} else if (
								($(this).hasClass('dd_render') ||
									$(this).hasClass('dd_multi_render')) &&
								!$(this).hasClass('ci_render')
							) {
								var t = $(this).find("option[value !='']").length,
									i = $(this).find("option[value !='']:disabled").length
								t == i &&
									($(this).removeClass('required'),
									$(this).find('.hulkapps-required').remove())
							} else if ($(this).hasClass('multiswatch_render')) {
								var t = $(this).find('.hulkapps_mswatch_option').length,
									i = $(this).find(
										".hulkapps_mswatch_option input[type='checkbox']:disabled"
									).length
								t == i &&
									($(this).removeClass('required'),
									$(this).find('.hulkapps-required').remove())
							} else if ($(this).hasClass('swatch_render')) {
								var t = $(this).find('.hulkapps_swatch_option').length,
									i = $(this).find(
										".hulkapps_swatch_option input[type='radio']:disabled"
									).length
								t == i &&
									($(this).removeClass('required'),
									$(this).find('.hulkapps-required').remove())
							} else if ($(this).hasClass('rb_render')) {
								var t = $(this).find('.hulkapps_radio_option').length,
									i = $(this).find(
										".hulkapps_radio_option input[type='radio']:disabled"
									).length
								t == i &&
									($(this).removeClass('required'),
									$(this).find('.hulkapps-required').remove())
							} else if ($(this).hasClass('cb_render')) {
								var t = $(this).find('.hulkapps_check_option').length,
									i = $(this).find(
										".hulkapps_check_option input[type='checkbox']:disabled"
									).length
								t == i &&
									($(this).removeClass('required'),
									$(this).find('.hulkapps-required').remove())
							} else if ($(this).hasClass('button_render')) {
								var t = $(this).find('.hulkapps_buton_option').length,
									i = $(this).find(
										".hulkapps_buton_option input[type='radio']:disabled"
									).length
								t == i &&
									($(this).removeClass('required'),
									$(this).find('.hulkapps-required').remove())
							}
						})
				}),
				(window.validate_options = async function (t, i, e = '') {
					var a,
						e = e,
						i = i
					;('' == i || void 0 == i) && (i = 'hulkapps_product_options')
					var o = !0
					$('.' + i + ' #error_text').html('')
					var n = $('.' + i).find(
						'#hulkapps_option_list_' + t + ':visible .required:visible'
					)
					for (a = 0; a < n.length; a++)
						$(n[a]).hasClass('ci_render') &&
						$(n[a]).find('.hulk_opt_prop').length &&
						!$(n[a]).find('.hulk_opt_prop').val()
							? ($(n[a]).addClass('validation_error'), (o = !1))
							: $(n[a]).hasClass('dd_render') &&
							  $(n[a]).find('.hulk_dropdown_hidden_prop').length &&
							  !$(n[a]).find('.hulk_dropdown_hidden_prop').val()
							? ($(n[a]).addClass('validation_error'), (o = !1))
							: 1 !=
									hulkapps_jQuery(n[a]).find("select[name^='properties']")
										.length ||
							  hulkapps_jQuery(n[a]).find("select[name^='properties']").val()
							? hulkapps_jQuery(n[a])
									.find('.hulkapps_option_value')
									.find("input[name^='properties']").length >= 1 &&
							  !hulkapps_jQuery(n[a])
									.find('.hulkapps_option_value')
									.find("input[name^='properties']:not(.hulk_unique_prop)")
									.val()
								? (hulkapps_jQuery(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find('.hulkapps_radio_option').length &&
								  !$(n[a]).find('.hulk_radiobutton_hidden_prop').val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find('.hulkapps_buton_option').length &&
								  !$(n[a]).find('.hulk_button_hidden_prop').val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find('.hulkapps_swatch_option').length &&
								  !$(n[a]).find('.hulk_swatch_hidden_prop').val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find('.hulkapps_short_option_value').length
								? $(n[a])
										.find("input[type='text']")
										.each(function () {
											'' != $(this).val() ||
												$(this)
													.parents('.hulkapps_short_option_value')
													.hasClass('conditional') ||
												($(n[a]).addClass('validation_error'), (o = !1))
										})
								: $(n[a]).find("input[type='text']").length > 1
								? $(n[a])
										.find("input[type='text']")
										.each(function () {
											'' == $(this).val() &&
												($(n[a]).addClass('validation_error'), (o = !1))
										})
								: $(n[a]).find("input[type='text']").length &&
								  !$(n[a]).find("input[name^='properties']").val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find("input[type='email']").length &&
								  !$(n[a]).find("input[name^='properties']").val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find("input[type='color']").length &&
								  !$(n[a]).find("input[name^='properties']").val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find('.hulkapps_check_option').length &&
								  !$(n[a])
										.find("input[name^='properties']:not(.hulk_unique_sku)")
										.val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find("input[type='file']").length &&
								  !$(n[a]).find("input[name^='properties']").val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).hasClass('cb_render') &&
								  $(n[a]).find("input[type='checkbox']:checked").length &&
								  !$(n[a]).find("input[name^='properties']:not(.hulk_unique_sku)")
										.length
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).hasClass('multiswatch_render') &&
								  $(n[a]).find("input[type='checkbox']:checked").length &&
								  !$(n[a]).find("input[name^='properties']:not(.hulk_unique_sku)")
										.length
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find('textarea').length &&
								  !$(n[a]).find("input[name^='properties']").val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find('select[multiple]').length >= 1 &&
								  !$(n[a])
										.find("input[name^='properties']:not(.hulk_unique_sku)")
										.val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).find("input[type='number']:not(.hulk_options_quantity)")
										.length && !$(n[a]).find("input[name^='properties']").val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).hasClass('dp_render') &&
								  $(n[a]).find("input[type='date']").length &&
								  !$(n[a]).find("input[name^='properties']").val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: $(n[a]).hasClass('dt_render') &&
								  $(n[a]).find("input[type='datetime-local']").length &&
								  !$(n[a]).find("input[name^='properties']").val()
								? ($(n[a]).addClass('validation_error'), (o = !1))
								: hulkapps_jQuery(n[a])
										.find('.hulkapps_option_value')
										.find("input[name^='properties']").length >= 1 &&
								  !hulkapps_jQuery(n[a])
										.find('.hulkapps_option_value')
										.find("input[name^='properties']:not(.hulk_unique_prop)")
										.val()
								? (hulkapps_jQuery(n[a]).addClass('validation_error'), (o = !1))
								: ($(n[a]).removeClass('validation_error'),
								  $(n[a]).removeAttr('aria-label tabindex'))
							: (hulkapps_jQuery(n[a]).addClass('validation_error'), (o = !1))
					return (
						$('.' + i)
							.find('#hulkapps_option_list_' + t + ' .cb_render:visible')
							.each(function () {
								$(this).hasClass('required') &&
								$(this).find("input[type='checkbox']").length
									? $(this)
											.find("input[name^='properties']:not(.hulk_unique_sku)")
											.val()
										? $(this).find('.error_span').length > 0
											? ($(this).addClass('validation_error'), (o = !1))
											: ($(this).removeClass('validation_error'),
											  $(this).removeAttr('aria-label tabindex'))
										: ($(this).addClass('validation_error'), (o = !1))
									: $(this).find('.error_span').length > 0
									? ($(this).addClass('validation_error'), (o = !1))
									: ($(this).removeClass('validation_error'),
									  $(this).removeAttr('aria-label tabindex'))
							}),
						$('.' + i)
							.find('#hulkapps_option_list_' + t + ' .multiswatch_render:visible')
							.each(function () {
								$(this).hasClass('required') &&
								$(this).find("input[type='checkbox']").length
									? $(this)
											.find("input[name^='properties']:not(.hulk_unique_sku)")
											.val()
										? $(this).find('.error_span').length > 0
											? ($(this).addClass('validation_error'), (o = !1))
											: ($(this).removeClass('validation_error'),
											  $(this).removeAttr('aria-label tabindex'))
										: ($(this).addClass('validation_error'), (o = !1))
									: $(this).find('.error_span').length > 0
									? ($(this).addClass('validation_error'), (o = !1))
									: ($(this).removeClass('validation_error'),
									  $(this).removeAttr('aria-label tabindex'))
							}),
						$('#hulkapps_option_list_' + t + ' .dd_multi_render:visible').each(
							function () {
								$(this).hasClass('required') &&
								$(this).find('select[multiple]').length
									? $(this)
											.find("input[name^='properties']:not(.hulk_unique_sku)")
											.val()
										? $(this).find('.error_span').length > 0
											? ($(this).addClass('validation_error'), (o = !1))
											: ($(this).removeClass('validation_error'),
											  $(this).removeAttr('aria-label tabindex'))
										: ($(this).addClass('validation_error'), (o = !1))
									: $(this).find('.error_span').length > 0
									? ($(this).addClass('validation_error'), (o = !1))
									: ($(this).removeClass('validation_error'),
									  $(this).removeAttr('aria-label tabindex'))
							}
						),
						$('.' + i)
							.find('#hulkapps_option_list_' + t + ' .et_render.required:visible')
							.each(function () {
								if (
									$(this).find("input[type='email']").length &&
									((!$(this).find("input[name^='properties']").val() &&
										$(this).hasClass('required')) ||
										'' != $(this).find("input[type='email']").val())
								) {
									var t = $(this).find("input[type='email']").val()
									;/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,5}|[0-9]{1,3})(\]?)$/.test(
										t
									)
										? ($(this).removeClass('validation_error'),
										  $(this).removeAttr('aria-label tabindex'),
										  $(this).find('.error_span').remove())
										: ($(this).addClass('validation_error'),
										  '' != $(this).find("input[type='email']").val() &&
												!$(this).find('.error_span').length > 0 &&
												($(this)
													.find("input[type='email']")
													.after(
														'<span class="validation_error error_span" tabindex="0" aria-label="Invalid email format">Invalid email format</span>'
													),
												$(this).attr('aria-label', 'Invalid email format')),
										  (o = !1))
								}
							}),
						$('.' + i)
							.find('#hulkapps_option_list_' + t + ' .pn_render.required:visible')
							.each(function () {
								$(this).find("input[type='textbox']").length &&
								!$(this).find("input[name^='properties']").val() &&
								$(this).hasClass('required')
									? ($(this).addClass('validation_error'), (o = !1))
									: $(this).find('.phone_number').hasClass('error')
									? ($(this).addClass('validation_error'), (o = !1))
									: ($(this).removeClass('validation_error'),
									  $(this).removeAttr('aria-label tabindex'))
							}),
						$('.' + i)
							.find('#hulkapps_option_list_' + t + ' .dp_render:visible')
							.each(function () {
								$(this).find('.error_span').length > 0
									? ($(this).addClass('validation_error'), (o = !1))
									: ($(this).removeClass('validation_error'),
									  $(this).removeAttr('aria-label tabindex'))
							}),
						$('.' + i)
							.find('#hulkapps_option_list_' + t + ' .dt_render:visible')
							.each(function () {
								$(this).find('.error_span').length > 0
									? ($(this).addClass('validation_error'), (o = !1))
									: ($(this).removeClass('validation_error'),
									  $(this).removeAttr('aria-label tabindex'))
							}),
						$('.' + i)
							.find('#hulkapps_option_list_' + t + ' .dp_render.required:visible')
							.each(function () {
								$(this).find("input[type='date']").length &&
								!$(this).find("input[name^='properties']").val() &&
								$(this).hasClass('required')
									? ($(this).addClass('validation_error'), (o = !1))
									: $(this).find('.error_span').length > 0
									? ($(this).addClass('validation_error'), (o = !1))
									: ($(this).removeClass('validation_error'),
									  $(this).removeAttr('aria-label tabindex'))
							}),
						$('.' + i)
							.find('#hulkapps_option_list_' + t + ' .dt_render.required:visible')
							.each(function () {
								$(this).find("input[type='datetime-local']").length &&
								!$(this).find("input[name^='properties']").val() &&
								$(this).hasClass('required')
									? ($(this).addClass('validation_error'), (o = !1))
									: $(this).find('.error_span').length > 0
									? ($(this).addClass('validation_error'), (o = !1))
									: ($(this).removeClass('validation_error'),
									  $(this).removeAttr('aria-label tabindex'))
							}),
						(o = await resolveInventory(
							i,
							(o = !$('.' + i)
								.find('.fm_option_val')
								.hasClass('validation_error')),
							e
						)),
						$('.' + i)
							.find('.hulkapps_option:visible')
							.each(function () {
								if ($(this).hasClass('validation_error')) {
									o = !1
									var t = $(this).find('.hulkapps_option_name').attr('aria-label')
									void 0 == $(this).attr('aria-label') &&
										$(this).attr({
											'aria-label': `${t} is required`,
											tabindex: 0,
										}),
										$('.validation_error:first').focus()
								}
							}),
						!1 == o && $('.inventory_error,.validation_error').first().focus(),
						o
					)
				}),
				(window.validate_single_option = function (t, i, e = '') {
					var e = e
					if (('' == e && (e = 'hulkapps_product_options'), 'dd_render' == i))
						1 ==
							$('.' + e)
								.find('.' + t)
								.find("select[name^='properties']").length &&
						!$('.' + e)
							.find('.' + t)
							.find("select[name^='properties']:not(.hulk_unique_sku)")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'),
							  $('.' + e)
									.find('.' + t)
									.removeClass('validation_error'))
					else if ('ci_render' == i)
						1 ==
							$('.' + e)
								.find('.' + t)
								.find("input[name^='properties']").length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']:not(.hulk_unique_sku)")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'),
							  $('.' + e)
									.find('.' + t)
									.removeClass('validation_error'))
					else if ('dd_multi_render' == i)
						$('.' + e)
							.find('.' + t)
							.find('select[multiple]').length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']:not(.hulk_unique_sku)")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'),
							  $('.' + e)
									.find('.' + t)
									.removeClass('validation_error'))
					else if ('swatch_render' == i)
						$('.' + e)
							.find('.' + t)
							.removeClass('validation_error'),
							$('.' + e)
								.find('.' + t)
								.removeAttr('aria-label tabindex')
					else if ('multiswatch_render' == i)
						$('.' + e)
							.find('.' + t)
							.find('.hulkapps_swatch_option').length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']:not(.hulk_unique_sku)")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('button_render' == i)
						$('.' + e)
							.find('.' + t)
							.find('.hulkapps_buton_option').length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']:not(.hulk_unique_sku)")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'),
							  $('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('cp_render' == i)
						$('.' + e)
							.find('.' + t)
							.find("input[type='text']").length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('cb_render' == i)
						$('.' + e)
							.find('.' + t)
							.find('.hulkapps_check_option').length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']:not(.hulk_unique_sku)")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('tb_render' == i)
						$('.' + e)
							.find('.' + t)
							.find("input[type='text']").length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('stg_render' == i)
						$('.' + e)
							.find('.' + t)
							.removeClass('validation_error'),
							$('.' + e)
								.find('.' + t)
								.removeAttr('aria-label tabindex'),
							$('.' + e)
								.find('.' + t)
								.hasClass('required') &&
								$('.' + e)
									.find('.' + t)
									.find("input[type='text']")
									.each(function () {
										'' != $(this).val() ||
											$(this)
												.parents('.hulkapps_short_option_value')
												.hasClass('conditional') ||
											$('.' + e)
												.find('.' + t)
												.addClass('validation_error')
									})
					else if ('gf_render' == i)
						$('.' + e)
							.find('.' + t)
							.find("input[type='text']").length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[type='text']")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('nf_render' == i)
						$('.' + e)
							.find('.' + t)
							.find("input[type='number']").length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('dp_render' == i) {
						if (
							$('.' + e)
								.find('.' + t)
								.find("input[type='date']").length &&
							$('.' + e)
								.find('.' + t)
								.find("input[name^='properties']")
								.val()
						) {
							var a = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/,
								o = $('.' + e)
									.find('.' + t)
									.find("input[type='date']")
									.val()
							if (o.includes('-')) {
								var n = o.split('-')
								o = n[1] + '/' + n[2] + '/' + n[0]
							}
							var l = o.match(a)
							if (null == l)
								$('.' + e)
									.find('.' + t)
									.addClass('validation_error'),
									$('.' + e)
										.find('.' + t)
										.find('.validation_error')
										.remove(),
									$('.' + e)
										.find('.' + t)
										.find("input[type='date']")
										.after(
											'<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>'
										)
							else if (
								((dtMonth = l[1]),
								(dtDay = l[3]),
								(dtYear = l[5]),
								dtMonth < 1 || dtMonth > 12)
							)
								$('.' + e)
									.find('.' + t)
									.addClass('validation_error'),
									$('.' + e)
										.find('.' + t)
										.find('.validation_error')
										.remove(),
									$('.' + e)
										.find('.' + t)
										.find("input[type='date']")
										.after(
											'<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>'
										)
							else if (dtDay < 1 || dtDay > 31)
								$('.' + e)
									.find('.' + t)
									.addClass('validation_error'),
									$('.' + e)
										.find('.' + t)
										.find('.validation_error')
										.remove(),
									$('.' + e)
										.find('.' + t)
										.find("input[type='date']")
										.after(
											'<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>'
										)
							else if (
								(4 == dtMonth || 6 == dtMonth || 9 == dtMonth || 11 == dtMonth) &&
								31 == dtDay
							)
								$('.' + e)
									.find('.' + t)
									.addClass('validation_error'),
									$('.' + e)
										.find('.' + t)
										.find('.validation_error')
										.remove(),
									$('.' + e)
										.find('.' + t)
										.find("input[type='date']")
										.after(
											'<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>'
										)
							else if (2 == dtMonth) {
								var s = dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0)
								dtDay > 29 || (29 == dtDay && !s)
									? ($('.' + e)
											.find('.' + t)
											.addClass('validation_error'),
									  $('.' + e)
											.find('.' + t)
											.find('.validation_error')
											.remove(),
									  $('.' + e)
											.find('.' + t)
											.find("input[type='date']")
											.after(
												'<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>'
											))
									: ($('.' + e)
											.find('.' + t)
											.removeClass('validation_error'),
									  $('.' + e)
											.find('.' + t)
											.find('.validation_error')
											.remove(),
									  $('.' + e)
											.find('.' + t)
											.removeAttr('aria-label tabindex'))
							} else
								'/' !== l[2] || '/' !== l[4]
									? ($('.' + e)
											.find('.' + t)
											.addClass('validation_error'),
									  $('.' + e)
											.find('.' + t)
											.find('.validation_error')
											.remove(),
									  $('.' + e)
											.find('.' + t)
											.find("input[type='date']")
											.after(
												'<span class="validation_error error_span" tabindex="0" aria-labe="Enter valid date format mm/dd/yyyy">Enter valid date format mm/dd/yyyy</span>'
											))
									: ($('.' + e)
											.find('.' + t)
											.removeClass('validation_error'),
									  $('.' + e)
											.find('.' + t)
											.find('.validation_error')
											.remove(),
									  $('.' + e)
											.find('.' + t)
											.removeAttr('aria-label tabindex'))
						} else
							$('.' + e)
								.find('.' + t)
								.find("input[type='date']").length &&
							!$('.' + e)
								.find('.' + t)
								.find("input[name^='properties']")
								.val() &&
							$('.' + e)
								.find('.' + t)
								.hasClass('required')
								? ($('.' + e)
										.find('.' + t)
										.addClass('validation_error'),
								  $('.' + e)
										.find('.' + t)
										.find('.validation_error')
										.remove())
								: ($('.' + e)
										.find('.' + t)
										.find('.validation_error')
										.remove(),
								  $('.' + e)
										.find('.' + t)
										.removeClass('validation_error'),
								  $('.' + e)
										.find('.' + t)
										.removeAttr('aria-label tabindex'))
					} else if ('ta_render' == i)
						$('.' + e)
							.find('.' + t)
							.find('textarea').length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('rb_render' == i)
						$('.' + e)
							.find('.' + t)
							.removeClass('validation_error'),
							$('.' + e)
								.find('.' + t)
								.removeAttr('aria-label tabindex')
					else if ('fu_render' == i)
						$('.' + e)
							.find('.' + t)
							.find("input[type='file']").length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? $('.' + e)
									.find('.' + t)
									.addClass('validation_error')
							: ($('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('pn_render' == i)
						$('.' + e)
							.find('.' + t)
							.find("input[type='textbox']").length &&
						!$('.' + e)
							.find('.' + t)
							.find("input[name^='properties']")
							.val() &&
						$('.' + e)
							.find('.' + t)
							.hasClass('required')
							? ($('.' + e)
									.find('.' + t)
									.addClass('validation_error'),
							  (good = !1))
							: $('.' + e)
									.find('.' + t)
									.find('.phone_number')
									.hasClass('error')
							? ($('.' + e)
									.find('.' + t)
									.addClass('validation_error'),
							  (good = !1))
							: ($('.' + e)
									.find('.' + t)
									.removeClass('validation_error'),
							  $('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex'))
					else if ('et_render' == i) {
						if (
							$('.' + e)
								.find('.' + t)
								.find("input[type='email']").length &&
							(($('.' + e)
								.find('.' + t)
								.find("input[name^='properties']")
								.val() &&
								$('.' + e)
									.find('.' + t)
									.hasClass('required')) ||
								'' !=
									$('.' + e)
										.find('.' + t)
										.find("input[type='email']")
										.val().length)
						) {
							var p = $('.' + e)
								.find('.' + t)
								.find("input[type='email']")
								.val()
							;/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,5}|[0-9]{1,3})(\]?)$/.test(
								p
							)
								? ($('.' + e)
										.find('.' + t)
										.removeClass('validation_error'),
								  $('.' + e)
										.find('.' + t)
										.find('.error_span')
										.remove(),
								  $('.' + e)
										.find('.' + t)
										.removeAttr('aria-label tabindex'))
								: ($('.' + e)
										.find('.' + t)
										.addClass('validation_error'),
								  !$('.' + e)
										.find('.' + t)
										.find('.error_span').length > 0 &&
										($('.' + e)
											.find('.' + t)
											.attr('aria-label', 'Invalid email format'),
										$('.' + e)
											.find('.' + t)
											.find("input[type='email']")
											.after(
												'<span class="validation_error error_span" tabindex="0" aria-label="Invalid email format">Invalid email format</span>'
											)))
						} else
							$('.' + e)
								.find('.' + t)
								.removeClass('validation_error'),
								$('.' + e)
									.find('.' + t)
									.find('.error_span')
									.remove(),
								$('.' + e)
									.find('.' + t)
									.removeAttr('aria-label tabindex')
					}
				}),
				$(document).on('change', '.hulk_file_upload', function () {
					var t = $(this).val()
					;/^\s*$/.test(t)
						? ($(this).parents('.file-upload').removeClass('hulk-active'),
						  $(this).parents('.file-upload').find('.noFile').text('No file chosen...'))
						: ($(this).parents('.file-upload').addClass('hulk-active'),
						  $(this)
								.parents('.file-upload')
								.find('.noFile')
								.text(t.replace('C:\\fakepath\\', '')))
				})
			var allOptions = ''
			function changeImage(t) {
				var i = '',
					t = $(t)
				if (
					($('.image_change_with_multiple').each(function () {
						;(first_element = $(this).find('.hulkapps_option_child:first')).attr(
							'data-single_valid-class'
						)
						var t = first_element.attr('data-val-selected-class')
						if ('radio' == $(first_element).prop('type'))
							1 == $(this).find(`.${t}`).length &&
								$.trim(
									$(this)
										.find(`.${t}`)
										.parents('.hulkapps_radio_option')
										.find('.hulkapps_option_child')
										.attr('data-conditional-value')
								) != $.trim(i) &&
								(i +=
									$.trim(
										$(this)
											.find(`.${t}`)
											.parents('.hulkapps_radio_option')
											.find('.hulkapps_option_child')
											.attr('data-conditional-value')
									) + ' ')
						else if ('select-one' == $(first_element).prop('type')) {
							var e = $(first_element).find(':selected').data('conditional-value')
							$.trim(e) != $.trim(i) && (i += $.trim(e) + ' ')
						} else
							1 == $(this).find(`.${t}`).length &&
								$.trim($(this).find(`.${t}`).attr('data-conditional-value')) !=
									$.trim(i) &&
								(i +=
									$.trim($(this).find(`.${t}`).attr('data-conditional-value')) +
									' ')
					}),
					'' != $.trim(i))
				) {
					var e = $.trim(i.toLowerCase())
					$(window.image_parent).each(function () {
						$.trim($(this).attr('alt').toLowerCase().replaceAll('_', ' ')) == e &&
							$(this).click()
					})
				}
			}
			$(document).on('click', 'ul.hulkapps_product_options_ul .init', function () {
				$(this)
					.parent('.hulkapps_option_child')
					.children('li:not(.init)')
					.toggleClass('hulk-flex')
			}),
				$(document).on(
					'click',
					'ul.hulkapps_product_options_ul li:not(.init)',
					function () {
						var t = $(this).parent('ul').attr('data-parent'),
							i = $(this).parent('ul').attr('data-pid')
						$(this)
							.parents('.hulkapps_option_value')
							.find('.hulk_options_quantity')
							.show(),
							$(this).parents('.ci_render').find('.inventory_error').html(''),
							$(this)
								.parents('.ci_render')
								.find('.hulk_unique_sku')
								.prop('disabled', !0)
						var e = $(this).closest('ul').attr('id')
						;(allOptions = $('#' + e).children('li:not(.init)')).removeClass(
							'dropdown_selected'
						),
							$(this).addClass('dropdown_selected'),
							$(this).closest('ul').children('.init').html($(this).html()),
							$(this).closest('ul').children('li:not(.init)').toggleClass('hulk-flex')
						var a = ''
						$(this)
							.parents('.hulkapps_option_value')
							.find('.hulk_options_quantity')
							.val() &&
							(a = ` | ${$(this)
								.parents('.hulkapps_option_value')
								.find('.hulk_options_quantity')
								.val()}`),
							$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop')
								.length > 0 &&
								('' != $(this).data('hinventory')
									? $(this)
											.parents('.hulkapps_option_value')
											.find('.hulk_unique_prop')
											.val(
												$(this).attr('data-value') +
													'_hin_' +
													$(this).data('hinventory') +
													a
											)
									: $(this)
											.parents('.hulkapps_option_value')
											.find('.hulk_unique_prop')
											.val('')),
							$(this)
								.parents('.hulkapps_option_value')
								.find('.hulk_opt_prop')
								.val($(this).attr('data-value') + a),
							$(this).find('.hulk_unique_sku').prop('disabled', !1),
							conditional_rules(parseInt(i), t),
							'1' == $('#hulk_amount_dis').val() &&
								calc_options_total(parseInt(i), t),
							validate_single_option('option_type_id_' + e, 'ci_render', t),
							changeImage(this)
					}
				),
				$(document).on(
					'click',
					'.hulkapps_product_options_ul_parent .hulk_options_quantity',
					function () {
						$(this)
							.parents('.hulkapps_option_value')
							.find('.hulk_opt_prop')
							.val(
								$(this)
									.parents('.hulkapps_option_value')
									.find('li.dropdown_selected')
									.attr('data-value') +
									' | ' +
									$(this).val()
							),
							$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') &&
								$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop')
									.length > 0 &&
								$(this)
									.parents('.hulkapps_option_value')
									.find('li.dropdown_selected')
									.data('hinventory') &&
								$(this)
									.parents('.hulkapps_option_value')
									.find('.hulk_unique_prop')
									.val(
										$(this)
											.parents('.hulkapps_option_value')
											.find('li.dropdown_selected')
											.attr('data-value') +
											'_hin_' +
											$(this)
												.parents('.hulkapps_option_value')
												.find('li.dropdown_selected')
												.data('hinventory') +
											' | ' +
											$(this).val()
									),
							'1' == $('#hulk_amount_dis').val() &&
								calc_options_total(
									parseInt(window.hulkapps.product_id),
									'hulkapps_product_options'
								)
					}
				),
				$(document).on('change', '.hulk_po_dropdown', function () {
					var t = $(this).attr('id'),
						i = $(this).attr('data-parent'),
						e = $(this).attr('data-pid')
					$(this).val()
						? $(this)
								.parent('.hulkapps_option_value')
								.find('.hulk_options_quantity')
								.show()
						: $(this)
								.parent('.hulkapps_option_value')
								.find('.hulk_options_quantity')
								.hide(),
						$(this).parents('.dd_render').find('.hulk_unique_sku').prop('disabled', !0),
						$(this).parents('.dd_render').find('.inventory_error').html('')
					var a = ''
					$(this).parent('.hulkapps_option_value').find('.hulk_options_quantity').val() &&
						(a = ` | ${$(this)
							.parent('.hulkapps_option_value')
							.find('.hulk_options_quantity')
							.val()}`),
						$(this).parent('.hulkapps_option_value').find('.hulk_unique_prop') &&
							$(this).parent('.hulkapps_option_value').find('.hulk_unique_prop')
								.length > 0 &&
							($(this).val() && $(this).children('option:selected').data('hinventory')
								? $(this)
										.parent('.hulkapps_option_value')
										.find('.hulk_unique_prop')
										.val(
											`${$(this).val()}_hin_${$(this)
												.children('option:selected')
												.data('hinventory')}${a}`
										)
								: $(this)
										.parent('.hulkapps_option_value')
										.find('.hulk_unique_prop')
										.val('')),
						$(this).val()
							? $(this)
									.parent('.hulkapps_option_value')
									.find('.hulk_dropdown_hidden_prop')
									.val($(this).val() + a)
							: $(this)
									.parent('.hulkapps_option_value')
									.find('.hulk_dropdown_hidden_prop')
									.val('')
					var o = $(this).find('option:selected').data('conditional-value')
					o &&
						$(this)
							.parents('.dd_render')
							.find(`[data-sku-identifier='${o}']`)
							.removeAttr('disabled'),
						conditional_rules(parseInt(e), i),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(e), i),
						validate_single_option(`option_type_id_${t}`, 'dd_render', i),
						changeImage(this)
				}),
				$(document).on('change', '.hulk_po_dropdown_quantity', function () {
					var t = $(this).attr('data-parent'),
						i = $(this).attr('data-pid')
					$(this)
						.parent('.hulkapps_option_value')
						.find('.hulk_dropdown_hidden_prop')
						.val(
							`${$(this)
								.parent('.hulkapps_option_value')
								.find('.hulkapps_option_child')
								.val()} | ${$(this).val()}`
						),
						$(this).parent('.hulkapps_option_value').find('.hulk_unique_prop') &&
							$(this).parent('.hulkapps_option_value').find('.hulk_unique_prop')
								.length > 0 &&
							($(this)
								.parent('.hulkapps_option_value')
								.find('.hulkapps_option_child')
								.children('option:selected')
								.data('hinventory')
								? $(this)
										.parent('.hulkapps_option_value')
										.find('.hulk_unique_prop')
										.val(
											`${$(this)
												.parent('.hulkapps_option_value')
												.find('.hulkapps_option_child')
												.val()}_hin_${$(this)
												.parent('.hulkapps_option_value')
												.find('.hulkapps_option_child')
												.children('option:selected')
												.data('hinventory')} | ${$(this).val()}`
										)
								: $(this)
										.parent('.hulkapps_option_value')
										.find('.hulk_unique_prop')
										.val('')),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(i), t)
				}),
				$(document).on('change', '.hulk_po_dropdown_multiple', function () {
					var t = $(this).attr('id'),
						i = parseInt($(this).attr('data-min')),
						e = parseInt($(this).attr('data-max')),
						a = '<span class="validation_error error_span" tabindex="0">',
						o = $(this).attr('data-parent'),
						n = $(this).attr('data-pid')
					$(this)
						.parents('.dd_multi_render')
						.find('.hulk_unique_sku')
						.prop('disabled', !0),
						$(this).parents('.dd_multi_render').find('.inventory_error').html(''),
						0 != i &&
						0 != e &&
						checkPlan('validation_for_min_max_option_selection', 'boolean')
							? $(this).find('option:selected').length < i
								? ($(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove(),
								  $(this).after(`${a} Choose from ${i} to ${e} values</span>`),
								  $(this)
										.parents('.hulkapps_option')
										.find('.validation_error')
										.attr('aria-label', `Choose from ${i} to ${e} values`),
								  0 == $(this).find('option:selected').length &&
										$(this)
											.parents('.hulkapps_option')
											.removeClass('validation_error')
											.find('.error_span')
											.remove())
								: $(this).find('option:selected').length > e
								? ($(this).find('option:selected:last').prop('selected', !1),
								  $(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove(),
								  $(this).after(`${a} Choose from ${i} to ${e} values</span>`),
								  $(this)
										.parents('.hulkapps_option')
										.find('.validation_error')
										.attr('aria-label', `Choose from ${i} to ${e} values`),
								  $(this).find('option:selected').length == e &&
										$(this)
											.parents('.hulkapps_option')
											.removeClass('validation_error')
											.find('.error_span')
											.remove())
								: $(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove()
							: checkPlan('validation_for_min_max_option_selection', 'boolean')
							? $(this).find('option:selected').length < i
								? ($(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove(),
								  $(this).after(`${a} Choose at least  ${i} values</span>`),
								  $(this)
										.parents('.hulkapps_option')
										.find('.validation_error')
										.attr('aria-label', `Choose at least  ${i} values`))
								: $(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove()
							: checkPlan('validation_for_min_max_option_selection', 'boolean')
							? e >= $(this).find('option:selected').length
								? e == $(this).find('option:selected').length
									? $(this)
											.parents('.hulkapps_option')
											.removeClass('validation_error')
											.find('.error_span')
											.remove()
									: ($(this)
											.parents('.hulkapps_option')
											.removeClass('validation_error')
											.find('.error_span')
											.remove(),
									  $(this).after(`${a} Choose upto ${e} values</span>`),
									  $(this)
											.parents('.hulkapps_option')
											.find('.validation_error')
											.attr('aria-label', `Choose upto ${e} values`))
								: ($(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove(),
								  $(this).find('option:selected:last').prop('selected', !1))
							: $(this).parents('.hulkapps_option').removeClass('validation_error')
					var l = $.map(
						$(`.${o}`).find(`.hulkapps_option_${t}_visible:not([disabled])  :selected`),
						function (t, i) {
							return $(t).val()
						}
					)
					$(`.${o}`).find(`#hulkapps_option_${t}_hidden`).val(l.join(', '))
					var s = $.map(
						$(`.${o}`).find(`.hulkapps_option_${t}_visible:not([disabled]) :selected`),
						function (t, i) {
							if ('' != $(t).data('hinventory'))
								return $(t).val() + '_hin_' + $(t).data('hinventory')
						}
					)
					$(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').length > 0 &&
						$(this)
							.parent('.hulkapps_option_value')
							.find('.hulk_unique_prop')
							.val(s.join(', ')),
						$(`.${o}`)
							.find(`.hulkapps_option_${t}_visible:not([disabled]) :selected`)
							.each(function (t) {
								var i = $(this).data('conditional-value')
								i &&
									$(this)
										.parents('.dd_multi_render')
										.find(`[data-sku-identifier='${i}']`)
										.removeAttr('disabled')
							}),
						conditional_rules(parseInt(n), o),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(n), o),
						validate_single_option(`option_type_id_${t}`, 'dd_multi_render', o)
				}),
				$(document).on('change', '.hulk_po_radio', function () {
					var t = $(this).attr('data-oid'),
						i = $(this).attr('data-parent'),
						e = $(this).attr('data-pid'),
						a = $(this).attr('data-radio-class'),
						o = $(this).attr('data-single_valid-class'),
						n = $(this).attr('data-val-selected-class'),
						l = $(this).attr('data-hidden-class')
					$(this).parents(`.${o}`).find('.hulk_unique_sku').prop('disabled', !0),
						$(this)
							.parents('.hulkapps_option_value')
							.find('.hulk_options_quantity')
							.show()
					var s = ''
					$(this)
						.parents('.hulkapps_option_value')
						.find('.hulk_options_quantity')
						.val() &&
						(s = ` | ${$(this)
							.parents('.hulkapps_option_value')
							.find('.hulk_options_quantity')
							.val()}`),
						$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') &&
							$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop')
								.length > 0 &&
							($(this).find(`.${a}`).data('hinventory')
								? $(this)
										.parents('.hulkapps_option_value')
										.find('.hulk_unique_prop')
										.val(
											`${$(this).find(`.${a}`).val()}_hin_${$(this)
												.find(`.${a}`)
												.data('hinventory')}${s}`
										)
								: $(this)
										.parents('.hulkapps_option_value')
										.find('.hulk_unique_prop')
										.val('')),
						$(this).find(`.${a}`).prop('checked', !0),
						$(this).parents(`.${o}`).find(`.${n}`).removeClass(n),
						$(this)
							.parents('.hulkapps_option_value')
							.find(`.${l}`)
							.val(`${$(this).find(`.${a}`).val()}${s}`),
						$(this).parents(`.${o}`).find('.inventory_error').html(''),
						$(this).addClass(n),
						$(this).parents('label').find('.hulk_unique_sku').prop('disabled', !1),
						conditional_rules(parseInt(e), i),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(e), i),
						validate_single_option(`option_type_id_${t}`, o, i),
						changeImage(this)
				}),
				$(document).on('change', '.hulk_po_swatch_quantity', function () {
					var t = $(this).attr('data-parent'),
						i = $(this).attr('data-pid')
					$(this)
						.parent('.hulkapps_option_value')
						.find('.hulk_swatch_hidden_prop')
						.val(
							`${$(this)
								.parents('.hulkapps_option_value')
								.find('.swatch_radio:checked')
								.val()} | ${$(this).val()}`
						),
						$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') &&
						$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').length >
							0 &&
						$(this)
							.parent('.hulkapps_option_value')
							.find('.swatch_radio:checked')
							.data('hinventory')
							? $(this)
									.parents('.hulkapps_option_value')
									.find('.hulk_unique_prop')
									.val(
										`${$(this)
											.parent('.hulkapps_option_value')
											.find('.swatch_radio:checked')
											.val()}_hin_${$(this)
											.parent('.hulkapps_option_value')
											.find('.swatch_radio:checked')
											.data('hinventory')} | ${$(this).val()}`
									)
							: $(this)
									.parents('.hulkapps_option_value')
									.find('.hulk_unique_prop')
									.val(''),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(i), t)
				}),
				$(document).on('change', '.hulk_po_button_quantity', function () {
					var t = $(this).attr('data-parent'),
						i = $(this).attr('data-pid')
					$(this)
						.parents('.hulkapps_option_value')
						.find('.hulk_button_hidden_prop')
						.val(
							`${$(this)
								.parents('.hulkapps_option_value')
								.find('.button_selected')
								.find('.button_radio')
								.val()} | ${$(this).val()}`
						),
						$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') &&
							$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop')
								.length > 0 &&
							$(this)
								.parent('.hulkapps_option_value')
								.find('.button_selected')
								.find('.button_radio')
								.data('hinventory') &&
							$(this)
								.parents('.hulkapps_option_value')
								.find('.hulk_unique_prop')
								.val(
									`${$(this)
										.parents('.hulkapps_option_value')
										.find('.button_selected')
										.find('.button_radio')
										.val()}_hin_${$(this)
										.parent('.hulkapps_option_value')
										.find('.button_selected')
										.find('.button_radio')
										.data('hinventory')} | ${$(this).val()}`
								),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(i), t)
				}),
				(window.keybordAccess = function () {
					let t = document.querySelectorAll(
						'.hulkapps_buton_option,.hulkapps_check_option,.hulkapps_radio_option,.hulkapps_swatch_option,.hulkapps_mswatch_option,ul.hulkapps_product_options_ul .init,ul.hulkapps_product_options_ul li:not(.init),.hulk_po_other_options,.font-select span,.fs-results li,.hulk_file_upload,.popup_open_link,.file-upload,.popup_close_link'
					)
					t.forEach((t) => {
						t.addEventListener('keydown', (i) => {
							;('Enter' === i.key || ' ' === i.key) &&
								(t.classList.contains('file-upload')
									? t.querySelector('.hulk_file_upload').click()
									: t.click())
						})
					})
					var i = document.getElementsByClassName('hulkapps_option_value'),
						e = 0,
						a = 0
					document.addEventListener('keydown', function (t) {
						var o = t.keyCode
						if (37 === o || 38 === o) a = a > 0 ? a - 1 : 0
						else {
							if (39 !== o && 40 !== o) return
							var n = document.activeElement.closest('.hulkapps_option_value')
							n || (n = i[e])
							var l = n.querySelectorAll('label, li').length - 1
							a === l
								? n &&
								  (Array.prototype.indexOf.call(i, n) === e ||
										(e = e < i.length - 1 ? e + 1 : 0),
								  (a = 0))
								: (a = a < l ? a + 1 : l)
						}
						var s = document.activeElement.closest('.hulkapps_option_value')
						s && (e = Array.prototype.indexOf.call(i, s))
						var p = i[e].querySelectorAll('label, li')[a]
						void 0 != p && (p.focus(), t.preventDefault())
					})
				}),
				$(document).on('click', '.hulk_po_checkbox', function () {
					var t = $(this).attr('data-oid'),
						i = $(this).attr('data-single_valid-class'),
						e = parseInt($(this).attr('data-min')),
						a = parseInt($(this).attr('data-max')),
						o = '<span class="validation_error error_span" tabindex="0" >',
						n = $(this).attr('data-parent'),
						l = $(this).attr('data-pid')
					$(this).parents(`.${i}`).find('.hulk_unique_sku').prop('disabled', !0),
						'multiswatch_render' == i
							? $(this).addClass('swatch_selected')
							: $(this).parents('.cb_render').find('.inventory_error').html(''),
						0 != e &&
						0 != a &&
						checkPlan('validation_for_min_max_option_selection', 'boolean')
							? $(`.hulkapps_option_${t}_visible:checkbox:checked`).length < e
								? ($(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove(),
								  $(this)
										.parents('.hulkapps_option')
										.append(`${o} Choose from ${e} to ${a} values</span>`),
								  $(this)
										.parents('.hulkapps_option')
										.find('.validation_error')
										.attr('aria-label', `Choose from ${e} to ${a} values`),
								  0 == $(`.hulkapps_option_${t}_visible:checkbox:checked`).length &&
										$(this)
											.parents('.hulkapps_option')
											.removeClass('validation_error')
											.find('.error_span')
											.remove())
								: $(`.${n}`).find(`.hulkapps_option_${t}_visible:checkbox:checked`)
										.length > a
								? ($(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove(),
								  $(this)
										.parents('.hulkapps_option')
										.append(`${o} Choose from ${e} to ${a} values</span>`),
								  $(this)
										.parents('.hulkapps_option')
										.find('.validation_error')
										.attr('aria-label', `Choose from ${e} to ${a} values`),
								  $(`.${n}`).find(`.hulkapps_option_${t}_visible:checkbox:checked`)
										.length != a &&
										$(this)
											.parents('.hulkapps_option')
											.removeClass('validation_error')
											.find('.error_span')
											.remove(),
								  'multiswatch_render' == i
										? $(this).find(':checkbox').prop('checked', !1)
										: (this.checked = !1))
								: $(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove()
							: 0 != e &&
							  checkPlan('validation_for_min_max_option_selection', 'boolean')
							? $(`.${n}`).find(`.hulkapps_option_${t}_visible:checkbox:checked`)
									.length < e
								? ($(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove(),
								  $(this)
										.parents('.hulkapps_option')
										.append(`${o} Choose at least  ${e} values</span>`),
								  $(this)
										.parents('.hulkapps_option')
										.find('.validation_error')
										.attr('aria-label', `Choose at least  ${e} values`))
								: $(this)
										.parents('.hulkapps_option')
										.removeClass('validation_error')
										.find('.error_span')
										.remove()
							: 0 != a &&
							  checkPlan('validation_for_min_max_option_selection', 'boolean') &&
							  (a >=
							  $(`.${n}`).find(`.hulkapps_option_${t}_visible:checkbox:checked`)
									.length
									? a ==
									  $(`.${n}`).find(
											`.hulkapps_option_${t}_visible:checkbox:checked`
									  ).length
										? $(this)
												.parents('.hulkapps_option')
												.removeClass('validation_error')
												.find('.error_span')
												.remove()
										: ($(this)
												.parents('.hulkapps_option')
												.removeClass('validation_error')
												.find('.error_span')
												.remove(),
										  $(this)
												.parents('.hulkapps_option')
												.append(`${o} Choose upto ${a} values</span>`),
										  $(this)
												.parents('.hulkapps_option')
												.find('.validation_error')
												.attr('aria-label', `Choose upto ${a} values`))
									: ($(this)
											.parents('.hulkapps_option')
											.removeClass('validation_error')
											.find('.error_span')
											.remove(),
									  'multiswatch_render' == i
											? $(this).find(':checkbox').prop('checked', !1)
											: (this.checked = !1))),
						conditional_rules(parseInt(l), n)
					var s = $.map(
						$(`.${n}`).find(`.hulkapps_option_${t}_visible:not([disabled]):checked`),
						function (t, i) {
							return $(t).val()
						}
					)
					$(`.${n}`)
						.find(`.hulkapps_option_${t}_visible:not([disabled]):checked`)
						.each(function (t) {
							$(this).parents('label').find('.hulk_unique_sku').removeAttr('disabled')
						}),
						$(`.${n}`).find(`#hulkapps_option_${t}_hidden`).val(s.join(',  '))
					var p = $.map(
						$(`.${n}`).find(`.hulkapps_option_${t}_visible:not([disabled]):checked`),
						function (t, i) {
							if ('' != $(t).data('hinventory'))
								return $(t).val() + '_hin_' + $(t).data('hinventory')
						}
					)
					$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').length >
						0 &&
						($(this)
							.parents('.hulkapps_option_value')
							.find('.hulk_unique_prop')
							.val(p.join(', ')),
						'multiswatch_render' == i &&
							$(this)
								.parents('.hulkapps_option_value')
								.find('.swatch_checkbox:disabled')
								.parent('.hulkapps_option_child')
								.removeClass('swatch_selected')),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(l), n),
						validate_single_option(`option_type_id_${t}`, i, n)
				}),
				$(document).on('change', '.hulk_po_swatch_multiple_checkbox', function (t) {
					$(this).is(':checked')
						? $(this).parent().addClass('swatch_selected')
						: $(this).parent().removeClass('swatch_selected'),
						$(this).parents('.multiswatch_render').find('.inventory_error').html('')
				}),
				$(document).on('change', '.hulk_po_radiobutton', function () {
					var t = $(this).attr('data-oid'),
						i = $(this).attr('data-parent'),
						e = $(this).attr('data-pid')
					$(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').show(),
						$(this).parents('.rb_render').find('.hulk_unique_sku').prop('disabled', !0)
					var a = ''
					$(this)
						.parents('.hulkapps_option_value')
						.find('.hulk_options_quantity')
						.val() &&
						(a = ` | ${$(this)
							.parents('.hulkapps_option_value')
							.find('.hulk_options_quantity')
							.val()}`),
						$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') &&
							$(this).parents('.hulkapps_option_value').find('.hulk_unique_prop')
								.length > 0 &&
							($(this).data('hinventory')
								? $(this)
										.parents('.hulkapps_option_value')
										.find('.hulk_unique_prop')
										.val(
											`${$(this).val()}_hin_${$(this).data('hinventory')}${a}`
										)
								: $(this)
										.parents('.hulkapps_option_value')
										.find('.hulk_unique_prop')
										.val('')),
						$(this)
							.parents('.hulkapps_option_value')
							.find('.hulk_radiobutton_hidden_prop')
							.val($(this).val() + a),
						$(this)
							.parent()
							.siblings()
							.find('.radio_div')
							.removeClass('radio_selected'),
						$(this).parent().find('.radio_div').addClass('radio_selected'),
						$(this).parent().find('.radio_div').addClass('radio_selected'),
						$(this).parents('label').find('.hulk_unique_sku').prop('disabled', !1),
						conditional_rules(parseInt(e), i),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(e), i),
						validate_single_option(`option_type_id_${t}`, 'rb_render', i),
						changeImage(this)
				}),
				$(document).on('change', '.hulk_po_radiobutton_quanity', function () {
					var t = $(this).attr('data-parent'),
						i = $(this).attr('data-pid')
					$(this)
						.parent('.hulkapps_option_value')
						.find('.hulk_radiobutton_hidden_prop')
						.val(
							`${$(this)
								.parent('.hulkapps_option_value')
								.find('.radio_selected')
								.parent('.hulkapps_radio_option')
								.find('.hulkapps_option_child')
								.val()} | ${$(this).val()}`
						),
						$(this).parent('.hulkapps_option_value').find('.hulk_unique_prop') &&
							$(this).parent('.hulkapps_option_value').find('.hulk_unique_prop')
								.length > 0 &&
							$(this)
								.parent('.hulkapps_option_value')
								.find('.radio_selected')
								.parent('.hulkapps_radio_option')
								.find('.hulkapps_option_child')
								.data('hinventory') &&
							$(this)
								.parent('.hulkapps_option_value')
								.find('.hulk_unique_prop')
								.val(
									`${$(this)
										.parent('.hulkapps_option_value')
										.find('.radio_selected')
										.parent('.hulkapps_radio_option')
										.find('.hulkapps_option_child')
										.val()}_hin_${$(this)
										.parent('.hulkapps_option_value')
										.find('.radio_selected')
										.parent('.hulkapps_radio_option')
										.find('.hulkapps_option_child')
										.data('hinventory')} | ${$(this).val()}`
								),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(i), t)
				}),
				$(document).on('change input', '.hulk_po_other_options', function () {
					var t = $(this).attr('id'),
						i = $(this).attr('data-parent'),
						e = $(this).attr('data-pid'),
						a = $(this).attr('data-single_valid-class'),
						o = $(this).attr('data-val-selected-class'),
						n = $(this).data('price'),
						l = $(this).val()
					if ('' != l) {
						if ('0.00' != n) var s = `${l} [ ${window.hulk_po_currency_symbol}${n} ]`
						else var s = l
						$(this).parent().find('.other_options_prop_val').val(s), $(this).addClass(o)
					} else $(this).parent().find('.other_options_prop_val').val(''), $(this).removeClass(o)
					conditional_rules(parseInt(e), i),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(e), i),
						validate_single_option(`option_type_id_${t}`, a, i)
				}),
				$(document).on('change', '.po_changed_formula', function () {
					var po_final_price = '',
						final_prop = '',
						hulk_parent_div = $(this).parents('.fm_option_val').attr('data-parent'),
						hulk_pid = $(this).parents('.fm_option_val').attr('data-pid'),
						min_selection = 0,
						max_selection = 0,
						opt_name = $(this).attr('data-name')
					$(this).attr('min') && (min_selection = parseInt($(this).attr('min'))),
						$(this).attr('max') && (max_selection = parseInt($(this).attr('max')))
					var is_validated = !0
					$(this).parent('.hulkapps_option_value').find('.error_span').remove(),
						0 != min_selection && 0 != max_selection
							? parseFloat($(this).val()) < min_selection ||
							  parseFloat($(this).val()) > max_selection
								? ($(this)
										.parent('.hulkapps_option_value')
										.append(
											`<span class='validation_error error_span' tabindex='0' aria-label='Choose values from ${min_selection} - ${max_selection} for option ${opt_name}'>  Choose values from ${min_selection} - ${max_selection}. </span>`
										),
								  (is_validated = !1))
								: ($(this)
										.parent('.hulkapps_option_value')
										.find('.error_span')
										.remove(),
								  (is_validated = !0))
							: 0 != min_selection
							? parseFloat($(this).val()) < min_selection
								? ($(this)
										.parent('.hulkapps_option_value')
										.append(
											`<span class='validation_error error_span' tabindex='0' aria-label=' Choose values higher than  ${min_selection} for option ${opt_name}'>  Choose values higher than  ${min_selection}. </span>`
										),
								  (is_validated = !1))
								: ($(this)
										.parent('.hulkapps_option_value')
										.find('.error_span')
										.remove(),
								  (is_validated = !0))
							: 0 != max_selection &&
							  (parseFloat($(this).val()) > max_selection
									? ($(this)
											.parent('.hulkapps_option_value')
											.append(
												`<span class='validation_error error_span' tabindex='0' aria-label='Choose values up to ${max_selection} for option ${opt_name}'> Choose values up to ${max_selection}. </span>`
											),
									  (is_validated = !1))
									: ($(this)
											.parent('.hulkapps_option_value')
											.find('.error_span')
											.remove(),
									  (is_validated = !0)))
					var error_span_length = $(this)
						.parents('.fm_option_val')
						.find('.error_span').length
					is_validated && 0 == error_span_length
						? ($(this)
								.parents('.fm_option_val')
								.find('.po_changed_formula')
								.each(function () {
									;(po_final_price +=
										parseFloat($(this).val()) +
										$(this).attr('data-arithmatic')),
										(final_prop += `${$(this).attr('data-name')}:${$(
											this
										).val()} | `)
								}),
						  (po_final_price = po_final_price.slice(0, -1)),
						  (final_prop = final_prop.slice(0, -1)),
						  (po_final_price = eval(po_final_price).toFixed(2)),
						  $(this).parents('.fm_option_val').removeClass('validation_error'),
						  $(this).parents('.fm_render').find('.error_span').remove(),
						  isNaN(po_final_price)
								? (0 >= parseFloat($(this).val()) && $(this).val(''),
								  $(this)
										.parents('.fm_option_val')
										.find('.hulk_formula_hidden_prop')
										.removeClass('formula_selected'),
								  $(this)
										.parents('.fm_option_val')
										.find('.hulk_formula_hidden_prop')
										.val(''),
								  $(this)
										.parents('.fm_option_val')
										.find('.hulk_formula_hidden_prop')
										.attr('data-price', ''),
								  calc_options_total(parseInt(hulk_pid), hulk_parent_div))
								: po_final_price <= 0 ||
								  'Infinity' == po_final_price ||
								  0 >= parseFloat($(this).val())
								? (0 >= parseFloat($(this).val()) && $(this).val(''),
								  $(this).parents('.fm_option_val').addClass('validation_error'),
								  $(this)
										.parents('.fm_render')
										.append(
											"<span class='validation_error error_span' tabindex='0' aria-label='Please change your value(s)'> Please change your value(s). </span>"
										),
								  $(this)
										.parents('.fm_option_val')
										.find('.hulk_formula_hidden_prop')
										.removeClass('formula_selected'),
								  $(this)
										.parents('.fm_option_val')
										.find('.hulk_formula_hidden_prop')
										.val(''),
								  $(this)
										.parents('.fm_option_val')
										.find('.hulk_formula_hidden_prop')
										.attr('data-price', ''),
								  calc_options_total(parseInt(hulk_pid), hulk_parent_div))
								: ($(this)
										.parents('.fm_option_val')
										.find('.hulk_formula_hidden_prop')
										.val(`${final_prop}[${po_final_price}]`),
								  $(this)
										.parents('.fm_option_val')
										.find('.hulk_formula_hidden_prop')
										.attr('data-price', po_final_price),
								  $(this)
										.parents('.fm_option_val')
										.find('.hulk_formula_hidden_prop')
										.addClass('formula_selected'),
								  calc_options_total(parseInt(hulk_pid), hulk_parent_div)))
						: (0 >= parseFloat($(this).val()) && $(this).val(''),
						  $(this)
								.parents('.fm_option_val')
								.find('.hulk_formula_hidden_prop')
								.removeClass('formula_selected'),
						  $(this)
								.parents('.fm_option_val')
								.find('.hulk_formula_hidden_prop')
								.val(''),
						  $(this)
								.parents('.fm_option_val')
								.find('.hulk_formula_hidden_prop')
								.attr('data-price', ''),
						  calc_options_total(parseInt(hulk_pid), hulk_parent_div))
				}),
				$(document).on('change', '.stg_render input[type="text"]', function () {
					opt_val = $(this)
						.parents('.stg_render')
						.find("input[type='text']")
						.map(function () {
							if ('' != $(this).val())
								return $(this).attr('data-key-name') + ' : ' + $(this).val()
						})
						.get()
						.join(' | ')
					var t = $(this).parents('.stg_render').find('.stg_hidden').attr('data-pid'),
						i = $(this).parents('.stg_render').find('.stg_hidden').attr('data-oid'),
						e = $(this).attr('data-parent'),
						a = $(this).attr('data-single_valid-class'),
						o = $(this).attr('data-val-selected-class')
					if ('' != opt_val) {
						if (
							((opt_price = $(this)
								.parents('.stg_render')
								.find('.stg_hidden')
								.data('price')),
							(opt_currency = window.hulk_po_currency_symbol),
							'0:00' != opt_price)
						) {
							var n = opt_val + ' [ ' + opt_currency + ' ' + opt_price + ' ]'
							$(this).parents('.stg_render').find('.stg_property_val').val(n),
								$(this).parents('.stg_render').find('.stg_hidden').addClass(o)
						} else {
							var n = opt_val
							$(this).parents('.stg_render').find('.stg_property_val').val(n),
								$(this).parents('.stg_render').find('.stg_hidden').addClass(o)
						}
					} else $(this).parents('.stg_render').find('.stg_property_val').val(''), $(this).parents('.stg_render').find('.stg_hidden').removeClass(o)
					conditional_rules(parseInt(t), e),
						'1' == $('#hulk_amount_dis').val() && calc_options_total(parseInt(t), e),
						validate_single_option(`option_type_id_${i}`, a, e)
				}),
				$(document).on('keyup', '.hulkapps_discount_code', function (t) {
					'' != $.trim($(this).val())
						? ($('.hulkapps_product_discount_button').removeAttr('disabled'),
						  $('.hulkapps_product_discount_button').removeClass(
								'hulkapps_product_discount_disabled_button'
						  ))
						: ($('.hulkapps_product_discount_button').attr('disabled', 'disabled'),
						  $('.hulkapps_product_discount_button').addClass(
								'hulkapps_product_discount_disabled_button'
						  ))
				}),
				$(document).on('click', '.hulkapps_product_discount_button', function (t) {
					$('.hulkapps_product_discount_button').attr('disabled', 'disabled'),
						$('.hulkapps_product_discount_button').addClass(
							'hulkapps_product_discount_disabled_button'
						),
						new Promise((t, i) => {
							var e = validate_options(
								window.hulkapps.product_id,
								'hulkapps_product_options'
							)
							t(e)
						})
							.then(function (t) {
								if (t) {
									var i = Shopify.locale,
										e = {}
									;(e[window.hulkapps.product.selected_variant] =
										window.hulkapps.product_collection),
										$.ajax({
											type: 'POST',
											url: window.hulkapps.po_url + '/store/get_cart_details',
											data: {
												cart_data: window.hulk_cjson,
												store_id: window.hulkapps.store_id,
												cart_collections: JSON.stringify(e),
												customer_tags:
													null != window.hulkapps.customer
														? window.hulkapps.customer.tags.split(',')
														: '',
												draft_order_language: void 0 != i ? i : '',
												discount_code: $(
													'input[name=checkout_discount]'
												).val(),
											},
											crossDomain: !0,
											success: function (t) {
												var i = t.discounts,
													e = parseFloat(i.discount_cut_price)
												i.discount_code && 1 == i.discount_error
													? (hulkapps_jQuery(
															'.hulkapps_summary_product'
													  ).remove(),
													  $(
															'.discount_code_box_product .hulkapps_discount_hide'
													  ).after(
															"<span class='hulkapps_summary_product'>Discount code does not match</span>"
													  ),
													  $(
															'.hulkapps-summary-product-line-discount-code'
													  ).html(''),
													  $('.product_after_discount_price').html(''))
													: i.is_free_shipping
													? ($('.hulkapps_summary_product').remove(),
													  $(
															'.hulkapps-summary-product-line-discount-code'
													  ).html(''),
													  $('.product_after_discount_price').html(''),
													  $(
															'.discount_code_box_product .hulkapps_discount_hide'
													  ).after(
															"<span class='hulkapps-summary-product-line-discount-code'><span class='discount-tag'>" +
																i.discount_code +
																"<span class='product-close-tag close-tag'></span></span>Free Shipping"
													  ))
													: i.discount_code && e <= 0
													? ($(
															'.discount_code_box_product .hulkapps_discount_hide'
													  ).after(
															"<span class='hulkapps_summary_product'>" +
																i.discount_code +
																' discount code isnâ€™t valid for the items in your cart</span>'
													  ),
													  $('.hulkapps_discount_code').val(''),
													  $(
															'.hulkapps-summary-product-line-discount-code'
													  ).html(''),
													  $('.product_after_discount_price').html(''))
													: i.discount_code
													? ($('.discount_code_box_product')
															.find('.hulkapps_summary_product')
															.html(''),
													  $(
															'.hulkapps-summary-product-line-discount-code,.product_after_discount_price'
													  ).remove(),
													  $(
															'.discount_code_box_product .hulkapps_discount_hide'
													  ).after(
															"<span class='hulkapps-summary-product-line-discount-code'><span class='discount-tag'>" +
																i.discount_code +
																"<span class='product-close-tag close-tag'></span></span><span class='hulkapps_with_discount'> -" +
																i.with_discount +
																"</span></span><span class='product_after_discount_price'><span class='final-total'>Total</span>" +
																i.final_with_discounted_price +
																'</span>'
													  ),
													  $('.hulkapps-cart-total').remove())
													: ($(
															'.hulkapps-summary-product-line-discount-code'
													  ).html(''),
													  $('.product_after_discount_price').html(''),
													  $('.discount_code_box_product')
															.find('.hulkapps_summary_product')
															.html('')),
													$(
														'.hulkapps_product_discount_button'
													).removeAttr('disabled'),
													$(
														'.hulkapps_product_discount_button'
													).removeClass(
														'hulkapps_product_discount_disabled_button'
													)
											},
										})
								}
							})
							.catch(function (t) {})
				}),
				$(document).on(
					'click',
					'.hulkapps_product_discount_modal .modal_close_btn',
					function (t) {
						$('.hulkapps_product_discount_modal').hide()
					}
				)
			var hulk_flag = 0
			$(document).on('click', '.hulk-buy_now,#hulkapps_buy_now_continue', function (t) {
				var i = $(this),
					e = $(this).attr('data-hulk-btn-type')
				;(t.cancelBubble = !0),
					t.stopPropagation(),
					t.preventDefault(),
					t.stopImmediatePropagation(),
					new Promise((t, i) => {
						var e = validate_options(
							window.hulkapps.product_id,
							'hulkapps_product_options'
						)
						t(e)
					})
						.then(function (t) {
							if (t) {
								if (
									window.is_product_page_doscount_code &&
									'hulkapps_buy_now_continue' != e &&
									$('.product-hulkapps-discount-code-html').length > 0
								) {
									var a,
										o = ''
									;(o = $('.shopify-payment-button')
										.html()
										.includes('ShopifyPay-button')
										? 'ShopifyPay-button'
										: 'Checkout-button'),
										$('.product-hulkapps-discount-code-html').html(
											'<div class="hulkapps_product_discount_modal"><div class="product_discount_modal_wrapper"><span class="modal_close_btn"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2361_7248)"><path d="M1.23998 24.0001C0.923838 24.0001 0.607699 23.8798 0.367506 23.6378C-0.114689 23.1556 -0.114689 22.3739 0.367506 21.8917L21.8975 0.361646C22.3797 -0.120549 23.1615 -0.120549 23.6437 0.361646C24.1259 0.843841 24.1259 1.6256 23.6437 2.1081L2.11396 23.6378C1.87195 23.8783 1.55582 24.0001 1.23998 24.0001Z" fill="#AAAAAA"/><path d="M22.7715 24.0001C22.4554 24.0001 22.1395 23.8798 21.899 23.6378L0.367506 2.1081C-0.114689 1.6256 -0.114689 0.843841 0.367506 0.361646C0.849701 -0.120549 1.63146 -0.120549 2.11396 0.361646L23.6437 21.8917C24.1259 22.3739 24.1259 23.1556 23.6437 23.6378C23.4017 23.8783 23.0858 24.0001 22.7715 24.0001Z" fill="#AAAAAA"/></g><defs><clipPath id="clip0_2361_7248"><rect width="24" height="24" fill="white"/></clipPath></defs></svg></span><div class="product_discount_modal_body"><div id="hulkapps_discount_code"><div class="discount_code_box_product"><div class="hulkapps_discount_hide"><input placeholder="Discount code" class="hulkapps_discount_code" autocomplete="off" aria-required="true" size="30" type="text" name="checkout_discount"><button type="button" class="btn btn--primary btn-primary button hulkapps_product_discount_button hulkapps_product_discount_disabled_button" disabled >Apply</button></div></div></div><p class="hulkapps_discount_notetxt"><b>Note:</b> Proceed with Checkout button if no discount code available.</p></div><div class="product_discount_modal_footer"><button id="" class="btn btn-secondary button button--secondary modal_close_btn" type="button"  >Cancel</button><button id="hulkapps_buy_now_continue" class="btn btn--secondary btn-primary button button--primary" type="button" data-testid="' +
												o +
												'" data-hulk-btn-type="hulkapps_buy_now_continue">Checkout</button></div></div></div>'
										)
								}
								var n = 'hulkapps_product_options',
									l = 0
								window.hulkapps.money_format
								var s = $(
									'.' +
										n +
										' #hulkapps_option_list_' +
										window.hulkapps.product_id +
										':visible .price-change:checked, .' +
										n +
										' #hulkapps_option_list_' +
										window.hulkapps.product_id +
										':visible .price-change:selected, .' +
										n +
										' .hulkapps_swatch_option .swatch_selected,.' +
										n +
										' .textarea_selected,.' +
										n +
										' .textbox_selected,.' +
										n +
										' .emailbox_selected,.' +
										n +
										' .datepicker_selected,.' +
										n +
										' .numberfield_selected,.' +
										n +
										' .colorpicker_selected,.' +
										n +
										' .button_selected,.' +
										n +
										' .googlefont_selected, .' +
										n +
										' .ci_render .hulkapps_option_value .hulkapps_option_child .dropdown_selected'
								)
								for (a = 0; a < s.length; a++)
									$(s[a]).parents('.hulkapps_option').hasClass('conditional') ||
										(l = Number($(s[a]).attr('data-price')) + Number(l))
								if (
									0 == hulk_flag &&
									('Checkout-button' == i.attr('data-testid') ||
										'ShopifyPay-button' == i.attr('data-testid'))
								) {
									$('.shopify-payment-button').css({ 'pointer-events': 'none' })
									var p = {},
										r = i.attr('data-testid')
									$("[name^='properties']").each(function () {
										var t
										'' == $(this).val() && $(this).remove(),
											'radio' == this.type
												? this.checked &&
												  ((t = this.name
														.replace('properties[', '')
														.replace(']', '')),
												  $.trim(this.value).length > 0 &&
														(p[t] = this.value))
												: (this.type,
												  (t = this.name
														.replace('properties[', '')
														.replace(']', '')),
												  $.trim(this.value).length > 0 &&
														(p[t] = this.value))
									})
									var d = Shopify.locale,
										u = {}
									;(u[window.hulkapps.product.selected_variant] =
										window.hulkapps.product_collection),
										(window.hulk_cjson = {})
									let h = []
									var c = window.hulkapps.product.price
									window.hulkapps.product.selected_variant_price &&
										(c = window.hulkapps.product.selected_variant_price),
										h.push({
											product_id: window.hulkapps.product.id,
											price: c,
											line_price:
												c * parseInt($('input[name=quantity]').val()),
											tags: window.hulkapps.product.tags,
											variant_id: window.hulkapps.product.selected_variant,
											quantity: parseInt($('input[name=quantity]').val()),
											vendor: window.hulkapps.product.vendor,
											product_type: window.hulkapps.product.product_type,
											properties: p,
											title: window.hulkapps.product.title,
										}),
										(hulk_cjson.cart = {
											items: h,
											original_total_price:
												window.hulkapps.product.price *
												parseInt($('input[name=quantity]').val()),
											item_count: parseInt($('input[name=quantity]').val()),
										}),
										(hulk_cjson.money_format = window.hulkapps.money_format),
										(!window.is_product_page_doscount_code ||
											(window.is_product_page_doscount_code &&
												'hulkapps_buy_now_continue' == e)) &&
											$.ajax({
												type: 'POST',
												url:
													window.hulkapps.po_url +
													'/store/create_draft_order',
												data: {
													cart_json: hulk_cjson,
													store_id: window.hulkapps.store_id,
													cart_collections: JSON.stringify(u),
													customer_tags:
														null != window.hulkapps.customer
															? window.hulkapps.customer.tags.split(
																	','
															  )
															: '',
													draft_order_language: void 0 != d ? d : '',
													discount_code: $(
														'.discount_code_box_product .hulkapps_discount_code'
													).val(),
													hulk_btn_type: r,
												},
												crossDomain: !0,
												success: function (t) {
													'string' == typeof t
														? (window.location.href = t)
														: 'ShopifyPay-button' == r
														? (window.location.href =
																'/checkout?payment=shop_pay')
														: (window.location.href = '/checkout'),
														localStorage.removeItem('discount_code')
												},
											})
								}
							}
						})
						.catch(function (t) {})
			})
			var hulk_flag = 0
			$(document).on('click', '.hulkapps_submit_cart', function (t) {
				0 == hulk_flag &&
					(t.preventDefault(),
					new Promise((t, i) => {
						var e = validate_options(
							window.hulkapps.product_id,
							'hulkapps_product_options'
						)
						t(e)
					})
						.then(function (t) {
							t &&
								($("[name^='properties']").each(function () {
									;('' == $(this).val() ||
										($(this).hasClass('hf_property_val') &&
											$(this).hasClass('conditional'))) &&
										$(this).attr('disabled', !0)
								}),
								(hulk_flag = 1),
								$('.hulkapps_submit_cart').click(),
								1 == hulk_flag &&
									($("[name^='properties']").each(function () {
										;('' == $(this).val() ||
											($(this).hasClass('hf_property_val') &&
												$(this).hasClass('conditional'))) &&
											$(this).attr('disabled', !1)
									}),
									(hulk_flag = 0)))
						})
						.catch(function (t) {
							;(hulk_flag = 1),
								$('.hulkapps_submit_cart').click(),
								1 == hulk_flag &&
									($("[name^='properties']").each(function () {
										;('' == $(this).val() ||
											($(this).hasClass('hf_property_val') &&
												$(this).hasClass('conditional'))) &&
											$(this).attr('disabled', !1)
									}),
									(hulk_flag = 0))
						}))
			})
		}),
		void 0 !== window.hulkapps &&
			('undefined' == typeof jQuery ||
			(3 == parseInt(jQuery.fn.jquery) &&
				2.1 > parseFloat(jQuery.fn.jquery.replace(/^1\./, '')))
				? hulkLoadScript(
						'//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js',
						function () {
							checkAppInstalled((hulkapps_jQuery = jQuery.noConflict(!0)))
						}
				  )
				: checkAppInstalled((hulkapps_jQuery = jQuery)))
}

if (!window.is_hulk_load_js) {
	window.is_hulk_load_js = !0
	window.loadHulkManualOverride()
}
